import { Injectable } from "@angular/core";
import * as XLSX from "xlsx";

import { saveAs } from "file-saver";
import { NGXLogger } from "ngx-logger";
import { Stats } from "../models/stats.model";
import { PraticaScuola_Firestore } from "../models/praticaScuolaFirestore.model";
import { Centrale } from "../models/centrale.models";
import {
  DatiAppuntamentiPerImpresa,
  DatiDocFase1PerImpresa,
  DatiDocFase2PerImpresa,
  DatiDocFase3PerImpresa,
  DatiSopralluogoPerImpresa,
  PraticaFlowdy2_Firestore,
} from "../models/praticaFirestore.model";
import { MandatoDiPagamento } from "../models/mandatoDiPagamento.model";
import { OdaAtFirestore } from "../models/odaAtFirestore.model";
import { UtilService } from "./util.service";
import { StoricoPratica } from "../models/pratica.storico.model";
import { Oda } from "../models/oda.model";
import { StoricoProntofibra } from "../models/prontofibra.storico.model";
import { Prontofibra_Firestore } from "../models/prontofibra.firestore.model";
import { NotaPratica } from "../models/pratica.nota.model";

@Injectable({
  providedIn: "root",
})
export class ExcelService {
  constructor(
    private utilService: UtilService,
    private logger: NGXLogger,
  ) {}

  exportPFToExcel(
    prontofibra: Prontofibra_Firestore[],
    filename: string,
    isDownload: boolean,
  ): Blob {
    const customHeaders = [
      "CUI",
      "ID",
      "LOTTO",
      "REGIONE",
      "PROVINCIA",
      "COMUNE",
      "INDIRIZZO",
      "DENOMINAZIONE",
      "TIPOLOGIA",
      "BANDO",
      "STATO",
      "CATEGORIA ATTESA",
    ];

    const customData = prontofibra.map((prontofibra) => ({
      CUI: prontofibra.cui,
      ID: prontofibra.id,
      LOTTO: prontofibra.lotto,
      REGIONE: prontofibra.regione,
      PROVINCIA: prontofibra.provincia,
      COMUNE: prontofibra.comune,
      INDIRIZZO: prontofibra.indirizzo,
      DENOMINAZIONE: prontofibra.denominazione,
      TIPOLOGIA: prontofibra.tipoSedeEffettiva,
      BANDO: prontofibra.bando,
      STATO: prontofibra.codiceStatoProntofibra,
      "CATEGORIA VINCOLO": prontofibra.categoriaKO,
    }));

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(customData, {
      header: [],
    });
    worksheet["A1"] = { v: customHeaders[0] };
    worksheet["B1"] = { v: customHeaders[1] };
    worksheet["C1"] = { v: customHeaders[2] };
    worksheet["D1"] = { v: customHeaders[3] };
    worksheet["E1"] = { v: customHeaders[4] };

    const workbook: XLSX.WorkBook = {
      Sheets: { data: worksheet },
      SheetNames: ["data"],
    };

    const excelBuffer: any = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    if (isDownload) {
      // Salva il file Excel
      saveAs(blob, filename);
      return null;
    } else {
      return blob;
    }
  }

  exportBEFToExcel(oda: OdaAtFirestore[], filename: string): void {
    const customHeaders = [
      "ODA",
      "IMPRESA",
      "BANDO",
      "VALORE FASE 1",
      "VALORE FASE 2",
      "VALORE FASE 3",
      "VALORE KO",
      "DOVUTO",
      "EMESSO",
      "RESIDUO",
    ];
    let totaleFase1: number = 0;
    let totaleFase2: number = 0;
    let totaleFase3: number = 0;
    let totaleKO: number = 0;
    let totaleDovuto: number = 0;
    oda.map((oda) => {
      totaleFase1 += Number(oda.importoDovutoFase1);
      totaleFase2 += Number(oda.importoDovutoFase2);
      totaleFase3 += Number(oda.importoDovutoFase3);
      totaleKO += Number(oda.importoDovutoKO);
      totaleDovuto +=
        Number(oda.importoDovutoFase1) +
        Number(oda.importoDovutoFase2) +
        Number(oda.importoDovutoFase3) +
        Number(oda.importoDovutoKO);
    });
    const customData = oda.map((oda) => ({
      ODA: oda.numero,
      IMPRESA: oda.azienda,
      BANDO: oda.bando,
      "VALORE FASE 1": oda.importoDovutoFase1 ? oda.importoDovutoFase1 : "0",
      "VALORE FASE 2": oda.importoDovutoFase2 ? oda.importoDovutoFase2 : "0",
      "VALORE FASE 3": oda.importoDovutoFase3 ? oda.importoDovutoFase3 : "0",
      "VALORE KO": oda.importoDovutoKO ? oda.importoDovutoKO : "0",
      DOVUTO:
        oda.importoDovutoFase1 +
        oda.importoDovutoFase2 +
        oda.importoDovutoFase3 +
        oda.importoDovutoKO,
      EMESSO: oda.importoEmEmesse,
      RESIDUO: oda.importoResiduo,
    }));
    customData.push({
      ODA: null,
      IMPRESA: "",
      BANDO: "",
      "VALORE FASE 1": totaleFase1,
      "VALORE FASE 2": totaleFase2,
      "VALORE FASE 3": totaleFase3,
      "VALORE KO": totaleKO,
      DOVUTO: totaleDovuto,
      EMESSO: null,
      RESIDUO: null,
    });
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(customData, {
      header: [],
    });
    worksheet["A1"] = { v: customHeaders[0] };
    worksheet["B1"] = { v: customHeaders[1] };
    worksheet["C1"] = { v: customHeaders[2] };
    worksheet["D1"] = { v: customHeaders[3] };
    worksheet["E1"] = { v: customHeaders[4] };

    const workbook: XLSX.WorkBook = {
      Sheets: { data: worksheet },
      SheetNames: ["data"],
    };

    const excelBuffer: any = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Salva il file Excel
    saveAs(blob, filename);
  }

  exportStoricoPFToExcel(
    storico: StoricoProntofibra[],
    filename: string,
  ): void {
    const customHeaders = ["STATO", "DATA"];
    const customData = storico.map((storico) => ({
      STATO: storico.stato.label.toString(),
      DATA: this.utilService.formattaDataDaDate(storico.data),
    }));
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(customData, {
      header: [],
    });
    worksheet["A1"] = { v: customHeaders[0] };
    worksheet["B1"] = { v: customHeaders[1] };
    worksheet["C1"] = { v: customHeaders[2] };
    worksheet["D1"] = { v: customHeaders[3] };
    worksheet["E1"] = { v: customHeaders[4] };

    const workbook: XLSX.WorkBook = {
      Sheets: { data: worksheet },
      SheetNames: ["data"],
    };

    const excelBuffer: any = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Salva il file Excel
    saveAs(blob, filename);
  }

  exportStoricoToExcel(storico: StoricoPratica[], filename: string): void {
    const customHeaders = [
      "STATO FLOWDY",
      "STATO INFRATEL",
      "DATA INIZIO",
      "DATA FINE",
    ];
    const customData = storico.map((storico) => ({
      "STATO FLOWDY": storico.statoFlowdy.codice.toString(),
      "STATO INFRATEL": storico.statoInfratel.codice.toString(),
      "DATA INIZIO": this.utilService.formattaDataDaDate(storico.dataInizio),
      "DATA FINE": storico.dataFine
        ? this.utilService.formattaDataDaDate(storico.dataFine)
        : "",
    }));
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(customData, {
      header: [],
    });
    worksheet["A1"] = { v: customHeaders[0] };
    worksheet["B1"] = { v: customHeaders[1] };
    worksheet["C1"] = { v: customHeaders[2] };
    worksheet["D1"] = { v: customHeaders[3] };
    worksheet["E1"] = { v: customHeaders[4] };

    const workbook: XLSX.WorkBook = {
      Sheets: { data: worksheet },
      SheetNames: ["data"],
    };

    const excelBuffer: any = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Salva il file Excel
    saveAs(blob, filename);
  }

  exportNotePraticaToExcel(note: NotaPratica[], filename: string): void {
    const customHeaders = ["DATA", "CONTENUTO", "UTENTE"];
    const customData = note.map((nota) => ({
      "DATA INIZIO": this.utilService.formattaDataDaDate(nota.data),
      CONTENUTO: nota.contenuto,
      UTENTE: nota.utente.nome,
    }));
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(customData, {
      header: [],
    });
    worksheet["A1"] = { v: customHeaders[0] };
    worksheet["B1"] = { v: customHeaders[1] };
    worksheet["C1"] = { v: customHeaders[2] };
    worksheet["D1"] = { v: customHeaders[3] };
    worksheet["E1"] = { v: customHeaders[4] };

    const workbook: XLSX.WorkBook = {
      Sheets: { data: worksheet },
      SheetNames: ["data"],
    };

    const excelBuffer: any = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Salva il file Excel
    saveAs(blob, filename);
  }

  exportNoteReworkFase1ToExcel(
    pratica: PraticaFlowdy2_Firestore,
    filename: string,
  ): void {
    const customHeaders = [
      "RET OK",
      "NOTE RET",
      "DUVRI OK",
      "NOTE DUVRI",
      "VERBALE OK",
      "NOTE VERBALE",
    ];
    const customData = [
      {
        "RET OK": pratica.isRetOK ? "SI" : "NO",
        "NOTE RET": pratica.noteRET ? pratica.noteRET : "-",
        "DUVRI OK": pratica.isDuvriOK ? "SI" : "NO",
        "NOTE DUVRI": pratica.noteDUVRI ? pratica.noteDUVRI : "-",
        "VERBALE OK": pratica.isVerbaleOK ? "SI" : "NO",
        "NOTE VERBALE": pratica.noteVerbale ? pratica.noteVerbale : "-",
      },
    ];
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(customData, {
      header: [],
    });
    worksheet["A1"] = { v: customHeaders[0] };
    worksheet["B1"] = { v: customHeaders[1] };
    worksheet["C1"] = { v: customHeaders[2] };
    worksheet["D1"] = { v: customHeaders[3] };
    worksheet["E1"] = { v: customHeaders[4] };

    const workbook: XLSX.WorkBook = {
      Sheets: { data: worksheet },
      SheetNames: ["data"],
    };

    const excelBuffer: any = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Salva il file Excel
    saveAs(blob, filename);
  }

  exportNoteReworkFase2ToExcel(
    pratica: PraticaFlowdy2_Firestore,
    filename: string,
  ): void {
    const customHeaders = [
      "VERBALE ATTIVAZIONE OK ",
      "NOTE VERBALE ATTIVAZIONE",
      "ALLEGATI OK",
      "NOTE ALLEGATI",
    ];
    const customData = [
      {
        "VERBALE ATTIVAZIONE OK": pratica.verbaleFase2OK ? "SI" : "NO",
        "NOTE VERBALE ATTIVAZIONE": pratica.noteVerbaleFase2
          ? pratica.noteVerbaleFase2
          : "-",
        "ALLEGATI OK": pratica.allegatiFase2OK ? "SI" : "NO",
        "NOTE ALLEGATI": pratica.noteAllegatiFase2
          ? pratica.noteAllegatiFase2
          : "-",
      },
    ];
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(customData, {
      header: [],
    });
    worksheet["A1"] = { v: customHeaders[0] };
    worksheet["B1"] = { v: customHeaders[1] };
    worksheet["C1"] = { v: customHeaders[2] };
    worksheet["D1"] = { v: customHeaders[3] };
    worksheet["E1"] = { v: customHeaders[4] };

    const workbook: XLSX.WorkBook = {
      Sheets: { data: worksheet },
      SheetNames: ["data"],
    };

    const excelBuffer: any = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Salva il file Excel
    saveAs(blob, filename);
  }

  exportNoteReworkFase3ToExcel(
    pratica: PraticaFlowdy2_Firestore,
    filename: string,
  ): void {
    const customHeaders = [
      "RET OK ",
      "NOTE RET",
      "PSI OK",
      "NOTE PSI",
      "SUBIRU OK",
      "NOTE SUBIRU",
      "NT9 OK",
      "NOTE NT9",
    ];
    const customData = [
      {
        "RET OK": pratica.isRetOK ? "SI" : "NO",
        "NOTE RET": pratica.noteRETFase3 ? pratica.noteRETFase3 : "-",
        "PSI OK": pratica.isPSIOK ? "SI" : "NO",
        "NOTE PSI": pratica.notePSI ? pratica.notePSI : "-",
        "SUBIRU OK": pratica.isSubiruOK ? "SI" : "NO",
        "NOTE SUBIRU": pratica.noteSUBIRU ? pratica.noteSUBIRU : "-",
        "NT9 OK": pratica.isNT9OK ? "SI" : "NO",
        "NOTE NT9": pratica.noteNT9 ? pratica.noteNT9 : "-",
      },
    ];
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(customData, {
      header: [],
    });
    worksheet["A1"] = { v: customHeaders[0] };
    worksheet["B1"] = { v: customHeaders[1] };
    worksheet["C1"] = { v: customHeaders[2] };
    worksheet["D1"] = { v: customHeaders[3] };
    worksheet["E1"] = { v: customHeaders[4] };

    const workbook: XLSX.WorkBook = {
      Sheets: { data: worksheet },
      SheetNames: ["data"],
    };

    const excelBuffer: any = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Salva il file Excel
    saveAs(blob, filename);
  }

  exportNoteInfratelFase1ToExcel(
    pratica: PraticaFlowdy2_Firestore,
    filename: string,
  ): void {
    const customHeaders = ["NOTE"];
    const customData = [
      {
        NOTE: pratica.noteBocciaturaInfratel
          ? pratica.noteBocciaturaInfratel
          : "-",
      },
    ];
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(customData, {
      header: [],
    });
    worksheet["A1"] = { v: customHeaders[0] };
    worksheet["B1"] = { v: customHeaders[1] };
    worksheet["C1"] = { v: customHeaders[2] };
    worksheet["D1"] = { v: customHeaders[3] };
    worksheet["E1"] = { v: customHeaders[4] };

    const workbook: XLSX.WorkBook = {
      Sheets: { data: worksheet },
      SheetNames: ["data"],
    };

    const excelBuffer: any = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Salva il file Excel
    saveAs(blob, filename);
  }

  exportNoteInfratelFase2ToExcel(
    pratica: PraticaFlowdy2_Firestore,
    filename: string,
  ): void {
    const customHeaders = ["NOTE"];
    const customData = [
      {
        NOTE: pratica.noteBocciaturaInfratel
          ? pratica.noteBocciaturaInfratel
          : "-",
      },
    ];
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(customData, {
      header: [],
    });
    worksheet["A1"] = { v: customHeaders[0] };
    worksheet["B1"] = { v: customHeaders[1] };
    worksheet["C1"] = { v: customHeaders[2] };
    worksheet["D1"] = { v: customHeaders[3] };
    worksheet["E1"] = { v: customHeaders[4] };

    const workbook: XLSX.WorkBook = {
      Sheets: { data: worksheet },
      SheetNames: ["data"],
    };

    const excelBuffer: any = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Salva il file Excel
    saveAs(blob, filename);
  }

  exportPraticheRespinteFase3ToExcel(
    pratiche: PraticaFlowdy2_Firestore[],
    filename: string,
  ): void {
    const praticheRespinte = pratiche.filter(
      (p) => p.statoFlowdyFase3 === "RESPINTA",
    );
    const customHeaders = [
      "CUI",
      "Note bocciatura Infratel Fase 3",
      "Data invio Infratel Fase 3",
      "Data risposta Infratel Fase 3",
    ];
    const customData = praticheRespinte.map((p) => ({
      CUI: p.cui || "",
      "Note bocciatura Infratel Fase 3":
        p.noteBocciaturaInfratelFase3 || p.noteBocciaturaInfratel || "",
      "Data invio Infratel Fase 3": p.dataInvioInfratelFase3
        ? this.utilService.formattaDataDaTimestampFirestore(
            p.dataInvioInfratelFase3,
          )
        : "",
      "Data risposta Infratel Fase 3": p.dataRispostaInfratelFase3
        ? this.utilService.formattaDataDaTimestampFirestore(
            p.dataRispostaInfratelFase3,
          )
        : "",
    }));
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(customData, {
      header: customHeaders,
    });
    const workbook: XLSX.WorkBook = {
      Sheets: { data: worksheet },
      SheetNames: ["data"],
    };
    const excelBuffer: any = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, filename);
  }

  exportNoteInfratelFase3ToExcel(
    pratica: PraticaFlowdy2_Firestore,
    filename: string,
  ): void {
    const customHeaders = ["NOTE"];
    const customData = [
      {
        NOTE: pratica.noteBocciaturaInfratel
          ? pratica.noteBocciaturaInfratel
          : "-",
      },
    ];
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(customData, {
      header: [],
    });
    worksheet["A1"] = { v: customHeaders[0] };
    worksheet["B1"] = { v: customHeaders[1] };
    worksheet["C1"] = { v: customHeaders[2] };
    worksheet["D1"] = { v: customHeaders[3] };
    worksheet["E1"] = { v: customHeaders[4] };

    const workbook: XLSX.WorkBook = {
      Sheets: { data: worksheet },
      SheetNames: ["data"],
    };

    const excelBuffer: any = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Salva il file Excel
    saveAs(blob, filename);
  }

  exportOdaToExcel(data: OdaAtFirestore[], filename: string): void {
    const customHeaders = [
      "NUMERO",
      "IMPRESA",
      "BANDO",
      "LOTTI",
      "DATA CREAZIONE",
      "IMPORTO",
      "IMPORTO IMPEGNATO",
      "IMPORTO EM EMESSE",
      "IMPORTO RESIDUO",
    ];
    const customData = data.map((oda) => ({
      NUMERO: oda.numero,
      IMPRESA: oda.azienda,
      BANDO: oda.bando,
      LOTTI: oda.lotti.toString(),
      "DATA CREAZIONE": this.utilService.formattaDataDaTimestampFirestore(
        oda.dataCreazione,
      ),
      IMPORTO: oda.importo,
      "IMPORTO IMPEGNATO": oda.importoImpegnato,
      "IMPORTO EM EMESSE": oda.importoEmEmesse,
      "IMPORTO RESIDUO": oda.importoResiduo,
    }));
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(customData, {
      header: [],
    });
    worksheet["A1"] = { v: customHeaders[0] };
    worksheet["B1"] = { v: customHeaders[1] };
    worksheet["C1"] = { v: customHeaders[2] };
    worksheet["D1"] = { v: customHeaders[3] };
    worksheet["E1"] = { v: customHeaders[4] };

    const workbook: XLSX.WorkBook = {
      Sheets: { data: worksheet },
      SheetNames: ["data"],
    };

    const excelBuffer: any = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Salva il file Excel
    saveAs(blob, filename);
  }

  exportPraticheMandatoDiPagamentoToExcel(
    data: PraticaFlowdy2_Firestore[],
    mdp: MandatoDiPagamento,
    filename: string,
  ): void {
    let totaleFase1: number = 0;
    let totaleFase2: number = 0;
    let totaleFase3: number = 0;
    let totaleKO: number = 0;
    const customHeaders = [
      "CUI",
      "IMPRESA FASE 1",
      "FASE 1",
      "ODA FASE 1",
      "IMPRESA FASE 2",
      "FASE 2",
      "ODA FASE 2",
      "IMPRESA FASE 3",
      "FASE 3",
      "ODA FASE 3",
      "KO",
      "",
    ];
    this.logger.info(data);
    data.map((pratica) => {
      if (pratica.idMandatoDiPagamentoFase1 === mdp.id) {
        if (pratica.importoPagatoFase1 && pratica.importoPagatoFase1 !== 0) {
          totaleFase1 += Number(pratica.importoPagatoFase1.toFixed(2));
        } else if (
          pratica.importoDovutoFase1 &&
          pratica.importoDovutoFase1 !== null &&
          pratica.importoDovutoFase1 !== undefined
        ) {
          totaleFase1 += Number(pratica.importoDovutoFase1.toFixed(2));
        }
        //totaleFase1 += Number((pratica.importoDovutoFase1 && pratica.importoDovutoFase1 !==0 ? Number(pratica.importoDovutoFase1) : Number(pratica.importoPagatoFase1)).toFixed(2));
      }
      if (pratica.idMandatoDiPagamentoFase2 === mdp.id) {
        if (pratica.importoPagatoFase2 && pratica.importoPagatoFase2 !== 0) {
          totaleFase2 += Number(pratica.importoPagatoFase2.toFixed(2));
        } else if (
          pratica.importoDovutoFase2 &&
          pratica.importoDovutoFase2 !== null &&
          pratica.importoDovutoFase2 !== undefined
        ) {
          totaleFase2 += Number(pratica.importoDovutoFase2.toFixed(2));
        }
        //totaleFase2 += Number((pratica.importoDovutoFase2 && pratica.importoDovutoFase2 !==0 ? Number(pratica.importoDovutoFase2) : Number(pratica.importoPagatoFase2)).toFixed(2));
      }
      if (pratica.idMandatoDiPagamentoFase3 === mdp.id) {
        if (pratica.importoPagatoFase3 && pratica.importoPagatoFase3 !== 0) {
          totaleFase3 += Number(pratica.importoPagatoFase3.toFixed(2));
        } else if (
          pratica.importoDovutoFase3 &&
          pratica.importoDovutoFase3 !== null &&
          pratica.importoDovutoFase3 !== undefined
        ) {
          totaleFase3 += Number(pratica.importoDovutoFase3.toFixed(2));
        }
        //totaleFase3 += Number((pratica.importoDovutoFase3 && pratica.importoDovutoFase3 !==0 ? Number(pratica.importoDovutoFase3) : Number(pratica.importoPagatoFase3)).toFixed(2));
      }
      if (pratica.idMandatoDiPagamentoKO === mdp.id) {
        if (pratica.importoPagatoKO && pratica.importoPagatoKO !== 0) {
          totaleKO += Number(pratica.importoPagatoKO.toFixed(2));
        } else if (
          pratica.importoDovutoKO &&
          pratica.importoDovutoKO !== null &&
          pratica.importoDovutoKO !== undefined
        ) {
          totaleKO += Number(pratica.importoDovutoKO.toFixed(2));
        }
        //totaleKO += Number((pratica.importoDovutoKO && pratica.importoDovutoKO !==0 ? Number(pratica.importoDovutoKO) : Number(pratica.importoPagatoKO)).toFixed(2));
      }
      if (pratica.cui === "I-PUG-INF-BRAA02208X-2125") {
        console.log(
          pratica.importoPagatoFase1,
          pratica.importoDovutoFase1,
          pratica.importoPagatoFase2,
          pratica.importoDovutoFase2,
          pratica.importoPagatoFase3,
          pratica.importoDovutoFase3,
          pratica.importoPagatoKO,
          pratica.importoDovutoKO,
        );
        console.log(totaleFase1, totaleFase2, totaleFase3, totaleKO);
        console.log(pratica.idMandatoDiPagamentoFase3 + " Vs " + mdp.id);
      }
    });

    const customData = data.map((pratica) => ({
      CUI: pratica.cui,
      "IMPRESA FASE 1": pratica.aziendaFase1
        ? pratica.aziendaFase1
        : pratica.azienda,
      "ODA FASE 1": pratica.numeroOdaFase1,
      "FASE 1": Number(
        (pratica.idMandatoDiPagamentoFase1 === mdp.id
          ? pratica.importoPagatoFase1 && pratica.importoPagatoFase1 !== 0
            ? Number(pratica.importoPagatoFase1)
            : Number(pratica.importoDovutoFase1)
          : 0
        ).toFixed(2),
      ),
      "IMPRESA FASE 2": pratica.aziendaFase2
        ? pratica.aziendaFase2
        : pratica.azienda,
      "FASE 2": Number(
        (pratica.idMandatoDiPagamentoFase2 === mdp.id
          ? pratica.importoPagatoFase2 && pratica.importoPagatoFase2 !== 0
            ? Number(pratica.importoPagatoFase2)
            : Number(pratica.importoDovutoFase2)
          : 0
        ).toFixed(2),
      ),
      "ODA FASE 2": pratica.numeroOdaFase2,
      "IMPRESA FASE 3": pratica.aziendaFase3
        ? pratica.aziendaFase3
        : pratica.azienda,
      "FASE 3": Number(
        (pratica.idMandatoDiPagamentoFase3 === mdp.id
          ? pratica.importoPagatoFase3 && pratica.importoPagatoFase3 !== 0
            ? Number(pratica.importoPagatoFase3)
            : Number(pratica.importoDovutoFase3)
          : 0
        ).toFixed(2),
      ),
      "ODA FASE 3": pratica.numeroOdaFase3,
      KO: Number(
        (pratica.idMandatoDiPagamentoKO === mdp.id
          ? pratica.importoPagatoKO && pratica.importoPagatoKO !== 0
            ? Number(pratica.importoPagatoKO)
            : Number(pratica.importoDovutoKO)
          : 0
        ).toFixed(2),
      ),
      TOTALE: Number(
        (pratica.idMandatoDiPagamentoFase1 === mdp.id
          ? pratica.importoPagatoFase1 && pratica.importoPagatoFase1 !== 0
            ? Number(pratica.importoPagatoFase1)
            : Number(pratica.importoDovutoFase1)
          : 0) +
          (pratica.idMandatoDiPagamentoFase2 === mdp.id
            ? pratica.importoPagatoFase2 && pratica.importoPagatoFase2 !== 0
              ? Number(pratica.importoPagatoFase2)
              : Number(pratica.importoDovutoFase2)
            : 0) +
          (pratica.idMandatoDiPagamentoFase3 === mdp.id
            ? pratica.importoPagatoFase3 && pratica.importoPagatoFase3 !== 0
              ? Number(pratica.importoPagatoFase3)
              : Number(pratica.importoDovutoFase3)
            : 0) +
          (pratica.idMandatoDiPagamentoKO === mdp.id
            ? pratica.importoPagatoKO && pratica.importoPagatoKO !== 0
              ? Number(pratica.importoPagatoKO)
              : Number(pratica.importoDovutoKO)
            : 0),
      ).toFixed(2),
    }));

    customData.push({
      CUI: "",
      "IMPRESA FASE 1": "",
      "ODA FASE 1": 0,
      "IMPRESA FASE 2": "",
      "ODA FASE 2": 0,
      "IMPRESA FASE 3": "",
      "ODA FASE 3": 0,
      "FASE 1": Number(totaleFase1.toFixed(2)),
      "FASE 2": Number(totaleFase2.toFixed(2)),
      "FASE 3": Number(totaleFase3.toFixed(2)),

      KO: Number(totaleKO.toFixed(2)),
      TOTALE: Number(
        totaleFase1 + totaleFase2 + totaleFase3 + totaleKO,
      ).toFixed(2),
    });
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(customData, {
      header: [],
    });
    worksheet["A1"] = { v: customHeaders[0] };
    worksheet["B1"] = { v: customHeaders[1] };
    worksheet["C1"] = { v: customHeaders[2] };
    worksheet["D1"] = { v: customHeaders[3] };
    worksheet["E1"] = { v: customHeaders[4] };

    const workbook: XLSX.WorkBook = {
      Sheets: { data: worksheet },
      SheetNames: ["data"],
    };

    const excelBuffer: any = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Salva il file Excel
    saveAs(blob, filename);
  }

  exportPraticheBando2ToExcel(
    data: PraticaScuola_Firestore[],
    filename: string,
  ): void {
    const customHeaders = [
      "CODICE INFRATEL",
      "NOME INVIO",
      "IMPRESA",
      "REGIONE",
      "COMUNE",
      "INDIRIZZO",
      "TIPO SEDE",
      "TIPO SEDE EFFETTIVA",
      "COLOCATA",
      "BACKUP",
      "STATO",
    ];
    const customData = data.map((pratica) => ({
      "CODICE INFRATEL": pratica.codiceInfratel,
      "NOME INVIO": pratica.nomeInvio,
      IMPRESA: pratica.azienda,
      REGIONE: pratica.regione,
      COMUNE: pratica.comune,
      INDIRIZZO: pratica.indirizzo,
      "TIPO SEDE": pratica.tipoSede,
      "TIPO SEDE EFFETTIVA": pratica.tipoSedeEffettiva
        ? pratica.tipoSedeEffettiva
        : "",
      COLOCATA: pratica.colocata ? "SI" : "NO",
      BACKUP: pratica.backup ? "SI" : "NO",
      STATO: pratica.stato,
    }));
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(customData, {
      header: [],
    });
    worksheet["A1"] = { v: customHeaders[0] };
    worksheet["B1"] = { v: customHeaders[1] };
    worksheet["C1"] = { v: customHeaders[2] };
    worksheet["D1"] = { v: customHeaders[3] };
    worksheet["E1"] = { v: customHeaders[4] };

    const workbook: XLSX.WorkBook = {
      Sheets: { data: worksheet },
      SheetNames: ["data"],
    };

    const excelBuffer: any = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Salva il file Excel
    saveAs(blob, filename);
  }

  exportAnagraficaBando1ToExcel(
    data: PraticaFlowdy2_Firestore[],
    filename: string,
  ): void {
    const customHeaders = [
      "CODICE INFRATEL",
      "CODICE MIUR",
      //'IMPRESA',
      "IMPRESA FASE 1",
      "IMPRESA FASE 2",
      "IMPRESA FASE 3",
      "REGIONE",
      "COMUNE",
      "INDIRIZZO",
      "TIPO SEDE",
      "TIPO SEDE EFFETTIVA",
      "PF NO F1",
      "STATO INFRATEL FASE 1",
      "STATO FLOWDY FASE 1",
      "DATA SOPRALLUOGO",
      "PERMESSO ENTE PUBBLICO",
      "DATA INVIO FASE 1",
      "DATA RISPOSTA FASE 1",
      "STATO PRONTOFIBRA",
      "DUMMY 1",
      "DATA ATTIVAZIONE",
      "STATO INFRATEL FASE 2",
      "STATO FLOWDY FASE 2",
      "DATA APPUNTAMENTO",
      "DATA INVIO FASE 2",
      "DATA APPROVAZIONE FASE 2",
      "STATO INFRATEL FASE 3",
      "STATO FLOWDY FASE 3",
      "DATA INVIO FASE 3",
      "DATA APPROVAZIONE FASE 3",
      "DUMMY 2",
      "DUMMY 3",
      "SDF PRINCIPALE",
      "SDF BK",
      "TGU FTTO PRINCIPALE",
      "TGU GIGA PRINCIPALE",
      "TGU FTTO BK",
      "TGU GIGA BK",
      "IMPRESA FC",
      "NTW FC",
      "FONTE TIM",
      "FONTE FC",
      "NOTE",
      "TIPO VINCOLO",
      "CATEGORIA VINCOLO",
      "FASE VINCOLO",
    ];
    const customData = data.map((pratica) => {
      if (pratica.dataAppuntamentoFase2) {
        const oggi = new Date();
        const dataAppuntamentoDaControllare = new Date(
          pratica.dataAppuntamentoFase2.toDate().getFullYear(),
          pratica.dataAppuntamentoFase2.toDate().getMonth(),
          pratica.dataAppuntamentoFase2.toDate().getDate() + 2,
        );
        if (
          pratica.statoFlowdyFase2 === "APPUNTAMENTO FISSATO" &&
          pratica.dataAppuntamentoFase2 &&
          !pratica.installazioneRouterOk &&
          dataAppuntamentoDaControllare < oggi
        ) {
          pratica.statoFlowdyFase2 = "APPUNTAMENTO MANCATO";
        }
      }
      if (
        pratica.showFase2 &&
        (pratica.statoFlowdyFase1 === "CONSEGNATA" ||
          pratica.statoFlowdyFase1 === "IN VERIFICA SMARTFIBER" ||
          pratica.statoFlowdyFase1 === "IN CARICO PRESIDIO" ||
          pratica.statoFlowdyFase1 === "IN REWORK AZIENDA" ||
          pratica.statoFlowdyFase1 === "PUBBLICATA" ||
          pratica.statoFlowdyFase1 === "RESPINTA" ||
          pratica.statoFlowdyFase1 === "APPROVATA")
      ) {
        pratica.showFase2 = false;
      }
      let codiceStatoFlowdyFase2 = pratica.statoFlowdyFase2;
      if (!pratica.statoFlowdyFase2 || pratica.statoFlowdyFase2.length == 0) {
        if (
          pratica.statoFlowdyFase1 === "ASSEGNATA" ||
          pratica.statoFlowdyFase1 === "DA ASSEGNARE" ||
          pratica.statoFlowdyFase1 === "IN ATTESA ODA"
        ) {
          codiceStatoFlowdyFase2 = pratica.statoFlowdyFase1;
        } else {
          codiceStatoFlowdyFase2 = "DA ASSEGNARE";
        }
      }
      let codiceStatoFlowdyFase3 = pratica.statoFlowdyFase3;
      if (!pratica.statoFlowdyFase3 || pratica.statoFlowdyFase3.length == 0) {
        if (
          pratica.statoFlowdyFase1 === "ASSEGNATA" ||
          pratica.statoFlowdyFase1 === "DA ASSEGNARE" ||
          pratica.statoFlowdyFase1 === "IN ATTESA ODA"
        ) {
          codiceStatoFlowdyFase3 = pratica.statoFlowdyFase1;
        } else {
          codiceStatoFlowdyFase3 = "DA ASSEGNARE";
        }
      }
      return {
        "CODICE INFRATEL": pratica.cui,
        "CODICE MIUR": pratica.codiceMiur,
        "IMPRESA FASE 1": pratica.aziendaFase1
          ? pratica.aziendaFase1
          : pratica.azienda,
        "IMPRESA FASE 2": pratica.aziendaFase2
          ? pratica.aziendaFase2
          : pratica.azienda,
        "IMPRESA FASE 3": pratica.aziendaFase3
          ? pratica.aziendaFase3
          : pratica.azienda,
        REGIONE: pratica.regione,
        COMUNE: pratica.comune,
        INDIRIZZO: pratica.indirizzo,
        "TIPO SEDE": pratica.tipoSede,
        "TIPO SEDE EFFETTIVA": pratica.tipoSedeEffettiva
          ? pratica.tipoSedeEffettiva
          : "",
        "PF NO F1": pratica.showFase2 ? "1" : "0",
        "STATO INFRATEL FASE 1": pratica.codiceStatoInfratelFase1,
        "STATO FLOWDY FASE 1": pratica.statoFlowdyFase1,
        "DATA SOPRALLUOGO": pratica.dataSopralluogo
          ? this.utilService.formattaDataDaTimestampFirestore(
              pratica.dataSopralluogo,
            )
          : "",
        "PERMESSO ENTE PUBBLICO": pratica.servePermessoEntePubblico
          ? pratica.dataCaricamentoPermesso
            ? this.utilService.formattaDataDaTimestampFirestore(
                pratica.dataCaricamentoPermesso,
              )
            : "DA CARICARE"
          : "NO",
        "DATA INVIO FASE 1":
          pratica.codiceStatoInfratelFase1 === "1-2" ||
          pratica.codiceStatoInfratelFase1 === "1-4" ||
          pratica.codiceStatoInfratelFase1 === "1-6"
            ? this.utilService.formattaDataDaTimestampFirestore(
                pratica.dataInvioInfratelFase1,
              )
            : "",
        "DATA RISPOSTA FASE 1":
          pratica.codiceStatoInfratelFase1 === "1-2" ||
          pratica.codiceStatoInfratelFase1 === "1-6"
            ? this.utilService.formattaDataDaTimestampFirestore(
                pratica.dataRispostaInfratelFase1,
              )
            : "",
        "STATO PRONTOFIBRA": pratica.statoPF ? pratica.statoPF : "",
        "DUMMY 1": "",
        "DATA ATTIVAZIONE": pratica.dataConfermaTS
          ? this.utilService.formattaDataDaTimestampFirestore(
              pratica.dataConfermaTS,
            )
          : "",
        "STATO INFRATEL FASE 2": pratica.codiceStatoInfratelFase2
          ? pratica.codiceStatoInfratelFase2
          : "2-1",
        "STATO FLOWDY FASE 2": pratica.statoFlowdyFase2
          ? pratica.statoFlowdyFase2
          : codiceStatoFlowdyFase2,
        "DATA APPUNTAMENTO": pratica.dataAppuntamentoFase2
          ? this.utilService.formattaDataDaTimestampFirestore(
              pratica.dataAppuntamentoFase2,
            )
          : "",
        "DATA INVIO FASE 2":
          pratica.codiceStatoInfratelFase1 === "2-2" ||
          pratica.codiceStatoInfratelFase1 === "2-4" ||
          pratica.codiceStatoInfratelFase1 === "2-6"
            ? this.utilService.formattaDataDaTimestampFirestore(
                pratica.dataInvioInfratelFase2,
              )
            : "",
        "DATA APPROVAZIONE FASE 2":
          pratica.codiceStatoInfratelFase2 == "2-6"
            ? this.utilService.formattaDataDaTimestampFirestore(
                pratica.dataRispostaInfratelFase2,
              )
            : "",
        "STATO INFRATEL FASE 3": pratica.codiceStatoInfratelFase3
          ? pratica.codiceStatoInfratelFase3
          : "3-1",
        "STATO FLOWDY FASE 3": pratica.statoFlowdyFase3
          ? pratica.statoFlowdyFase3
          : codiceStatoFlowdyFase3,
        "DATA INVIO FASE 3":
          pratica.codiceStatoInfratelFase1 === "3-2" ||
          pratica.codiceStatoInfratelFase1 === "3-4" ||
          pratica.codiceStatoInfratelFase1 === "3-6"
            ? this.utilService.formattaDataDaTimestampFirestore(
                pratica.dataInvioInfratelFase3,
              )
            : "",
        "DATA APPROVAZIONE FASE 3":
          pratica.codiceStatoInfratelFase3 == "3-6"
            ? this.utilService.formattaDataDaTimestampFirestore(
                pratica.dataRispostaInfratelFase3,
              )
            : "",
        "DUMMY 2": "",
        "DUMMY 3:": "",
        "SDF PRINCIPALE": pratica.sdfPrincipale ? pratica.sdfPrincipale : "",
        "SDF BK": pratica.sdfBackup ? pratica.sdfBackup : "",
        "TGU FTTO PRINCIPALE": pratica.tguFttoPrincipale
          ? pratica.tguFttoPrincipale
          : "",
        "TGU GIGA PRINCIPALE": pratica.tguGigaPrincipale
          ? pratica.tguGigaPrincipale
          : "",
        "TGU FTTO BK": pratica.tguFttoBackup ? pratica.tguFttoBackup : "",
        "TGU GIGA BK": pratica.tguGigaBackup ? pratica.tguGigaBackup : "",
        "IMPRESA FC": pratica.impresaFC ? pratica.impresaFC : "",
        "NTW FC": pratica.ntwFC ? pratica.ntwFC : "",
        "FONTE TIM": pratica.fonteTIM ? pratica.fonteTIM : "",
        "FONTE FC": pratica.fonteFC ? pratica.fonteFC : "",
        NOTE: pratica.ultimeNote ? pratica.ultimeNote : "",
        "TIPO VINCOLO": pratica.vincoloTipologiaID
          ? pratica.vincoloTipologiaID
          : "",
        "CATEGORIA VINCOLO": pratica.vincoloCategoriaLabel
          ? pratica.vincoloCategoriaLabel
          : "",
        "FASE VINCOLO": pratica.vincoloFase ? pratica.vincoloFase : "",
      };
    });

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(customData, {
      header: [],
    });
    worksheet["A1"] = { v: customHeaders[0] };
    worksheet["B1"] = { v: customHeaders[1] };
    worksheet["C1"] = { v: customHeaders[2] };
    worksheet["D1"] = { v: customHeaders[3] };
    worksheet["E1"] = { v: customHeaders[4] };

    const workbook: XLSX.WorkBook = {
      Sheets: { data: worksheet },
      SheetNames: ["data"],
    };

    const excelBuffer: any = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Salva il file Excel
    saveAs(blob, filename);
  }

  exportAnagraficaBando2ToExcel(
    data: PraticaFlowdy2_Firestore[],
    filename: string,
  ): void {
    const customHeaders = [
      "CODICE INFRATEL",
      "CODICE MIUR",
      //'IMPRESA',
      "IMPRESA FASE 1",
      "IMPRESA FASE 2",
      "IMPRESA FASE 3",
      "REGIONE",
      "COMUNE",
      "INDIRIZZO",
      "TIPO SEDE",
      "TIPO SEDE EFFETTIVA",
      "PF NO F1",
      "STATO INFRATEL FASE 1",
      "STATO FLOWDY FASE 1",
      "DATA SOPRALLUOGO",
      "PERMESSO ENTE PUBBLICO",
      "DATA INVIO FASE 1",
      "DATA RISPOSTA FASE 1",
      "STATO PRONTOFIBRA",
      "DUMMY 1",
      "DATA ATTIVAZIONE",
      "STATO INFRATEL FASE 2",
      "STATO FLOWDY FASE 2",
      "DATA APPUNTAMENTO",
      "DATA INVIO FASE 2",
      "DATA APPROVAZIONE FASE 2",
      "STATO INFRATEL FASE 3",
      "STATO FLOWDY FASE 3",
      "DATA INVIO FASE 3",
      "DATA APPROVAZIONE FASE 3",
      "DUMMY 2",
      "DUMMY 3",
      "SDF PRINCIPALE",
      "SDF BK",
      "TGU FTTO PRINCIPALE",
      "TGU GIGA PRINCIPALE",
      "TGU FTTO BK",
      "TGU GIGA BK",
      "IMPRESA FC",
      "NTW FC",
      "FONTE TIM",
      "FONTE FC",
      "NOTE",
      "TIPO VINCOLO",
      "CATEGORIA VINCOLO",
      "FASE VINCOLO",
    ];
    const customData = data.map((pratica) => {
      if (pratica.dataAppuntamentoFase2) {
        const oggi = new Date();
        const dataAppuntamentoDaControllare = new Date(
          pratica.dataAppuntamentoFase2.toDate().getFullYear(),
          pratica.dataAppuntamentoFase2.toDate().getMonth(),
          pratica.dataAppuntamentoFase2.toDate().getDate() + 2,
        );
        if (
          pratica.statoFlowdyFase2 === "APPUNTAMENTO FISSATO" &&
          pratica.dataAppuntamentoFase2 &&
          !pratica.installazioneRouterOk &&
          dataAppuntamentoDaControllare < oggi
        ) {
          pratica.statoFlowdyFase2 = "APPUNTAMENTO MANCATO";
        }
      }

      if (
        pratica.showFase2 &&
        (pratica.statoFlowdyFase1 === "CONSEGNATA" ||
          pratica.statoFlowdyFase1 === "IN VERIFICA SMARTFIBER" ||
          pratica.statoFlowdyFase1 === "IN CARICO PRESIDIO" ||
          pratica.statoFlowdyFase1 === "IN REWORK AZIENDA" ||
          pratica.statoFlowdyFase1 === "PUBBLICATA" ||
          pratica.statoFlowdyFase1 === "RESPINTA" ||
          pratica.statoFlowdyFase1 === "APPROVATA")
      ) {
        pratica.showFase2 = false;
      }
      let codiceStatoFlowdyFase2 = pratica.statoFlowdyFase2;
      if (!pratica.statoFlowdyFase2 || pratica.statoFlowdyFase2.length == 0) {
        if (
          pratica.statoFlowdyFase1 === "ASSEGNATA" ||
          pratica.statoFlowdyFase1 === "DA ASSEGNARE" ||
          pratica.statoFlowdyFase1 === "IN ATTESA ODA"
        ) {
          codiceStatoFlowdyFase2 = pratica.statoFlowdyFase1;
        } else {
          codiceStatoFlowdyFase2 = "DA ASSEGNARE";
        }
      }
      let codiceStatoFlowdyFase3 = pratica.statoFlowdyFase3;
      if (!pratica.statoFlowdyFase3 || pratica.statoFlowdyFase3.length == 0) {
        if (
          pratica.statoFlowdyFase1 === "ASSEGNATA" ||
          pratica.statoFlowdyFase1 === "DA ASSEGNARE" ||
          pratica.statoFlowdyFase1 === "IN ATTESA ODA"
        ) {
          codiceStatoFlowdyFase3 = pratica.statoFlowdyFase1;
        } else {
          codiceStatoFlowdyFase3 = "DA ASSEGNARE";
        }
      }
      return {
        "CODICE INFRATEL": pratica.cui,
        "CODICE MIUR": pratica.codiceMiur,
        "IMPRESA FASE 1": pratica.aziendaFase1
          ? pratica.aziendaFase1
          : pratica.azienda,
        "IMPRESA FASE 2": pratica.aziendaFase2
          ? pratica.aziendaFase2
          : pratica.azienda,
        "IMPRESA FASE 3": pratica.aziendaFase3
          ? pratica.aziendaFase3
          : pratica.azienda,
        REGIONE: pratica.regione,
        COMUNE: pratica.comune,
        INDIRIZZO: pratica.indirizzo,
        "TIPO SEDE": pratica.tipoSede,
        "TIPO SEDE EFFETTIVA": pratica.tipoSedeEffettiva
          ? pratica.tipoSedeEffettiva
          : "",
        "PF NO F1": pratica.showFase2 ? "1" : "0",
        "STATO INFRATEL FASE 1": pratica.codiceStatoInfratelFase1,
        "STATO FLOWDY FASE 1": pratica.statoFlowdyFase1,
        "DATA SOPRALLUOGO": pratica.dataSopralluogo
          ? this.utilService.formattaDataDaTimestampFirestore(
              pratica.dataSopralluogo,
            )
          : "",
        "PERMESSO ENTE PUBBLICO": pratica.servePermessoEntePubblico
          ? pratica.dataCaricamentoPermesso
            ? this.utilService.formattaDataDaTimestampFirestore(
                pratica.dataCaricamentoPermesso,
              )
            : "DA CARICARE"
          : "NO",
        "DATA INVIO FASE 1":
          pratica.codiceStatoInfratelFase1 === "1-2" ||
          pratica.codiceStatoInfratelFase1 === "1-4" ||
          pratica.codiceStatoInfratelFase1 === "1-6"
            ? this.utilService.formattaDataDaTimestampFirestore(
                pratica.dataInvioInfratelFase1,
              )
            : "",
        "DATA RISPOSTA FASE 1":
          pratica.codiceStatoInfratelFase1 === "1-2" ||
          pratica.codiceStatoInfratelFase1 === "1-6"
            ? this.utilService.formattaDataDaTimestampFirestore(
                pratica.dataRispostaInfratelFase1,
              )
            : "",
        "STATO PRONTOFIBRA": pratica.statoPF ? pratica.statoPF : "",
        "DUMMY 1": "",
        "DATA ATTIVAZIONE": pratica.dataConfermaTS
          ? this.utilService.formattaDataDaTimestampFirestore(
              pratica.dataConfermaTS,
            )
          : "",
        "STATO INFRATEL FASE 2": pratica.codiceStatoInfratelFase2
          ? pratica.codiceStatoInfratelFase2
          : "2-1",
        "STATO FLOWDY FASE 2": pratica.statoFlowdyFase2
          ? pratica.statoFlowdyFase2
          : codiceStatoFlowdyFase2,
        "DATA APPUNTAMENTO": pratica.dataAppuntamentoFase2
          ? this.utilService.formattaDataDaTimestampFirestore(
              pratica.dataAppuntamentoFase2,
            )
          : "",
        "DATA INVIO FASE 2":
          pratica.codiceStatoInfratelFase1 === "2-2" ||
          pratica.codiceStatoInfratelFase1 === "2-4" ||
          pratica.codiceStatoInfratelFase1 === "2-6"
            ? this.utilService.formattaDataDaTimestampFirestore(
                pratica.dataInvioInfratelFase2,
              )
            : "",
        "DATA APPROVAZIONE FASE 2":
          pratica.codiceStatoInfratelFase2 == "2-6"
            ? this.utilService.formattaDataDaTimestampFirestore(
                pratica.dataRispostaInfratelFase2,
              )
            : "",
        "STATO INFRATEL FASE 3": pratica.codiceStatoInfratelFase3
          ? pratica.codiceStatoInfratelFase3
          : "3-1",
        "STATO FLOWDY FASE 3": pratica.statoFlowdyFase3
          ? pratica.statoFlowdyFase3
          : codiceStatoFlowdyFase3,
        "DATA INVIO FASE 3":
          pratica.codiceStatoInfratelFase1 === "3-2" ||
          pratica.codiceStatoInfratelFase1 === "3-4" ||
          pratica.codiceStatoInfratelFase1 === "3-6"
            ? this.utilService.formattaDataDaTimestampFirestore(
                pratica.dataInvioInfratelFase3,
              )
            : "",
        "DATA APPROVAZIONE FASE 3":
          pratica.codiceStatoInfratelFase3 == "3-6"
            ? this.utilService.formattaDataDaTimestampFirestore(
                pratica.dataRispostaInfratelFase3,
              )
            : "",
        "DUMMY 2": "",
        "DUMMY 3:": "",
        "SDF PRINCIPALE": pratica.sdfPrincipale ? pratica.sdfPrincipale : "",
        "SDF BK": pratica.sdfBackup ? pratica.sdfBackup : "",
        "TGU FTTO PRINCIPALE": pratica.tguFttoPrincipale
          ? pratica.tguFttoPrincipale
          : "",
        "TGU GIGA PRINCIPALE": pratica.tguGigaPrincipale
          ? pratica.tguGigaPrincipale
          : "",
        "TGU FTTO BK": pratica.tguFttoBackup ? pratica.tguFttoBackup : "",
        "TGU GIGA BK": pratica.tguGigaBackup ? pratica.tguGigaBackup : "",
        "IMPRESA FC": pratica.impresaFC ? pratica.impresaFC : "",
        "NTW FC": pratica.ntwFC ? pratica.ntwFC : "",
        "FONTE TIM": pratica.fonteTIM ? pratica.fonteTIM : "",
        "FONTE FC": pratica.fonteFC ? pratica.fonteFC : "",
        NOTE: pratica.ultimeNote ? pratica.ultimeNote : "",
        "TIPO VINCOLO": pratica.vincoloTipologiaID
          ? pratica.vincoloTipologiaID
          : "",
        "CATEGORIA VINCOLO": pratica.vincoloCategoriaLabel
          ? pratica.vincoloCategoriaLabel
          : "",
        "FASE VINCOLO": pratica.vincoloFase ? pratica.vincoloFase : "",
      };
    });

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(customData, {
      header: [],
    });
    worksheet["A1"] = { v: customHeaders[0] };
    worksheet["B1"] = { v: customHeaders[1] };
    worksheet["C1"] = { v: customHeaders[2] };
    worksheet["D1"] = { v: customHeaders[3] };
    worksheet["E1"] = { v: customHeaders[4] };

    const workbook: XLSX.WorkBook = {
      Sheets: { data: worksheet },
      SheetNames: ["data"],
    };

    const excelBuffer: any = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Salva il file Excel
    saveAs(blob, filename);
  }

  exportAllPraticheBando1ToExcel(
    data: PraticaFlowdy2_Firestore[],
    filename: string,
  ): void {
    const customHeaders = [
      "CODICE INFRATEL",
      "CODICE MIUR",
      "IMPRESA",
      "REGIONE",
      "COMUNE",
      "INDIRIZZO",
      "TIPO SEDE",
      "TIPO SEDE EFFETTIVA",
      "PF NO F1",
      "STATO INFRATEL FASE 1",
      "STATO FLOWDY FASE 1",
      "DATA SOPRALLUOGO",
      "PERMESSO ENTE PUBBLICO",
      "DATA INVIO FASE 1",
      "DATA RISPOSTA FASE 1",
      "STATO PRONTOFIBRA",
      "CAUSA KO PRONTOFIBRA",
      "DATA ATTIVAZIONE",
      "STATO INFRATEL FASE 2",
      "STATO FLOWDY FASE 2",
      "DATA APPUNTAMENTO",
      "DATA INVIO FASE 2",
      "DATA APPROVAZIONE FASE 2",
      "STATO INFRATEL FASE 3",
      "STATO FLOWDY FASE 3",
      "DATA INVIO FASE 3",
      "DATA APPROVAZIONE FASE 3",
      "CAUSA SOPRALLLUOGO KO",
      "SOPPRALLUOGO KO APPROVATO",
    ];
    const customData = data.map((pratica) => {
      if (pratica.dataAppuntamentoFase2) {
        const oggi = new Date();
        const dataAppuntamentoDaControllare = new Date(
          pratica.dataAppuntamentoFase2.toDate().getFullYear(),
          pratica.dataAppuntamentoFase2.toDate().getMonth(),
          pratica.dataAppuntamentoFase2.toDate().getDate() + 2,
        );
        if (
          pratica.statoFlowdyFase2 === "APPUNTAMENTO FISSATO" &&
          pratica.dataAppuntamentoFase2 &&
          !pratica.installazioneRouterOk &&
          dataAppuntamentoDaControllare < oggi
        ) {
          pratica.statoFlowdyFase2 = "APPUNTAMENTO MANCATO";
        }
      }
      if (
        pratica.showFase2 &&
        (pratica.statoFlowdyFase1 === "CONSEGNATA" ||
          pratica.statoFlowdyFase1 === "IN VERIFICA SMARTFIBER" ||
          pratica.statoFlowdyFase1 === "IN CARICO PRESIDIO" ||
          pratica.statoFlowdyFase1 === "IN REWORK AZIENDA" ||
          pratica.statoFlowdyFase1 === "PUBBLICATA" ||
          pratica.statoFlowdyFase1 === "RESPINTA" ||
          pratica.statoFlowdyFase1 === "APPROVATA")
      ) {
        pratica.showFase2 = false;
      }
      let codiceStatoFlowdyFase2 = pratica.statoFlowdyFase2;
      if (!pratica.statoFlowdyFase2 || pratica.statoFlowdyFase2.length == 0) {
        if (
          pratica.statoFlowdyFase1 === "ASSEGNATA" ||
          pratica.statoFlowdyFase1 === "DA ASSEGNARE" ||
          pratica.statoFlowdyFase1 === "IN ATTESA ODA"
        ) {
          codiceStatoFlowdyFase2 = pratica.statoFlowdyFase1;
        } else {
          codiceStatoFlowdyFase2 = "DA ASSEGNARE";
        }
      }
      let codiceStatoFlowdyFase3 = pratica.statoFlowdyFase3;
      if (!pratica.statoFlowdyFase3 || pratica.statoFlowdyFase3.length == 0) {
        if (
          pratica.statoFlowdyFase1 === "ASSEGNATA" ||
          pratica.statoFlowdyFase1 === "DA ASSEGNARE" ||
          pratica.statoFlowdyFase1 === "IN ATTESA ODA"
        ) {
          codiceStatoFlowdyFase3 = pratica.statoFlowdyFase1;
        } else {
          codiceStatoFlowdyFase3 = "DA ASSEGNARE";
        }
      }
      return {
        "CODICE INFRATEL": pratica.cui,
        "CODICE MIUR": pratica.codiceMiur,
        IMPRESA: pratica.azienda,
        REGIONE: pratica.regione,
        COMUNE: pratica.comune,
        INDIRIZZO: pratica.indirizzo,
        "TIPO SEDE": pratica.tipoSede,
        "TIPO SEDE EFFETTIVA": pratica.tipoSedeEffettiva
          ? pratica.tipoSedeEffettiva
          : "",
        "PF NO F1": pratica.showFase2 ? "1" : "0",
        "STATO INFRATEL FASE 1": pratica.codiceStatoInfratelFase1,
        "STATO FLOWDY FASE 1": pratica.statoFlowdyFase1,
        "DATA SOPRALLUOGO": pratica.dataSopralluogo
          ? this.utilService.formattaDataDaTimestampFirestore(
              pratica.dataSopralluogo,
            )
          : "",
        "PERMESSO ENTE PUBBLICO": pratica.servePermessoEntePubblico
          ? pratica.dataCaricamentoPermesso
            ? this.utilService.formattaDataDaTimestampFirestore(
                pratica.dataCaricamentoPermesso,
              )
            : "DA CARICARE"
          : "NO",
        "DATA INVIO FASE 1":
          pratica.codiceStatoInfratelFase1 === "1-2" ||
          pratica.codiceStatoInfratelFase1 === "1-4" ||
          pratica.codiceStatoInfratelFase1 === "1-6"
            ? this.utilService.formattaDataDaTimestampFirestore(
                pratica.dataInvioInfratelFase1,
              )
            : "",
        "DATA RISPOSTA FASE 1":
          pratica.codiceStatoInfratelFase1 === "1-2" ||
          pratica.codiceStatoInfratelFase1 === "1-6"
            ? this.utilService.formattaDataDaTimestampFirestore(
                pratica.dataRispostaInfratelFase1,
              )
            : "",
        "STATO PRONTOFIBRA": pratica.statoPF ? pratica.statoPF : "",
        "CAUSA KO PRONTOFIBRA":
          pratica.statoPF === "KO" ? pratica.categoriaKOProntofibra : "",
        "DATA ATTIVAZIONE": pratica.dataConfermaTS
          ? this.utilService.formattaDataDaTimestampFirestore(
              pratica.dataConfermaTS,
            )
          : "",
        "STATO INFRATEL FASE 2": pratica.codiceStatoInfratelFase2
          ? pratica.codiceStatoInfratelFase2
          : "2-1",
        "STATO FLOWDY FASE 2": pratica.statoFlowdyFase2
          ? pratica.statoFlowdyFase2
          : codiceStatoFlowdyFase2,
        "DATA APPUNTAMENTO": pratica.dataAppuntamentoFase2
          ? this.utilService.formattaDataDaTimestampFirestore(
              pratica.dataAppuntamentoFase2,
            )
          : "",
        "DATA INVIO FASE 2":
          pratica.codiceStatoInfratelFase1 === "2-2" ||
          pratica.codiceStatoInfratelFase1 === "2-4" ||
          pratica.codiceStatoInfratelFase1 === "2-6"
            ? this.utilService.formattaDataDaTimestampFirestore(
                pratica.dataInvioInfratelFase2,
              )
            : "",
        "DATA APPROVAZIONE FASE 2":
          pratica.codiceStatoInfratelFase2 == "2-6"
            ? this.utilService.formattaDataDaTimestampFirestore(
                pratica.dataRispostaInfratelFase2,
              )
            : "",
        "STATO INFRATEL FASE 3": pratica.codiceStatoInfratelFase3
          ? pratica.codiceStatoInfratelFase3
          : "3-1",
        "STATO FLOWDY FASE 3": pratica.statoFlowdyFase3
          ? pratica.statoFlowdyFase3
          : codiceStatoFlowdyFase3,
        "DATA INVIO FASE 3":
          pratica.codiceStatoInfratelFase1 === "3-2" ||
          pratica.codiceStatoInfratelFase1 === "3-4" ||
          pratica.codiceStatoInfratelFase1 === "3-6"
            ? this.utilService.formattaDataDaTimestampFirestore(
                pratica.dataInvioInfratelFase3,
              )
            : "",
        "DATA APPROVAZIONE FASE 3":
          pratica.codiceStatoInfratelFase3 == "3-6"
            ? this.utilService.formattaDataDaTimestampFirestore(
                pratica.dataRispostaInfratelFase3,
              )
            : "",
        "CAUSA SOPRALLLUOGO KO": pratica.causaSopralluogoKO
          ? pratica.causaSopralluogoKO.toUpperCase()
          : "",
        "SOPPRALLUOGO KO APPROVATO:": pratica.sopralluogoApprovato ? "1" : "0",
      };
    });

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(customData, {
      header: [],
    });
    worksheet["A1"] = { v: customHeaders[0] };
    worksheet["B1"] = { v: customHeaders[1] };
    worksheet["C1"] = { v: customHeaders[2] };
    worksheet["D1"] = { v: customHeaders[3] };
    worksheet["E1"] = { v: customHeaders[4] };

    const workbook: XLSX.WorkBook = {
      Sheets: { data: worksheet },
      SheetNames: ["data"],
    };

    const excelBuffer: any = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Salva il file Excel
    saveAs(blob, filename);
  }

  exportAllPraticheBando1ImpreseToExcel(
    data: PraticaFlowdy2_Firestore[],
    filename: string,
  ): void {
    const customHeaders = [
      "CODICE INFRATEL",
      "CODICE MIUR",
      "IMPRESA",
      "REGIONE",
      "COMUNE",
      "INDIRIZZO",
      "TIPO SEDE",
      "TIPO SEDE EFFETTIVA",
      "PF NO F1",
      "STATO INFRATEL FASE 1",
      "STATO FLOWDY FASE 1",
      "DATA SOPRALLUOGO",
      "PERMESSO ENTE PUBBLICO",
      "DATA INVIO FASE 1",
      "DATA RISPOSTA FASE 1",
      "STATO PRONTOFIBRA",
      "CAUSA KO PRONTOFIBRA",
      "DATA ATTIVAZIONE",
      "STATO INFRATEL FASE 2",
      "STATO FLOWDY FASE 2",
      "DATA APPUNTAMENTO",
      "DATA INVIO FASE 2",
      "DATA APPROVAZIONE FASE 2",
      "STATO INFRATEL FASE 3",
      "STATO FLOWDY FASE 3",
      "DATA INVIO FASE 3",
      "DATA APPROVAZIONE FASE 3",
      "CAUSA SOPRALLLUOGO KO",
      "SOPPRALLUOGO KO APPROVATO",
    ];
    const customData = data.map((pratica) => {
      if (pratica.dataAppuntamentoFase2) {
        const oggi = new Date();
        const dataAppuntamentoDaControllare = new Date(
          pratica.dataAppuntamentoFase2.toDate().getFullYear(),
          pratica.dataAppuntamentoFase2.toDate().getMonth(),
          pratica.dataAppuntamentoFase2.toDate().getDate() + 2,
        );
        if (
          pratica.statoFlowdyFase2 === "APPUNTAMENTO FISSATO" &&
          pratica.dataAppuntamentoFase2 &&
          !pratica.installazioneRouterOk &&
          dataAppuntamentoDaControllare < oggi
        ) {
          pratica.statoFlowdyFase2 = "APPUNTAMENTO MANCATO";
        }
      }
      if (
        pratica.showFase2 &&
        (pratica.statoFlowdyFase1 === "CONSEGNATA" ||
          pratica.statoFlowdyFase1 === "IN VERIFICA SMARTFIBER" ||
          pratica.statoFlowdyFase1 === "IN CARICO PRESIDIO" ||
          pratica.statoFlowdyFase1 === "IN REWORK AZIENDA" ||
          pratica.statoFlowdyFase1 === "PUBBLICATA" ||
          pratica.statoFlowdyFase1 === "RESPINTA" ||
          pratica.statoFlowdyFase1 === "APPROVATA")
      ) {
        pratica.showFase2 = false;
      }
      let codiceStatoFlowdyFase2 = pratica.statoFlowdyFase2;
      if (!pratica.statoFlowdyFase2 || pratica.statoFlowdyFase2.length == 0) {
        if (
          pratica.statoFlowdyFase1 === "ASSEGNATA" ||
          pratica.statoFlowdyFase1 === "DA ASSEGNARE" ||
          pratica.statoFlowdyFase1 === "IN ATTESA ODA"
        ) {
          codiceStatoFlowdyFase2 = pratica.statoFlowdyFase1;
        } else {
          codiceStatoFlowdyFase2 = "DA ASSEGNARE";
        }
      }
      let codiceStatoFlowdyFase3 = pratica.statoFlowdyFase3;
      if (!pratica.statoFlowdyFase3 || pratica.statoFlowdyFase3.length == 0) {
        if (
          pratica.statoFlowdyFase1 === "ASSEGNATA" ||
          pratica.statoFlowdyFase1 === "DA ASSEGNARE" ||
          pratica.statoFlowdyFase1 === "IN ATTESA ODA"
        ) {
          codiceStatoFlowdyFase3 = pratica.statoFlowdyFase1;
        } else {
          codiceStatoFlowdyFase3 = "DA ASSEGNARE";
        }
      }
      return {
        "CODICE INFRATEL": pratica.cui,
        "CODICE MIUR": pratica.codiceMiur,
        IMPRESA: pratica.azienda,
        REGIONE: pratica.regione,
        COMUNE: pratica.comune,
        INDIRIZZO: pratica.indirizzo,
        "TIPO SEDE": pratica.tipoSede,
        "TIPO SEDE EFFETTIVA": pratica.tipoSedeEffettiva
          ? pratica.tipoSedeEffettiva
          : "",
        "PF NO F1": pratica.showFase2 ? "1" : "0",
        "STATO INFRATEL FASE 1": pratica.codiceStatoInfratelFase1,
        "STATO FLOWDY FASE 1": pratica.statoFlowdyFase1,
        "DATA SOPRALLUOGO": pratica.dataSopralluogo
          ? this.utilService.formattaDataDaTimestampFirestore(
              pratica.dataSopralluogo,
            )
          : "",
        "PERMESSO ENTE PUBBLICO": pratica.servePermessoEntePubblico
          ? pratica.dataCaricamentoPermesso
            ? this.utilService.formattaDataDaTimestampFirestore(
                pratica.dataCaricamentoPermesso,
              )
            : "DA CARICARE"
          : "NO",
        "DATA INVIO FASE 1":
          pratica.codiceStatoInfratelFase1 === "1-2" ||
          pratica.codiceStatoInfratelFase1 === "1-4" ||
          pratica.codiceStatoInfratelFase1 === "1-6"
            ? this.utilService.formattaDataDaTimestampFirestore(
                pratica.dataInvioInfratelFase1,
              )
            : "",
        "DATA RISPOSTA FASE 1":
          pratica.codiceStatoInfratelFase1 === "1-2" ||
          pratica.codiceStatoInfratelFase1 === "1-6"
            ? this.utilService.formattaDataDaTimestampFirestore(
                pratica.dataRispostaInfratelFase1,
              )
            : "",
        "STATO PRONTOFIBRA": pratica.statoPF ? pratica.statoPF : "",
        "CAUSA KO PRONTOFIBRA":
          pratica.statoPF === "KO" ? pratica.categoriaKOProntofibra : "",
        "DATA ATTIVAZIONE": pratica.dataConfermaTS
          ? this.utilService.formattaDataDaTimestampFirestore(
              pratica.dataConfermaTS,
            )
          : "",
        "STATO INFRATEL FASE 2": pratica.codiceStatoInfratelFase2
          ? pratica.codiceStatoInfratelFase2
          : "2-1",
        "STATO FLOWDY FASE 2": pratica.statoFlowdyFase2
          ? pratica.statoFlowdyFase2
          : codiceStatoFlowdyFase2,
        "DATA APPUNTAMENTO": pratica.dataAppuntamentoFase2
          ? this.utilService.formattaDataDaTimestampFirestore(
              pratica.dataAppuntamentoFase2,
            )
          : "",
        "DATA INVIO FASE 2":
          pratica.codiceStatoInfratelFase1 === "2-2" ||
          pratica.codiceStatoInfratelFase1 === "2-4" ||
          pratica.codiceStatoInfratelFase1 === "2-6"
            ? this.utilService.formattaDataDaTimestampFirestore(
                pratica.dataInvioInfratelFase2,
              )
            : "",
        "DATA APPROVAZIONE FASE 2":
          pratica.codiceStatoInfratelFase2 == "2-6"
            ? this.utilService.formattaDataDaTimestampFirestore(
                pratica.dataRispostaInfratelFase2,
              )
            : "",
        "STATO INFRATEL FASE 3": pratica.codiceStatoInfratelFase3
          ? pratica.codiceStatoInfratelFase3
          : "3-1",
        "STATO FLOWDY FASE 3": pratica.statoFlowdyFase3
          ? pratica.statoFlowdyFase3
          : codiceStatoFlowdyFase3,
        "DATA INVIO FASE 3":
          pratica.codiceStatoInfratelFase1 === "3-2" ||
          pratica.codiceStatoInfratelFase1 === "3-4" ||
          pratica.codiceStatoInfratelFase1 === "3-6"
            ? this.utilService.formattaDataDaTimestampFirestore(
                pratica.dataInvioInfratelFase3,
              )
            : "",
        "DATA APPROVAZIONE FASE 3":
          pratica.codiceStatoInfratelFase3 == "3-6"
            ? this.utilService.formattaDataDaTimestampFirestore(
                pratica.dataRispostaInfratelFase3,
              )
            : "",
        "CAUSA SOPRALLLUOGO KO": pratica.causaSopralluogoKO
          ? pratica.causaSopralluogoKO.toUpperCase()
          : "",
        "SOPPRALLUOGO KO APPROVATO:": pratica.sopralluogoApprovato ? "1" : "0",
      };
    });

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(customData, {
      header: [],
    });
    worksheet["A1"] = { v: customHeaders[0] };
    worksheet["B1"] = { v: customHeaders[1] };
    worksheet["C1"] = { v: customHeaders[2] };
    worksheet["D1"] = { v: customHeaders[3] };
    worksheet["E1"] = { v: customHeaders[4] };

    const workbook: XLSX.WorkBook = {
      Sheets: { data: worksheet },
      SheetNames: ["data"],
    };

    const excelBuffer: any = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Salva il file Excel
    saveAs(blob, filename);
  }

  exportAllPraticheBando2ToExcel(
    data: PraticaFlowdy2_Firestore[],
    filename: string,
  ): void {
    const customHeaders = [
      "CODICE INFRATEL",
      "CODICE MIUR",
      "IMPRESA",
      "REGIONE",
      "COMUNE",
      "INDIRIZZO",
      "TIPO SEDE",
      "TIPO SEDE EFFETTIVA",
      "PF NO F1",
      "STATO INFRATEL FASE 1",
      "STATO FLOWDY FASE 1",
      "DATA SOPRALLUOGO",
      "PERMESSO ENTE PUBBLICO",
      "DATA INVIO FASE 1",
      "DATA RISPOSTA FASE 1",
      "STATO PRONTOFIBRA",
      "CAUSA KO PRONTOFIBRA",
      "DATA ATTIVAZIONE",
      "STATO INFRATEL FASE 2",
      "STATO FLOWDY FASE 2",
      "DATA APPUNTAMENTO",
      "DATA INVIO FASE 2",
      "DATA APPROVAZIONE FASE 2",
      "STATO INFRATEL FASE 3",
      "STATO FLOWDY FASE 3",
      "DATA INVIO FASE 3",
      "DATA APPROVAZIONE FASE 3",
      "CAUSA SOPRALLLUOGO KO",
      "SOPPRALLUOGO KO APPROVATO",
    ];
    const customData = data.map((pratica) => {
      if (pratica.dataAppuntamentoFase2) {
        const oggi = new Date();
        const dataAppuntamentoDaControllare = new Date(
          pratica.dataAppuntamentoFase2.toDate().getFullYear(),
          pratica.dataAppuntamentoFase2.toDate().getMonth(),
          pratica.dataAppuntamentoFase2.toDate().getDate() + 2,
        );
        if (
          pratica.statoFlowdyFase2 === "APPUNTAMENTO FISSATO" &&
          pratica.dataAppuntamentoFase2 &&
          !pratica.installazioneRouterOk &&
          dataAppuntamentoDaControllare < oggi
        ) {
          pratica.statoFlowdyFase2 = "APPUNTAMENTO MANCATO";
        }
      }

      if (
        pratica.showFase2 &&
        (pratica.statoFlowdyFase1 === "CONSEGNATA" ||
          pratica.statoFlowdyFase1 === "IN VERIFICA SMARTFIBER" ||
          pratica.statoFlowdyFase1 === "IN CARICO PRESIDIO" ||
          pratica.statoFlowdyFase1 === "IN REWORK AZIENDA" ||
          pratica.statoFlowdyFase1 === "PUBBLICATA" ||
          pratica.statoFlowdyFase1 === "RESPINTA" ||
          pratica.statoFlowdyFase1 === "APPROVATA")
      ) {
        pratica.showFase2 = false;
      }
      let codiceStatoFlowdyFase2 = pratica.statoFlowdyFase2;
      if (!pratica.statoFlowdyFase2 || pratica.statoFlowdyFase2.length == 0) {
        if (
          pratica.statoFlowdyFase1 === "ASSEGNATA" ||
          pratica.statoFlowdyFase1 === "DA ASSEGNARE" ||
          pratica.statoFlowdyFase1 === "IN ATTESA ODA"
        ) {
          codiceStatoFlowdyFase2 = pratica.statoFlowdyFase1;
        } else {
          codiceStatoFlowdyFase2 = "DA ASSEGNARE";
        }
      }
      let codiceStatoFlowdyFase3 = pratica.statoFlowdyFase3;
      if (!pratica.statoFlowdyFase3 || pratica.statoFlowdyFase3.length == 0) {
        if (
          pratica.statoFlowdyFase1 === "ASSEGNATA" ||
          pratica.statoFlowdyFase1 === "DA ASSEGNARE" ||
          pratica.statoFlowdyFase1 === "IN ATTESA ODA"
        ) {
          codiceStatoFlowdyFase3 = pratica.statoFlowdyFase1;
        } else {
          codiceStatoFlowdyFase3 = "DA ASSEGNARE";
        }
      }
      return {
        "CODICE INFRATEL": pratica.cui,
        "CODICE MIUR": pratica.codiceMiur,
        IMPRESA: pratica.azienda,
        REGIONE: pratica.regione,
        COMUNE: pratica.comune,
        INDIRIZZO: pratica.indirizzo,
        "TIPO SEDE": pratica.tipoSede,
        "TIPO SEDE EFFETTIVA": pratica.tipoSedeEffettiva
          ? pratica.tipoSedeEffettiva
          : "",
        "PF NO F1": pratica.showFase2 ? "1" : "0",
        "STATO INFRATEL FASE 1": pratica.codiceStatoInfratelFase1,
        "STATO FLOWDY FASE 1": pratica.statoFlowdyFase1,
        "DATA SOPRALLUOGO": pratica.dataSopralluogo
          ? this.utilService.formattaDataDaTimestampFirestore(
              pratica.dataSopralluogo,
            )
          : "",
        "PERMESSO ENTE PUBBLICO": pratica.servePermessoEntePubblico
          ? pratica.dataCaricamentoPermesso
            ? this.utilService.formattaDataDaTimestampFirestore(
                pratica.dataCaricamentoPermesso,
              )
            : "DA CARICARE"
          : "NO",
        "DATA INVIO FASE 1":
          pratica.codiceStatoInfratelFase1 === "1-2" ||
          pratica.codiceStatoInfratelFase1 === "1-4" ||
          pratica.codiceStatoInfratelFase1 === "1-6"
            ? this.utilService.formattaDataDaTimestampFirestore(
                pratica.dataInvioInfratelFase1,
              )
            : "",
        "DATA RISPOSTA FASE 1":
          pratica.codiceStatoInfratelFase1 === "1-2" ||
          pratica.codiceStatoInfratelFase1 === "1-6"
            ? this.utilService.formattaDataDaTimestampFirestore(
                pratica.dataRispostaInfratelFase1,
              )
            : "",
        "STATO PRONTOFIBRA": pratica.statoPF ? pratica.statoPF : "",
        "CAUSA KO PRONTOFIBRA":
          pratica.statoPF === "KO" ? pratica.categoriaKOProntofibra : "",
        "DATA ATTIVAZIONE": pratica.dataConfermaTS
          ? this.utilService.formattaDataDaTimestampFirestore(
              pratica.dataConfermaTS,
            )
          : "",
        "STATO INFRATEL FASE 2": pratica.codiceStatoInfratelFase2
          ? pratica.codiceStatoInfratelFase2
          : "2-1",
        "STATO FLOWDY FASE 2": pratica.statoFlowdyFase2
          ? pratica.statoFlowdyFase2
          : codiceStatoFlowdyFase2,
        "DATA APPUNTAMENTO": pratica.dataAppuntamentoFase2
          ? this.utilService.formattaDataDaTimestampFirestore(
              pratica.dataAppuntamentoFase2,
            )
          : "",
        "DATA INVIO FASE 2":
          pratica.codiceStatoInfratelFase1 === "2-2" ||
          pratica.codiceStatoInfratelFase1 === "2-4" ||
          pratica.codiceStatoInfratelFase1 === "2-6"
            ? this.utilService.formattaDataDaTimestampFirestore(
                pratica.dataInvioInfratelFase2,
              )
            : "",
        "DATA APPROVAZIONE FASE 2":
          pratica.codiceStatoInfratelFase2 == "2-6"
            ? this.utilService.formattaDataDaTimestampFirestore(
                pratica.dataRispostaInfratelFase2,
              )
            : "",
        "STATO INFRATEL FASE 3": pratica.codiceStatoInfratelFase3
          ? pratica.codiceStatoInfratelFase3
          : "3-1",
        "STATO FLOWDY FASE 3": pratica.statoFlowdyFase3
          ? pratica.statoFlowdyFase3
          : codiceStatoFlowdyFase3,
        "DATA INVIO FASE 3":
          pratica.codiceStatoInfratelFase1 === "3-2" ||
          pratica.codiceStatoInfratelFase1 === "3-4" ||
          pratica.codiceStatoInfratelFase1 === "3-6"
            ? this.utilService.formattaDataDaTimestampFirestore(
                pratica.dataInvioInfratelFase3,
              )
            : "",
        "DATA APPROVAZIONE FASE 3":
          pratica.codiceStatoInfratelFase3 == "3-6"
            ? this.utilService.formattaDataDaTimestampFirestore(
                pratica.dataRispostaInfratelFase3,
              )
            : "",
        "CAUSA SOPRALLLUOGO KO": pratica.causaSopralluogoKO
          ? pratica.causaSopralluogoKO.toUpperCase()
          : "",
        "SOPPRALLUOGO KO APPROVATO:": pratica.sopralluogoApprovato ? "1" : "0",
      };
    });

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(customData, {
      header: [],
    });
    worksheet["A1"] = { v: customHeaders[0] };
    worksheet["B1"] = { v: customHeaders[1] };
    worksheet["C1"] = { v: customHeaders[2] };
    worksheet["D1"] = { v: customHeaders[3] };
    worksheet["E1"] = { v: customHeaders[4] };

    const workbook: XLSX.WorkBook = {
      Sheets: { data: worksheet },
      SheetNames: ["data"],
    };

    const excelBuffer: any = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Salva il file Excel
    saveAs(blob, filename);
  }

  exportAllPraticheBando2ImpreseToExcel(
    data: PraticaFlowdy2_Firestore[],
    filename: string,
  ): void {
    const customHeaders = [
      "CODICE INFRATEL",
      "CODICE MIUR",
      "IMPRESA",
      "REGIONE",
      "COMUNE",
      "INDIRIZZO",
      "TIPO SEDE",
      "TIPO SEDE EFFETTIVA",
      "PF NO F1",
      "STATO INFRATEL FASE 1",
      "STATO FLOWDY FASE 1",
      "DATA SOPRALLUOGO",
      "PERMESSO ENTE PUBBLICO",
      "DATA INVIO FASE 1",
      "DATA RISPOSTA FASE 1",
      "STATO PRONTOFIBRA",
      "CAUSA KO PRONTOFIBRA",
      "DATA ATTIVAZIONE",
      "STATO INFRATEL FASE 2",
      "STATO FLOWDY FASE 2",
      "DATA APPUNTAMENTO",
      "DATA INVIO FASE 2",
      "DATA APPROVAZIONE FASE 2",
      "STATO INFRATEL FASE 3",
      "STATO FLOWDY FASE 3",
      "DATA INVIO FASE 3",
      "DATA APPROVAZIONE FASE 3",
      "CAUSA SOPRALLLUOGO KO",
      "SOPPRALLUOGO KO APPROVATO",
    ];
    const customData = data.map((pratica) => {
      if (pratica.dataAppuntamentoFase2) {
        const oggi = new Date();
        const dataAppuntamentoDaControllare = new Date(
          pratica.dataAppuntamentoFase2.toDate().getFullYear(),
          pratica.dataAppuntamentoFase2.toDate().getMonth(),
          pratica.dataAppuntamentoFase2.toDate().getDate() + 2,
        );
        if (
          pratica.statoFlowdyFase2 === "APPUNTAMENTO FISSATO" &&
          pratica.dataAppuntamentoFase2 &&
          !pratica.installazioneRouterOk &&
          dataAppuntamentoDaControllare < oggi
        ) {
          pratica.statoFlowdyFase2 = "APPUNTAMENTO MANCATO";
        }
      }

      if (
        pratica.showFase2 &&
        (pratica.statoFlowdyFase1 === "CONSEGNATA" ||
          pratica.statoFlowdyFase1 === "IN VERIFICA SMARTFIBER" ||
          pratica.statoFlowdyFase1 === "IN CARICO PRESIDIO" ||
          pratica.statoFlowdyFase1 === "IN REWORK AZIENDA" ||
          pratica.statoFlowdyFase1 === "PUBBLICATA" ||
          pratica.statoFlowdyFase1 === "RESPINTA" ||
          pratica.statoFlowdyFase1 === "APPROVATA")
      ) {
        pratica.showFase2 = false;
      }
      let codiceStatoFlowdyFase2 = pratica.statoFlowdyFase2;
      if (!pratica.statoFlowdyFase2 || pratica.statoFlowdyFase2.length == 0) {
        if (
          pratica.statoFlowdyFase1 === "ASSEGNATA" ||
          pratica.statoFlowdyFase1 === "DA ASSEGNARE" ||
          pratica.statoFlowdyFase1 === "IN ATTESA ODA"
        ) {
          codiceStatoFlowdyFase2 = pratica.statoFlowdyFase1;
        } else {
          codiceStatoFlowdyFase2 = "DA ASSEGNARE";
        }
      }
      let codiceStatoFlowdyFase3 = pratica.statoFlowdyFase3;
      if (!pratica.statoFlowdyFase3 || pratica.statoFlowdyFase3.length == 0) {
        if (
          pratica.statoFlowdyFase1 === "ASSEGNATA" ||
          pratica.statoFlowdyFase1 === "DA ASSEGNARE" ||
          pratica.statoFlowdyFase1 === "IN ATTESA ODA"
        ) {
          codiceStatoFlowdyFase3 = pratica.statoFlowdyFase1;
        } else {
          codiceStatoFlowdyFase3 = "DA ASSEGNARE";
        }
      }
      return {
        "CODICE INFRATEL": pratica.cui,
        "CODICE MIUR": pratica.codiceMiur,
        IMPRESA: pratica.azienda,
        REGIONE: pratica.regione,
        COMUNE: pratica.comune,
        INDIRIZZO: pratica.indirizzo,
        "TIPO SEDE": pratica.tipoSede,
        "TIPO SEDE EFFETTIVA": pratica.tipoSedeEffettiva
          ? pratica.tipoSedeEffettiva
          : "",
        "PF NO F1": pratica.showFase2 ? "1" : "0",
        "STATO INFRATEL FASE 1": pratica.codiceStatoInfratelFase1,
        "STATO FLOWDY FASE 1": pratica.statoFlowdyFase1,
        "DATA SOPRALLUOGO": pratica.dataSopralluogo
          ? this.utilService.formattaDataDaTimestampFirestore(
              pratica.dataSopralluogo,
            )
          : "",
        "PERMESSO ENTE PUBBLICO": pratica.servePermessoEntePubblico
          ? pratica.dataCaricamentoPermesso
            ? this.utilService.formattaDataDaTimestampFirestore(
                pratica.dataCaricamentoPermesso,
              )
            : "DA CARICARE"
          : "NO",
        "DATA INVIO FASE 1":
          pratica.codiceStatoInfratelFase1 === "1-2" ||
          pratica.codiceStatoInfratelFase1 === "1-4" ||
          pratica.codiceStatoInfratelFase1 === "1-6"
            ? this.utilService.formattaDataDaTimestampFirestore(
                pratica.dataInvioInfratelFase1,
              )
            : "",
        "DATA RISPOSTA FASE 1":
          pratica.codiceStatoInfratelFase1 === "1-2" ||
          pratica.codiceStatoInfratelFase1 === "1-6"
            ? this.utilService.formattaDataDaTimestampFirestore(
                pratica.dataRispostaInfratelFase1,
              )
            : "",
        "STATO PRONTOFIBRA": pratica.statoPF ? pratica.statoPF : "",
        "CAUSA KO PRONTOFIBRA":
          pratica.statoPF === "KO" ? pratica.categoriaKOProntofibra : "",
        "DATA ATTIVAZIONE": pratica.dataConfermaTS
          ? this.utilService.formattaDataDaTimestampFirestore(
              pratica.dataConfermaTS,
            )
          : "",
        "STATO INFRATEL FASE 2": pratica.codiceStatoInfratelFase2
          ? pratica.codiceStatoInfratelFase2
          : "2-1",
        "STATO FLOWDY FASE 2": pratica.statoFlowdyFase2
          ? pratica.statoFlowdyFase2
          : codiceStatoFlowdyFase2,
        "DATA APPUNTAMENTO": pratica.dataAppuntamentoFase2
          ? this.utilService.formattaDataDaTimestampFirestore(
              pratica.dataAppuntamentoFase2,
            )
          : "",
        "DATA INVIO FASE 2":
          pratica.codiceStatoInfratelFase1 === "2-2" ||
          pratica.codiceStatoInfratelFase1 === "2-4" ||
          pratica.codiceStatoInfratelFase1 === "2-6"
            ? this.utilService.formattaDataDaTimestampFirestore(
                pratica.dataInvioInfratelFase2,
              )
            : "",
        "DATA APPROVAZIONE FASE 2":
          pratica.codiceStatoInfratelFase2 == "2-6"
            ? this.utilService.formattaDataDaTimestampFirestore(
                pratica.dataRispostaInfratelFase2,
              )
            : "",
        "STATO INFRATEL FASE 3": pratica.codiceStatoInfratelFase3
          ? pratica.codiceStatoInfratelFase3
          : "3-1",
        "STATO FLOWDY FASE 3": pratica.statoFlowdyFase3
          ? pratica.statoFlowdyFase3
          : codiceStatoFlowdyFase3,
        "DATA INVIO FASE 3":
          pratica.codiceStatoInfratelFase1 === "3-2" ||
          pratica.codiceStatoInfratelFase1 === "3-4" ||
          pratica.codiceStatoInfratelFase1 === "3-6"
            ? this.utilService.formattaDataDaTimestampFirestore(
                pratica.dataInvioInfratelFase3,
              )
            : "",
        "DATA APPROVAZIONE FASE 3":
          pratica.codiceStatoInfratelFase3 == "3-6"
            ? this.utilService.formattaDataDaTimestampFirestore(
                pratica.dataRispostaInfratelFase3,
              )
            : "",
        "CAUSA SOPRALLLUOGO KO": pratica.causaSopralluogoKO
          ? pratica.causaSopralluogoKO.toUpperCase()
          : "",
        "SOPPRALLUOGO KO APPROVATO:": pratica.sopralluogoApprovato ? "1" : "0",
      };
    });
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(customData, {
      header: [],
    });
    worksheet["A1"] = { v: customHeaders[0] };
    worksheet["B1"] = { v: customHeaders[1] };
    worksheet["C1"] = { v: customHeaders[2] };
    worksheet["D1"] = { v: customHeaders[3] };
    worksheet["E1"] = { v: customHeaders[4] };

    const workbook: XLSX.WorkBook = {
      Sheets: { data: worksheet },
      SheetNames: ["data"],
    };

    const excelBuffer: any = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Salva il file Excel
    saveAs(blob, filename);
  }

  exportPreventiviOpereExtraToExcel(
    data: PraticaFlowdy2_Firestore[],
    filename: string,
  ): void {
    const customHeaders = [];
    customHeaders.push(
      "CUI",
      "IMPRESA FASE 1",
      "REGIONE",
      "STATO PREVENTIVO",
      "DATA",
      "IMPORTO",
    );

    let customData = null;
    customData = data.map((pratica) => ({
      CUI: pratica.cui,
      "IMPRESA FASE 1": pratica.aziendaFase1,
      REGIONE: pratica.regione,
      "STATO PREVENTIVO": pratica.statoPreventivo,
      DATA: pratica.dataEsitoPreventivo
        ? this.utilService.formattaDataDaTimestampFirestore(
            pratica.dataEsitoPreventivo,
          )
        : this.utilService.formattaDataDaTimestampFirestore(
            pratica.dataPresentazionePreventivo,
          ),
      IMPORTO: pratica.preventivo ? Number(pratica.preventivo.toFixed(2)) : "",
    }));

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(customData);

    /*   // Calcola il totale degli importi
  const totale = data.reduce((sum, pratica) => sum + (pratica.preventivo || 0), 0);
  
  // Aggiungi riga con il totale
  const lastRow = data.length + 2; // +1 per header, +1 per nuova riga
  XLSX.utils.sheet_add_aoa(worksheet, [['', '', '', '', 'TOTALE', totale]], { origin: lastRow }); */

    const workbook: XLSX.WorkBook = {
      Sheets: { data: worksheet },
      SheetNames: ["data"],
    };

    const excelBuffer: any = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, filename);
  }

  exportPraticheFase1ToExcel(
    data: PraticaFlowdy2_Firestore[],
    filename: string,
    isImpresa: Boolean,
  ): void {
    const customHeaders = [];
    customHeaders.push("CUI");
    if (!isImpresa) {
      customHeaders.push("IMPRESA");
    }
    customHeaders.push(
      "LOTTO",
      "REGIONE",
      "COMUNE",
      "CODICE MIUR",
      "DENOMINAZIONE",
      "INDIRIZZO",
      "TIPO SEDE",
      "TIPO SEDE EFFETTIVA",
      "STATO INFRATEL",
      "STATO PRATICA",
      "DATA SOPRALLUOGO PIANIFICATO",
      "DATA SOPRALLUOGO ESEGUITO",
      "SDF PRINCIPALE",
      "SDF BK",
      "TGU FTTO PRINCIPALE",
      "TGU GIGA PRINCIPALE",
      "TGU FTTO BK",
      "TGU GIGA BK",
    );
    let customData = null;
    if (!isImpresa) {
      customData = data.map((pratica) => ({
        CUI: pratica.cui,
        IMPRESA: pratica.aziendaFase1,
        LOTTO: pratica.lotto,
        REGIONE: pratica.regione,
        COMUNE: pratica.comune,
        "CODICE MIUR": pratica.codiceMiur,
        DENOMINAZIONE: pratica.denominazione,
        INDIRIZZO: pratica.indirizzo,
        "TIPO SEDE": pratica.tipoSede,
        "TIPO SEDE EFFETTIVA": pratica.tipoSedeEffettiva
          ? pratica.tipoSedeEffettiva
          : "",
        "STATO INFRATEL": pratica.codiceStatoInfratelFase1,
        "STATO PRATICA": pratica.statoFlowdyFase1,
        "DATA SOPRALLUOGO PIANIFICATO": pratica.dataSopralluogo
          ? this.utilService.formattaDataDaTimestampFirestore(
              pratica.dataSopralluogo,
            )
          : "",
        "DATA SOPRALLUOGO ESEGUITO": pratica.dataSopralluogo
          ? this.utilService.formattaDataDaTimestampFirestore(
              pratica.dataSopralluogo,
            )
          : "",
        "SDF PRINCIPALE": pratica.sdfPrincipale,
        "SDF BK": pratica.sdfBackup,
        "TGU FTTO PRINCIPALE": pratica.tguFttoPrincipale
          ? pratica.tguFttoPrincipale
          : "",
        "TGU GIGA PRINCIPALE": pratica.tguGigaPrincipale
          ? pratica.tguGigaPrincipale
          : "",
        "TGU FTTO BK": pratica.tguFttoBackup ? pratica.tguFttoBackup : "",
        "TGU GIGA BK": pratica.tguGigaBackup ? pratica.tguGigaBackup : "",
      }));
    } else {
      customData = data.map((pratica) => ({
        CUI: pratica.cui,
        REGIONE: pratica.regione,
        COMUNE: pratica.comune,
        INDIRIZZO: pratica.indirizzo,
        "TIPO SEDE": pratica.tipoSede,
        "TIPO SEDE EFFETTIVA": pratica.tipoSedeEffettiva
          ? pratica.tipoSedeEffettiva
          : "",
        "STATO INFRATEL": pratica.codiceStatoInfratelFase1,
        "STATO PRATICA": pratica.statoFlowdyFase1,
      }));
    }

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(customData, {
      header: [],
    });
    worksheet["A1"] = { v: customHeaders[0] };
    worksheet["B1"] = { v: customHeaders[1] };
    worksheet["C1"] = { v: customHeaders[2] };
    worksheet["D1"] = { v: customHeaders[3] };
    worksheet["E1"] = { v: customHeaders[4] };

    const workbook: XLSX.WorkBook = {
      Sheets: { data: worksheet },
      SheetNames: ["data"],
    };

    const excelBuffer: any = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Salva il file Excel
    saveAs(blob, filename);
  }

  exportPraticheFase2ToExcel(
    data: PraticaFlowdy2_Firestore[],
    filename: string,
    isImpresa: Boolean,
  ): void {
    const customHeaders = [];
    customHeaders.push("CUI");
    if (!isImpresa) {
      customHeaders.push("IMPRESA");
    }
    customHeaders.push(
      "LOTTO",
      "REGIONE",
      "PROVINCIA",
      "COMUNE",
      "CODICE MIUR",
      "DENOMINAZIONE",
      "INDIRIZZO",
      "TIPO SEDE",
      "TIPO SEDE EFFETTIVA",
      "STATO PRONTO FIBRA",
      "DATA PF",
      "STATO INFRATEL",
      "STATO PRATICA",
      "DATA APPUNTAMENTO",
      "SDF PRINCIPALE",
      "SDF BK",
      "TGU FTTO PRINCIPALE",
      "TGU GIGA PRINCIPALE",
      "TGU FTTO BK",
      "TGU GIGA BK",
    );
    let customData = null;
    if (!isImpresa) {
      customData = data.map((pratica) => ({
        CUI: pratica.cui,
        IMPRESA: pratica.azienda,
        LOTTO: pratica.lotto,
        REGIONE: pratica.regione,
        PROVINCIA: pratica.provincia,
        COMUNE: pratica.comune,

        "CODICE MIUR": pratica.codiceMiur,
        DENOMINAZIONE: pratica.denominazione,
        INDIRIZZO: pratica.indirizzo,
        "TIPO SEDE": pratica.tipoSede,
        "TIPO SEDE EFFETTIVA": pratica.tipoSedeEffettiva
          ? pratica.tipoSedeEffettiva
          : "",
        "STATO PRONTO FIBRA": pratica.statoPF ? pratica.statoPF : "",
        "DATA PF": this.utilService.formattaDataPFDaTimestampFirestore(pratica),
        "STATO INFRATEL": pratica.codiceStatoInfratelFase2,
        "STATO PRATICA": pratica.statoFlowdyFase2,
        "DATA APPUNTAMENTO": pratica.dataAppuntamentoFase2
          ? this.utilService.formattaDataDaTimestampFirestore(
              pratica.dataAppuntamentoFase2,
            )
          : "",
        "SDF PRINCIPALE": pratica.sdfPrincipale,
        "SDF BK": pratica.sdfBackup,
        "TGU FTTO PRINCIPALE": pratica.tguFttoPrincipale
          ? pratica.tguFttoPrincipale
          : "",
        "TGU GIGA PRINCIPALE": pratica.tguGigaPrincipale
          ? pratica.tguGigaPrincipale
          : "",
        "TGU FTTO BK": pratica.tguFttoBackup ? pratica.tguFttoBackup : "",
        "TGU GIGA BK": pratica.tguGigaBackup ? pratica.tguGigaBackup : "",
      }));
    } else {
      customData = data.map((pratica) => ({
        CUI: pratica.cui,
        REGIONE: pratica.regione,
        PROVINCIA: pratica.provincia,
        COMUNE: pratica.comune,
        INDIRIZZO: pratica.indirizzo,
        "TIPO SEDE": pratica.tipoSede,
        "TIPO SEDE EFFETTIVA": pratica.tipoSedeEffettiva
          ? pratica.tipoSedeEffettiva
          : "",
        "STATO PRONTO FIBRA": pratica.statoPF ? pratica.statoPF : "",
        "DATA PF": this.utilService.formattaDataPFDaTimestampFirestore(pratica),
        "STATO INFRATEL": pratica.codiceStatoInfratelFase2,
        "STATO PRATICA": pratica.statoFlowdyFase2,
        "DATA APPUNTAMENTO": pratica.dataAppuntamentoFase2
          ? this.utilService.formattaDataDaTimestampFirestore(
              pratica.dataAppuntamentoFase2,
            )
          : "",
        "SDF PRINCIPALE": pratica.sdfPrincipale,
        "SDF BK": pratica.sdfBackup,
        "TGU FTTO PRINCIPALE": pratica.tguFttoPrincipale
          ? pratica.tguFttoPrincipale
          : "",
        "TGU GIGA PRINCIPALE": pratica.tguGigaPrincipale
          ? pratica.tguGigaPrincipale
          : "",
        "TGU FTTO BK": pratica.tguFttoBackup ? pratica.tguFttoBackup : "",
        "TGU GIGA BK": pratica.tguGigaBackup ? pratica.tguGigaBackup : "",
      }));
    }

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(customData, {
      header: [],
    });
    worksheet["A1"] = { v: customHeaders[0] };
    worksheet["B1"] = { v: customHeaders[1] };
    worksheet["C1"] = { v: customHeaders[2] };
    worksheet["D1"] = { v: customHeaders[3] };
    worksheet["E1"] = { v: customHeaders[4] };

    const workbook: XLSX.WorkBook = {
      Sheets: { data: worksheet },
      SheetNames: ["data"],
    };

    const excelBuffer: any = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Salva il file Excel
    saveAs(blob, filename);
  }

  exportPraticheFase3ToExcel(
    data: PraticaFlowdy2_Firestore[],
    filename: string,
    isImpresa: Boolean,
  ): void {
    const customHeaders = [];
    customHeaders.push("CUI");
    if (!isImpresa) {
      customHeaders.push("IMPRESA");
    }
    customHeaders.push(
      "LOTTO",
      "REGIONE",
      "PROVINCIA",
      "COMUNE",
      "CODICE MIUR",
      "DENOMINAZIONE",
      "INDIRIZZO EFFETTIVO",
      "TIPO SEDE",
      "TIPO SEDE EFFETTIVA",
      "STATO INFRATEL",
      "STATO PRATICA",
      "SDF PRINCIPALE",
      "SDF BK",
      "TGU FTTO PRINCIPALE",
      "TGU GIGA PRINCIPALE",
      "TGU FTTO BK",
      "TGU GIGA BK",
    );

    let customData = null;
    if (!isImpresa) {
      customData = data.map((pratica) => ({
        CUI: pratica.cui,
        IMPRESA: pratica.azienda,
        LOTTO: pratica.lotto,
        REGIONE: pratica.regione,
        PROVINCIA: pratica.provincia,
        COMUNE: pratica.comune,
        "CODICE MIUR": pratica.codiceMiur,
        DENOMINAZIONE: pratica.denominazione,
        "INDIRIZZO EFFETTIVO": pratica.indirizzo,
        INDIRIZZO: pratica.indirizzo,
        "TIPO SEDE": pratica.tipoSede,
        "TIPO SEDE EFFETTIVA": pratica.tipoSedeEffettiva
          ? pratica.tipoSedeEffettiva
          : "",
        "STATO INFRATEL": pratica.codiceStatoInfratelFase3,
        "STATO PRATICA": pratica.statoFlowdyFase3,
        "SDF PRINCIPALE": pratica.sdfPrincipale,
        "SDF BK": pratica.sdfBackup,
        "TGU FTTO PRINCIPALE": pratica.tguFttoPrincipale
          ? pratica.tguFttoPrincipale
          : "",
        "TGU GIGA PRINCIPALE": pratica.tguGigaPrincipale
          ? pratica.tguGigaPrincipale
          : "",
        "TGU FTTO BK": pratica.tguFttoBackup ? pratica.tguFttoBackup : "",
        "TGU GIGA BK": pratica.tguGigaBackup ? pratica.tguGigaBackup : "",
      }));
    } else {
      customData = data.map((pratica) => ({
        CUI: pratica.cui,
        REGIONE: pratica.regione,
        PROVINCIA: pratica.provincia,
        COMUNE: pratica.comune,
        "CODICE MIUR": pratica.codiceMiur,
        DENOMINAZIONE: pratica.denominazione,
        "INDIRIZZO EFFETTIVO": pratica.indirizzo,
        INDIRIZZO: pratica.indirizzo,
        "TIPO SEDE": pratica.tipoSede,
        "TIPO SEDE EFFETTIVA": pratica.tipoSedeEffettiva
          ? pratica.tipoSedeEffettiva
          : "",
        "STATO INFRATEL": pratica.codiceStatoInfratelFase3,
        "STATO PRATICA": pratica.statoFlowdyFase3,
        "SDF PRINCIPALE": pratica.sdfPrincipale,
        "SDF BK": pratica.sdfBackup,
        "TGU FTTO PRINCIPALE": pratica.tguFttoPrincipale
          ? pratica.tguFttoPrincipale
          : "",
        "TGU GIGA PRINCIPALE": pratica.tguGigaPrincipale
          ? pratica.tguGigaPrincipale
          : "",
        "TGU FTTO BK": pratica.tguFttoBackup ? pratica.tguFttoBackup : "",
        "TGU GIGA BK": pratica.tguGigaBackup ? pratica.tguGigaBackup : "",
      }));
    }

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(customData, {
      header: [],
    });
    worksheet["A1"] = { v: customHeaders[0] };
    worksheet["B1"] = { v: customHeaders[1] };
    worksheet["C1"] = { v: customHeaders[2] };
    worksheet["D1"] = { v: customHeaders[3] };
    worksheet["E1"] = { v: customHeaders[4] };

    const workbook: XLSX.WorkBook = {
      Sheets: { data: worksheet },
      SheetNames: ["data"],
    };

    const excelBuffer: any = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Salva il file Excel
    saveAs(blob, filename);
  }

  exportPraticheKOToExcel(
    data: PraticaFlowdy2_Firestore[],
    filename: string,
    isImpresa: Boolean,
  ): void {
    const customHeaders = [];
    customHeaders.push("CUI");
    if (!isImpresa) {
      customHeaders.push("IMPRESA");
    }
    customHeaders.push(
      "REGIONE",
      "COMUNE",
      "INDIRIZZO",
      "TIPO SEDE",
      "TIPO SEDE EFFETTIVA",
      "CAUSA KO",
      "DATA SOPRALLUOGO KO",
      "NOTE SOPRALLUOGO KO",
      "VINCOLO",
      "NOTE VINCOLO",
    );
    let customData = null;
    if (!isImpresa) {
      customData = data.map((pratica) => ({
        CUI: pratica.cui,
        IMPRESA: pratica.azienda,
        REGIONE: pratica.regione,
        COMUNE: pratica.comune,
        INDIRIZZO: pratica.indirizzo,
        "TIPO SEDE": pratica.tipoSede,
        "TIPO SEDE EFFETTIVA": pratica.tipoSedeEffettiva
          ? pratica.tipoSedeEffettiva
          : "",
        "CAUSA KO": pratica.causaSopralluogoKO,
        "DATA SOPRALLUOGO KO":
          this.utilService.formattaDataDaTimestampFirestore(
            pratica.dataUltimaModificaFase1,
          ),
        "NOTE SOPRALLUOGO KO": pratica.noteSopralluogo,
        VINCOLO: pratica.tipoVincolo,
        "NOTE VINCOLO": pratica.noteVincolo,
      }));
    } else {
      customData = data.map((pratica) => ({
        CUI: pratica.cui,
        REGIONE: pratica.regione,
        COMUNE: pratica.comune,
        INDIRIZZO: pratica.indirizzo,
        "TIPO SEDE": pratica.tipoSede,
        "TIPO SEDE EFFETTIVA": pratica.tipoSedeEffettiva
          ? pratica.tipoSedeEffettiva
          : "",
        "CAUSA KO": pratica.causaSopralluogoKO,
        "DATA SOPRALLUOGO KO":
          this.utilService.formattaDataDaTimestampFirestore(
            pratica.dataUltimaModificaFase1,
          ),
        "NOTE SOPRALLUOGO KO": pratica.noteSopralluogo,
      }));
    }

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(customData, {
      header: [],
    });
    worksheet["A1"] = { v: customHeaders[0] };
    worksheet["B1"] = { v: customHeaders[1] };
    worksheet["C1"] = { v: customHeaders[2] };
    worksheet["D1"] = { v: customHeaders[3] };
    worksheet["E1"] = { v: customHeaders[4] };

    const workbook: XLSX.WorkBook = {
      Sheets: { data: worksheet },
      SheetNames: ["data"],
    };

    const excelBuffer: any = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Salva il file Excel
    saveAs(blob, filename);
  }

  exportImpreseToExcel(data: Stats[], filename: string): void {
    const customHeaders = [
      "RAGIONE SOCIALE",
      "SCUOLE ASSEGNATE",
      "SCUOLE IN CARICO",
      "SCUOLE CONSEGNATE",
      "SCUOLE IN REWORK",
    ];
    const customData = data.map((item) => ({
      "RAGIONE SOCIALE": item.ragioneSociale,
      "SCUOLE ASSEGNATE": item.numeroPraticheScuolaAssegnate,
      "SCUOLE IN CARICO": item.numeroPraticheScuolaInCarico,
      "SCUOLE CONSEGNATE": item.numeroPraticheScuolaConsegnate,
      "SCUOLE IN REWORK": item.numeroPraticheScuolaInRework,
    }));
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(customData, {
      header: [],
    });
    worksheet["A1"] = { v: customHeaders[0] };
    worksheet["B1"] = { v: customHeaders[1] };
    worksheet["C1"] = { v: customHeaders[2] };
    worksheet["D1"] = { v: customHeaders[3] };
    worksheet["E1"] = { v: customHeaders[4] };

    const workbook: XLSX.WorkBook = {
      Sheets: { data: worksheet },
      SheetNames: ["data"],
    };

    const excelBuffer: any = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Salva il file Excel
    saveAs(blob, filename);
  }

  exportCentraliToExcel(data: Centrale[], filename: string): void {
    const customHeaders = [
      "CODICE ACL",
      "CLLI",
      "CLLI ATTESTAZIONE",
      "DENOMINAZIONE",
      "INDIRIZZO",
      "COMUNE",
      "LATITUDINE",
      "LONGITUDINE",
    ];
    const customData = data.map((item) => ({
      "CODICE ACL": item.idTim,
      CLLI: item.clli,
      "CLLI ATTESTAZIONE": item.clliAttestazione,
      DENOMINAZIONE: item.denominazione,
      INDIRIZZO: item.indirizzo,
      COMUNE: item.comune.denominazione,
      LATITUDINE: item.latitudine,
      LONGITUDINE: item.longitudine,
    }));
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(customData, {
      header: [],
    });
    worksheet["A1"] = { v: customHeaders[0] };
    worksheet["B1"] = { v: customHeaders[1] };
    worksheet["C1"] = { v: customHeaders[2] };
    worksheet["D1"] = { v: customHeaders[3] };
    worksheet["E1"] = { v: customHeaders[4] };
    worksheet["F1"] = { v: customHeaders[5] };
    worksheet["G1"] = { v: customHeaders[6] };
    worksheet["H1"] = { v: customHeaders[7] };

    const workbook: XLSX.WorkBook = {
      Sheets: { data: worksheet },
      SheetNames: ["data"],
    };

    const excelBuffer: any = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    saveAs(blob, filename);
  }

  exportSopralluoghiToExcel(
    data: DatiSopralluogoPerImpresa[],
    filename: string,
  ): void {
    const customHeaders = [
      "IMPRESA",
      "NO SOPRALLUOGO",
      "NO SOPRALLUOGO (PF)",
      "SOPRALLUOGO PIANIFICATO",
      "SOPRALLUOGO ESEGUITO",
      "SOPRALLUOGO KO",

      "TOTALE",
    ];
    let totaleNoSopralluogo: number = 0;
    let totaleNoSopralluogoPF: number = 0;
    let totaleSopralluoghiPianificati: number = 0;
    let totaleSopralluoghiOK: number = 0;
    let totaleSopralluoghiKO: number = 0;
    let totale: number = 0;

    data.map((sopralluoghiPerImpresa) => {
      totaleNoSopralluogo += Number(sopralluoghiPerImpresa.noSopralluogo);
      totaleNoSopralluogoPF += Number(sopralluoghiPerImpresa.noSopralluogoPF);
      totaleSopralluoghiPianificati += Number(
        sopralluoghiPerImpresa.sopralluogoPianificato,
      );
      totaleSopralluoghiOK += Number(
        sopralluoghiPerImpresa.sopralluogoEseguito,
      );
      totaleSopralluoghiKO += Number(sopralluoghiPerImpresa.sopralluogoKO);
      totale +=
        Number(sopralluoghiPerImpresa.noSopralluogo) +
        Number(sopralluoghiPerImpresa.noSopralluogoPF) +
        Number(sopralluoghiPerImpresa.sopralluogoPianificato) +
        Number(sopralluoghiPerImpresa.sopralluogoEseguito) +
        Number(sopralluoghiPerImpresa.sopralluogoKO);
    });
    const customData = data.map((sopralluoghiPerImpresa) => ({
      IMPRESA: sopralluoghiPerImpresa.impresa,
      "NO SOPRALLUOGO": sopralluoghiPerImpresa.noSopralluogo
        ? sopralluoghiPerImpresa.noSopralluogo
        : 0,
      "NO SOPRALLUOGO (PF)": sopralluoghiPerImpresa.noSopralluogoPF
        ? sopralluoghiPerImpresa.noSopralluogoPF
        : 0,
      "SOPRALLUOGO PIANIFICATO": sopralluoghiPerImpresa.sopralluogoPianificato
        ? sopralluoghiPerImpresa.sopralluogoPianificato
        : 0,
      "SOPRALLUOGO ESEGUITO": sopralluoghiPerImpresa.sopralluogoEseguito
        ? sopralluoghiPerImpresa.sopralluogoEseguito
        : 0,
      "SOPRALLUOGO KO": sopralluoghiPerImpresa.sopralluogoKO
        ? sopralluoghiPerImpresa.sopralluogoKO
        : 0,
      TOTALE: sopralluoghiPerImpresa.totale ? sopralluoghiPerImpresa.totale : 0,
    }));
    customData.push({
      IMPRESA: "",
      "NO SOPRALLUOGO": totaleNoSopralluogo,
      "NO SOPRALLUOGO (PF)": totaleNoSopralluogoPF,
      "SOPRALLUOGO PIANIFICATO": totaleSopralluoghiPianificati,
      "SOPRALLUOGO KO": totaleSopralluoghiKO,
      "SOPRALLUOGO ESEGUITO": totaleSopralluoghiOK,
      TOTALE: totale,
    });
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(customData, {
      header: [],
    });
    worksheet["A1"] = { v: customHeaders[0] };
    worksheet["B1"] = { v: customHeaders[1] };
    worksheet["C1"] = { v: customHeaders[2] };
    worksheet["D1"] = { v: customHeaders[3] };
    worksheet["E1"] = { v: customHeaders[4] };

    const workbook: XLSX.WorkBook = {
      Sheets: { data: worksheet },
      SheetNames: ["data"],
    };

    const excelBuffer: any = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Salva il file Excel
    saveAs(blob, filename);
  }

  exportVincoliOFToExcel(
    dataComplessivo: any[],
    pratiche: PraticaFlowdy2_Firestore[],
    praticheNonCategorizzate: PraticaFlowdy2_Firestore[],
    filename: string,
  ): void {
    // PRIMA SCHEDA: COMPLESSIVO
    const headersComplessivo = [
      "VINCOLO OF",
      "LOTTO 1",
      "LOTTO 5",
      "LOTTO 7",
      "LOTTO 8",
      "TOTALE",
    ];

    let totaleLotto1: number = 0;
    let totaleLotto5: number = 0;
    let totaleLotto7: number = 0;
    let totaleLotto8: number = 0;
    let totaleComplessivo: number = 0;

    dataComplessivo.forEach((vincolo) => {
      totaleLotto1 += Number(vincolo.lotto1 || 0);
      totaleLotto5 += Number(vincolo.lotto5 || 0);
      totaleLotto7 += Number(vincolo.lotto7 || 0);
      totaleLotto8 += Number(vincolo.lotto8 || 0);
      totaleComplessivo += Number(vincolo.totale || 0);
    });

    const dataComplessivoExport = dataComplessivo.map((vincolo) => ({
      "VINCOLO OF": vincolo.categoria || "",
      "LOTTO 1": vincolo.lotto1 || 0,
      "LOTTO 5": vincolo.lotto5 || 0,
      "LOTTO 7": vincolo.lotto7 || 0,
      "LOTTO 8": vincolo.lotto8 || 0,
      TOTALE: vincolo.totale || 0,
    }));

    dataComplessivoExport.push({
      "VINCOLO OF": "TOTALI",
      "LOTTO 1": totaleLotto1,
      "LOTTO 5": totaleLotto5,
      "LOTTO 7": totaleLotto7,
      "LOTTO 8": totaleLotto8,
      TOTALE: totaleComplessivo,
    });

    const worksheetComplessivo: XLSX.WorkSheet = XLSX.utils.json_to_sheet(
      dataComplessivoExport,
      {
        header: [],
      },
    );
    worksheetComplessivo["A1"] = { v: headersComplessivo[0] };
    worksheetComplessivo["B1"] = { v: headersComplessivo[1] };
    worksheetComplessivo["C1"] = { v: headersComplessivo[2] };
    worksheetComplessivo["D1"] = { v: headersComplessivo[3] };
    worksheetComplessivo["E1"] = { v: headersComplessivo[4] };
    worksheetComplessivo["F1"] = { v: headersComplessivo[5] };

    // SECONDA SCHEDA: PRATICHE
    const headersPratiche = [
      "CUI",
      "LOTTO",
      "REGIONE",
      "PROVINCIA",
      "COMUNE",
      "DENOMINAZIONE",
      "INDIRIZZO",
      "TIPOLOGIA DI GARA",
      "TIPOLOGIA EFFETTIVA",
      "IMPRESA",
      "VINCOLO",
      "SERVIZIO OF",
      "STATO OPEN FIBER",
      // SITUAZIONE OF
      "ID ORDINE SCUOLA",
      "STATO ORDINE SCUOLA",
      "DATA CREAZIONE ORDINE SCUOLA",
      "DATA ESPLETAMENTO ORDINE SCUOLA",
      "POP RACCOLTA",
      "NOTE SCUOLA OF",
      "ID ORDINE BH",
      "STATO ORDINE BH",
      "DATA CREAZIONE ORDINE BH",
      "DATA ESPLETAMENTO ORDINE BH",
      "NUMERO FIBRE BH",
      "NOTE BH OF",
      "ID ORDINE PCN",
      "STATO ORDINE PCN",
      "DATA CREAZIONE ORDINE PCN",
      "DATA ESPLETAMENTO ORDINE PCN",
      "NOTE PCN OF",
    ];

    const dataPraticheExport = pratiche.map((pratica) => {
      // Rimappa statoOF: LAVORABILE -> ESPLETATA, VINCOLATA con vincolo 2.x -> valore vincolo, altrimenti vuoto
      let statoOFMapped = "";

      // Log: pratica con vincolo 2.x ma senza statoOF
      const vincoloCodice = pratica.vincoloCategoriaCodice || "";
      if (
        vincoloCodice &&
        vincoloCodice.startsWith("2.") &&
        (!pratica.statoOF || pratica.statoOF.trim() === "")
      ) {
        this.logger.warn(
          `[EXCEL SERVICE] Pratica con vincolo ${vincoloCodice} ma senza statoOF - CUI: ${pratica.cui || "N/A"}, Denominazione: ${pratica.denominazione || "N/A"}, Regione: ${pratica.regione || "N/A"}`,
        );
        statoOFMapped = pratica.vincoloCategoriaLabel;
      }

      if (pratica.statoOF) {
        const statoOFUpper = pratica.statoOF.trim().toUpperCase();
        const statoOFValue = pratica.statoOF.trim();

        // Log: pratica con vincolo 2.x ma statoOF non corrisponde (non è LAVORABILE e non inizia con 2.)
        if (
          vincoloCodice &&
          vincoloCodice.startsWith("2.") &&
          statoOFUpper !== "LAVORABILE" &&
          !statoOFUpper.startsWith("2.")
        ) {
          this.logger.warn(
            `[EXCEL SERVICE] Pratica con vincolo ${vincoloCodice} ma statoOF="${statoOFValue}" non corrisponde - CUI: ${pratica.cui || "N/A"}, Denominazione: ${pratica.denominazione || "N/A"}, Regione: ${pratica.regione || "N/A"}`,
          );
        }

        if (statoOFUpper === "LAVORABILE") {
          statoOFMapped = "ESPLETATA";
        } else if (statoOFUpper === "VINCOLATA") {
          // Se statoOF è VINCOLATA e il vincolo è di tipo 2.x, usa il valore del vincolo
          if (vincoloCodice && vincoloCodice.startsWith("2.")) {
            statoOFMapped = vincoloCodice;
          }
          // Se il vincolo non è 2.x, rimane vuoto
        } else if (statoOFUpper.startsWith("2.")) {
          statoOFMapped = pratica.statoOF;
        }
        // Se non è LAVORABILE, VINCOLATA o non inizia con 2., rimane vuoto
      }

      return {
        CUI: pratica.cui || "",
        LOTTO: pratica.lotto || "",
        REGIONE: pratica.regione || "",
        PROVINCIA: pratica.provincia || "",
        COMUNE: pratica.comune || "",
        DENOMINAZIONE: pratica.denominazione || "",
        INDIRIZZO: pratica.indirizzo || "",
        "TIPOLOGIA DI GARA": pratica.tipoSede || "",
        "TIPOLOGIA EFFETTIVA": pratica.tipoSedeEffettiva || "",
        IMPRESA: pratica.azienda || "",
        VINCOLO:
          pratica.vincoloCategoriaLabel || pratica.vincoloCategoriaCodice || "",
        "SERVIZIO OF": pratica.servizioOF || "",
        "STATO OPEN FIBER": statoOFMapped,
        // SITUAZIONE OF
        "ID ORDINE SCUOLA": pratica.idOrdineScuola || "",
        "STATO ORDINE SCUOLA": pratica.statoOrdineScuola || "",
        "DATA CREAZIONE ORDINE SCUOLA": pratica.dataCreazioneOrdineScuola || "",
        "DATA ESPLETAMENTO ORDINE SCUOLA":
          pratica.dataEspletamentoOrdineScuola || "",
        "POP RACCOLTA": pratica.popRaccolta || "",
        "NOTE SCUOLA OF": pratica.noteScuolaOF || "",
        "ID ORDINE BH": pratica.idOrdineBH || "",
        "STATO ORDINE BH": pratica.statoOrdineBH || "",
        "DATA CREAZIONE ORDINE BH": pratica.dataCreazioneOrdineBH || "",
        "DATA ESPLETAMENTO ORDINE BH": pratica.dataEspletamentoOrdineBH || "",
        "NUMERO FIBRE BH": pratica.numeroFibreBH || "",
        "NOTE BH OF": pratica.noteBHOF || "",
        "ID ORDINE PCN": pratica.idOrdinePCN || "",
        "STATO ORDINE PCN": pratica.statoOrdinePCN || "",
        "DATA CREAZIONE ORDINE PCN": pratica.dataCreazioneOrdinePCN || "",
        "DATA ESPLETAMENTO ORDINE PCN": pratica.dataEspletamentoOrdinePCN || "",
        "NOTE PCN OF": pratica.notePCNOF || "",
      };
    });

    const worksheetPratiche: XLSX.WorkSheet = XLSX.utils.json_to_sheet(
      dataPraticheExport,
      {
        header: [],
      },
    );
    worksheetPratiche["A1"] = { v: headersPratiche[0] };
    worksheetPratiche["B1"] = { v: headersPratiche[1] };
    worksheetPratiche["C1"] = { v: headersPratiche[2] };
    worksheetPratiche["D1"] = { v: headersPratiche[3] };
    worksheetPratiche["E1"] = { v: headersPratiche[4] };
    worksheetPratiche["F1"] = { v: headersPratiche[5] };
    worksheetPratiche["G1"] = { v: headersPratiche[6] };
    worksheetPratiche["H1"] = { v: headersPratiche[7] };
    worksheetPratiche["I1"] = { v: headersPratiche[8] };
    worksheetPratiche["J1"] = { v: headersPratiche[9] };
    worksheetPratiche["K1"] = { v: headersPratiche[10] };
    worksheetPratiche["L1"] = { v: headersPratiche[11] };
    // SITUAZIONE OF headers
    worksheetPratiche["M1"] = { v: headersPratiche[12] };
    worksheetPratiche["N1"] = { v: headersPratiche[13] };
    worksheetPratiche["O1"] = { v: headersPratiche[14] };
    worksheetPratiche["P1"] = { v: headersPratiche[15] };
    worksheetPratiche["Q1"] = { v: headersPratiche[16] };
    worksheetPratiche["R1"] = { v: headersPratiche[17] };
    worksheetPratiche["S1"] = { v: headersPratiche[18] };
    worksheetPratiche["T1"] = { v: headersPratiche[19] };
    worksheetPratiche["U1"] = { v: headersPratiche[20] };
    worksheetPratiche["V1"] = { v: headersPratiche[21] };
    worksheetPratiche["W1"] = { v: headersPratiche[22] };
    worksheetPratiche["X1"] = { v: headersPratiche[23] };
    worksheetPratiche["Y1"] = { v: headersPratiche[24] };
    worksheetPratiche["Z1"] = { v: headersPratiche[25] };
    worksheetPratiche["AA1"] = { v: headersPratiche[26] };
    worksheetPratiche["AB1"] = { v: headersPratiche[27] };
    worksheetPratiche["AC1"] = { v: headersPratiche[28] };

    // TERZA SCHEDA: PRATICHE NON CATEGORIZZATE
    const headersNonCategorizzate = [
      "CUI",
      "LOTTO",
      "REGIONE",
      "PROVINCIA",
      "COMUNE",
      "DENOMINAZIONE",
      "TIPOLOGIA DI GARA",
      "TIPOLOGIA DI GARA EFFETTIVA",
      "IMPRESA",
      "VINCOLO",
      "SERVIZIO OF",
      "STATO OPEN FIBER",
      "VINCOLO CATEGORIA CODICE",
      "VINCOLO TIPOLOGIA ID",
      "MOTIVO NON CATEGORIZZATO",
    ];

    const dataNonCategorizzateExport = praticheNonCategorizzate.map(
      (pratica) => {
        // Rimappa statoOF: LAVORABILE -> ESPLETATA, VINCOLATA con vincolo 2.x -> valore vincolo, altrimenti vuoto
        let statoOFMapped = "";

        // Log: pratica con vincolo 2.x ma senza statoOF
        const vincoloCodice = pratica.vincoloCategoriaCodice || "";
        if (
          vincoloCodice &&
          vincoloCodice.startsWith("2.") &&
          (!pratica.statoOF || pratica.statoOF.trim() === "")
        ) {
          this.logger.warn(
            `[EXCEL SERVICE] Pratica NON CATEGORIZZATA con vincolo ${vincoloCodice} ma senza statoOF - CUI: ${pratica.cui || "N/A"}, Denominazione: ${pratica.denominazione || "N/A"}, Regione: ${pratica.regione || "N/A"}`,
          );
          statoOFMapped = vincoloCodice;
        }

        if (pratica.statoOF) {
          const statoOFUpper = pratica.statoOF.trim().toUpperCase();
          const statoOFValue = pratica.statoOF.trim();

          // Log: pratica con vincolo 2.x ma statoOF non corrisponde (non è LAVORABILE e non inizia con 2.)
          if (
            vincoloCodice &&
            vincoloCodice.startsWith("2.") &&
            statoOFUpper !== "LAVORABILE" &&
            !statoOFUpper.startsWith("2.")
          ) {
            this.logger.warn(
              `[EXCEL SERVICE] Pratica NON CATEGORIZZATA con vincolo ${vincoloCodice} ma statoOF="${statoOFValue}" non corrisponde - CUI: ${pratica.cui || "N/A"}, Denominazione: ${pratica.denominazione || "N/A"}, Regione: ${pratica.regione || "N/A"}`,
            );
          }

          if (statoOFUpper === "LAVORABILE") {
            statoOFMapped = "ESPLETATA";
          } else if (statoOFUpper === "VINCOLATA") {
            // Se statoOF è VINCOLATA e il vincolo è di tipo 2.x, usa il valore del vincolo
            if (vincoloCodice && vincoloCodice.startsWith("2.")) {
              statoOFMapped = vincoloCodice;
            }
            // Se il vincolo non è 2.x, rimane vuoto
          } else if (statoOFUpper.startsWith("2.")) {
            statoOFMapped = pratica.statoOF;
          }
          // Se non è LAVORABILE, VINCOLATA o non inizia con 2., rimane vuoto
        }

        return {
          CUI: pratica.cui || "",
          LOTTO: pratica.lotto || "",
          REGIONE: pratica.regione || "",
          PROVINCIA: pratica.provincia || "",
          COMUNE: pratica.comune || "",
          DENOMINAZIONE: pratica.denominazione || "",
          "TIPOLOGIA DI GARA": pratica.tipoSede || "",
          "TIPOLOGIA DI GARA EFFETTIVA": pratica.tipoSedeEffettiva || "",
          IMPRESA: pratica.azienda || "",
          VINCOLO:
            pratica.vincoloCategoriaLabel ||
            pratica.vincoloCategoriaCodice ||
            "",
          "SERVIZIO OF": pratica.servizioOF || "",
          "STATO OPEN FIBER": statoOFMapped,
          "VINCOLO CATEGORIA CODICE": pratica.vincoloCategoriaCodice || "",
          "VINCOLO TIPOLOGIA ID": pratica.vincoloTipologiaID || "",
          "MOTIVO NON CATEGORIZZATO":
            (pratica as any).motivoNonCategorizzato || "",
        };
      },
    );

    const worksheetNonCategorizzate: XLSX.WorkSheet = XLSX.utils.json_to_sheet(
      dataNonCategorizzateExport,
      {
        header: [],
      },
    );
    worksheetNonCategorizzate["A1"] = { v: headersNonCategorizzate[0] };
    worksheetNonCategorizzate["B1"] = { v: headersNonCategorizzate[1] };
    worksheetNonCategorizzate["C1"] = { v: headersNonCategorizzate[2] };
    worksheetNonCategorizzate["D1"] = { v: headersNonCategorizzate[3] };
    worksheetNonCategorizzate["E1"] = { v: headersNonCategorizzate[4] };
    worksheetNonCategorizzate["F1"] = { v: headersNonCategorizzate[5] };
    worksheetNonCategorizzate["G1"] = { v: headersNonCategorizzate[6] };
    worksheetNonCategorizzate["H1"] = { v: headersNonCategorizzate[7] };
    worksheetNonCategorizzate["I1"] = { v: headersNonCategorizzate[8] };
    worksheetNonCategorizzate["J1"] = { v: headersNonCategorizzate[9] };
    worksheetNonCategorizzate["K1"] = { v: headersNonCategorizzate[10] };
    worksheetNonCategorizzate["L1"] = { v: headersNonCategorizzate[11] };
    worksheetNonCategorizzate["M1"] = { v: headersNonCategorizzate[12] };
    worksheetNonCategorizzate["N1"] = { v: headersNonCategorizzate[13] };
    worksheetNonCategorizzate["O1"] = { v: headersNonCategorizzate[14] };

    // Crea il workbook con tre fogli
    const workbook: XLSX.WorkBook = {
      Sheets: {
        Complessivo: worksheetComplessivo,
        Pratiche: worksheetPratiche,
        //     'Non Categorizzate': worksheetNonCategorizzate
      },
      SheetNames: ["Complessivo", "Pratiche"], //, 'Non Categorizzate'
    };

    const excelBuffer: any = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Salva il file Excel
    saveAs(blob, filename);
  }

  exportAppuntamentiToExcel(
    data: DatiAppuntamentiPerImpresa[],
    filename: string,
  ): void {
    const customHeaders = [
      "IMPRESA",
      "MANCA PF (CON NTW)",
      "MANCA PF (NO NTW)",
      "APPUNTAMENTO DA PRENDERE (PF PRONTO)",
      "APPUNTAMENTO FISSATO",
      "APPUNTAMENTO SCADUTO",
      "ATTIVAZIONE KO",
      "ATTIVAZIONE OK",
      "INSTALLAZIONE OK",
      "TOTALE",
    ];
    let totaliNoAppuntamentoMancaPF_conNTW: number = 0;
    let totaliNoAppuntamentoMancaPF_noNTW: number = 0;
    let totaliNoAppuntamentoPFPronto: number = 0;
    let totaliAppuntamentoFissato: number = 0;
    let totaliAppuntamentoScaduto: number = 0;
    let totaliAttivazioneKO: number = 0;
    let totaliAttivazioneOK: number = 0;
    let totaliInstallazioneOK: number = 0;
    let totale: number = 0;

    data.map((sopralluoghiPerImpresa) => {
      totaliNoAppuntamentoMancaPF_conNTW += Number(
        sopralluoghiPerImpresa.noAppuntamentoMancaPF_conNTW,
      );
      totaliNoAppuntamentoMancaPF_noNTW += Number(
        sopralluoghiPerImpresa.noAppuntamentoMancaPF_noNTW,
      );
      totaliNoAppuntamentoPFPronto += Number(
        sopralluoghiPerImpresa.noAppuntamentoPFPronto,
      );
      totaliAppuntamentoFissato += Number(
        sopralluoghiPerImpresa.appuntamentoFissato,
      );
      totaliAppuntamentoScaduto += Number(
        sopralluoghiPerImpresa.appuntamentoScaduto,
      );
      totaliAttivazioneKO += Number(sopralluoghiPerImpresa.attivazioneKO);
      totaliAttivazioneOK += Number(sopralluoghiPerImpresa.attivazioneOK);
      totaliInstallazioneOK += Number(sopralluoghiPerImpresa.installazioneOK);
      totale += Number(sopralluoghiPerImpresa.totale);
    });
    const customData = data.map((attivazioniPerImpresa) => ({
      IMPRESA: attivazioniPerImpresa.impresa,
      "MANCA PF (CON NTW)": attivazioniPerImpresa.noAppuntamentoMancaPF_conNTW
        ? attivazioniPerImpresa.noAppuntamentoMancaPF_conNTW
        : 0,
      "MANCA PF (NO NTW)": attivazioniPerImpresa.noAppuntamentoMancaPF_noNTW
        ? attivazioniPerImpresa.noAppuntamentoMancaPF_noNTW
        : 0,
      "APPUNTAMENTO DA PRENDERE (PF PRONTO)":
        attivazioniPerImpresa.noAppuntamentoPFPronto
          ? attivazioniPerImpresa.noAppuntamentoPFPronto
          : 0,
      "APPUNTAMENTO FISSATO": attivazioniPerImpresa.appuntamentoFissato
        ? attivazioniPerImpresa.appuntamentoFissato
        : 0,
      "APPUNTAMENTO SCADUTO": attivazioniPerImpresa.appuntamentoScaduto
        ? attivazioniPerImpresa.appuntamentoScaduto
        : 0,
      "ATTIVAZIONE KO": attivazioniPerImpresa.attivazioneKO
        ? attivazioniPerImpresa.attivazioneKO
        : 0,
      "ATTIVAZIONE OK": attivazioniPerImpresa.attivazioneOK
        ? attivazioniPerImpresa.attivazioneOK
        : 0,
      "INSTALLAZIONE OK": attivazioniPerImpresa.installazioneOK
        ? attivazioniPerImpresa.installazioneOK
        : 0,
      TOTALE: attivazioniPerImpresa.totale ? attivazioniPerImpresa.totale : 0,
    }));
    customData.push({
      IMPRESA: "",
      "MANCA PF (CON NTW)": totaliNoAppuntamentoMancaPF_conNTW,
      "MANCA PF (NO NTW)": totaliNoAppuntamentoMancaPF_noNTW,
      "APPUNTAMENTO DA PRENDERE (PF PRONTO)": totaliNoAppuntamentoPFPronto,
      "APPUNTAMENTO FISSATO": totaliAppuntamentoFissato,
      "APPUNTAMENTO SCADUTO": totaliAppuntamentoScaduto,
      "ATTIVAZIONE KO": totaliAttivazioneKO,
      "ATTIVAZIONE OK": totaliAttivazioneOK,
      "INSTALLAZIONE OK": totaliInstallazioneOK,
      TOTALE: totale,
    });
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(customData, {
      header: [],
    });
    worksheet["A1"] = { v: customHeaders[0] };
    worksheet["B1"] = { v: customHeaders[1] };
    worksheet["C1"] = { v: customHeaders[2] };
    worksheet["D1"] = { v: customHeaders[3] };
    worksheet["E1"] = { v: customHeaders[4] };

    const workbook: XLSX.WorkBook = {
      Sheets: { data: worksheet },
      SheetNames: ["data"],
    };

    const excelBuffer: any = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Salva il file Excel
    saveAs(blob, filename);
  }

  exportBando1ToExcel(data: DatiDocFase1PerImpresa[], filename: string): void {
    const customHeaders = ["IMPRESA", "TOTALE"];
    const customData = data.map((item) => ({
      IMPRESA: item.impresa,
      TOTALE: item.totale,
    }));
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(customData, {
      header: [],
    });
    worksheet["A1"] = { v: customHeaders[0] };
    worksheet["B1"] = { v: customHeaders[1] };

    const workbook: XLSX.WorkBook = {
      Sheets: { data: worksheet },
      SheetNames: ["data"],
    };

    const excelBuffer: any = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Salva il file Excel
    saveAs(blob, filename);
  }

  exportDocFase1ToExcel(
    data: DatiDocFase1PerImpresa[],
    filename: string,
  ): void {
    const customHeaders = [
      "IMPRESA",
      "01. F1 da assegnare (no ODA)",
      "02. F1 da Accettare con ODA",
      "03. F1 in carico con ODA",
      "04. SPR Pianificato",
      "05. Sopralluogo KO",
      "06. Sopralluogo OK",
      "07. Sopralluogo OK (extra)",
      "08. Extra KO",
      "09. Extra Approvato",
      "10. Doc. F1 consegnata",
      "11. Doc. F1 verifica SF",
      "12. Doc. F1 Rework Azienda",
      "13. Doc. F1 in firma",
      "14. Doc. F1 respinta",
      "15. Doc. F1 a Infratel",
      "16. Doc. F1 Approvata",
      "TOTALE",
    ];

    // Calcolo dei totali per colonna
    const totali = {
      inAttesaODA: data.reduce((sum, item) => sum + (item.inAttesaODA || 0), 0),
      daAssegnare: data.reduce((sum, item) => sum + (item.daAssegnare || 0), 0),
      assegnate: data.reduce((sum, item) => sum + (item.assegnate || 0), 0),
      sopralluogoPianificato: data.reduce(
        (sum, item) => sum + (item.sopralluogoPianificato || 0),
        0,
      ),
      sopralluogoKO: data.reduce(
        (sum, item) => sum + (item.sopralluogoKO || 0),
        0,
      ),
      sopralluogoEseguito: data.reduce(
        (sum, item) => sum + (item.sopralluogoEseguito || 0),
        0,
      ),
      preventivoInAttesa: data.reduce(
        (sum, item) => sum + (item.preventivoInAttesa || 0),
        0,
      ),
      preventivoRifiutato: data.reduce(
        (sum, item) => sum + (item.preventivoRifiutato || 0),
        0,
      ),
      preventivoApprovato: data.reduce(
        (sum, item) => sum + (item.preventivoApprovato || 0),
        0,
      ),
      consegnate: data.reduce((sum, item) => sum + (item.consegnate || 0), 0),
      inVerificaSmartfiber: data.reduce(
        (sum, item) => sum + (item.inVerificaSmartfiber || 0),
        0,
      ),
      inReworkAzienda: data.reduce(
        (sum, item) => sum + (item.inReworkAzienda || 0),
        0,
      ),
      inCaricoPresidio: data.reduce(
        (sum, item) => sum + (item.inCaricoPresidio || 0),
        0,
      ),
      respinte: data.reduce((sum, item) => sum + (item.respinte || 0), 0),
      pubblicate: data.reduce((sum, item) => sum + (item.pubblicate || 0), 0),
      approvate: data.reduce((sum, item) => sum + (item.approvate || 0), 0),
      totale: data.reduce((sum, item) => sum + (item.totale || 0), 0),
    };

    const customData = data.map((item) => ({
      IMPRESA: item.impresa,
      "01. F1 da assegnare (no ODA)": item.inAttesaODA,
      "02. F1 da Accettare con ODA": item.daAssegnare,
      "03. F1 in carico con ODA": item.assegnate,
      "04. SPR Pianificato": item.sopralluogoPianificato,
      "05. Sopralluogo KO": item.sopralluogoKO,
      "06. Sopralluogo OK": item.sopralluogoEseguito,
      "07. Sopralluogo OK (extra)": item.preventivoInAttesa,
      "08. Extra KO": item.preventivoRifiutato,
      "09. Extra Approvato": item.preventivoApprovato,
      "10. Doc. F1 consegnata": item.consegnate,
      "11. Doc. F1 verifica SF": item.inVerificaSmartfiber,
      "12. Doc. F1 Rework Azienda": item.inReworkAzienda,
      "13. Doc. F1 in firma": item.inCaricoPresidio,
      "14. Doc. F1 respinta": item.respinte,
      "15. Doc. F1 a Infratel": item.pubblicate,
      "16. Doc. F1 Approvata": item.approvate,
      TOTALE: item.totale,
    }));

    // Aggiungo la riga dei totali
    customData.push({
      IMPRESA: "TOTALI",
      "01. F1 da assegnare (no ODA)": totali.inAttesaODA,
      "02. F1 da Accettare con ODA": totali.daAssegnare,
      "03. F1 in carico con ODA": totali.assegnate,
      "04. SPR Pianificato": totali.sopralluogoPianificato,
      "05. Sopralluogo KO": totali.sopralluogoKO,
      "06. Sopralluogo OK": totali.sopralluogoEseguito,
      "07. Sopralluogo OK (extra)": totali.preventivoInAttesa,
      "08. Extra KO": totali.preventivoRifiutato,
      "09. Extra Approvato": totali.preventivoApprovato,
      "10. Doc. F1 consegnata": totali.consegnate,
      "11. Doc. F1 verifica SF": totali.inVerificaSmartfiber,
      "12. Doc. F1 Rework Azienda": totali.inReworkAzienda,
      "13. Doc. F1 in firma": totali.inCaricoPresidio,
      "14. Doc. F1 respinta": totali.respinte,
      "15. Doc. F1 a Infratel": totali.pubblicate,
      "16. Doc. F1 Approvata": totali.approvate,
      TOTALE: totali.totale,
    });

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(customData, {
      header: [],
    });

    // Imposto gli header
    customHeaders.forEach((header, index) => {
      const cellRef = XLSX.utils.encode_cell({ r: 0, c: index });
      worksheet[cellRef] = { v: header };
    });

    // Formattazione della riga dei totali
    const lastRow = customData.length;
    const totaliRow = lastRow;
    customHeaders.forEach((_, index) => {
      const cellRef = XLSX.utils.encode_cell({ r: totaliRow, c: index });
      if (index === 0) {
        worksheet[cellRef].s = { font: { bold: true } };
      } else {
        worksheet[cellRef].s = { font: { bold: true }, numFmt: "#,##0" };
      }
    });

    const workbook: XLSX.WorkBook = {
      Sheets: { data: worksheet },
      SheetNames: ["data"],
    };

    const excelBuffer: any = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Salva il file Excel
    saveAs(blob, filename);
  }

  exportDocFase2ToExcel(
    data: DatiDocFase2PerImpresa[],
    filename: string,
  ): void {
    const customHeaders = [
      "IMPRESA",
      "01. F2 da assegnare (no ODA)",
      "02. F2 da Accettare con ODA",
      "03. F2 in carico con ODA",
      "04. Appuntamneto pianificato",
      "05. Appuntamneto scaduto",
      "06. Installazione OK",
      "07. Attesa TIMSUPPORT",
      "08. Attivazione KO CPE",
      "09. Attivazione KO FO",
      "10. Verifica TIMSUPPORT KO",
      "11. Attivazione OK",
      "12. Consegnate",
      "13. In Verifica Smartfiber",
      "14. In Carico Presidio",
      "15. Pubblicate",
      "16. Respinte",
      "17. In Rework Azienda",
      "18. Approvate",
      "TOTALE",
    ];

    // Calcolo dei totali per colonna
    const totali = {
      inAttesaODA: data.reduce((sum, item) => sum + (item.inAttesaODA || 0), 0),
      daAssegnare: data.reduce((sum, item) => sum + (item.daAssegnare || 0), 0),
      assegnate: data.reduce((sum, item) => sum + (item.assegnate || 0), 0),
      inCaricoImpresa: data.reduce(
        (sum, item) => sum + (item.inCaricoImpresa || 0),
        0,
      ),
      appuntamentoFissato: data.reduce(
        (sum, item) => sum + (item.appuntamentoFissato || 0),
        0,
      ),
      appuntamentoScaduto: data.reduce(
        (sum, item) => sum + (item.appuntamentoScaduto || 0),
        0,
      ),
      installazioneOK: data.reduce(
        (sum, item) => sum + (item.installazioneOK || 0),
        0,
      ),
      attesaTS: data.reduce((sum, item) => sum + (item.attesaTS || 0), 0),
      attivazioneKO_CPE: data.reduce(
        (sum, item) => sum + (item.attivazioneKO_CPE || 0),
        0,
      ),
      attivazioneKO_FO: data.reduce(
        (sum, item) => sum + (item.attivazioneKO_FO || 0),
        0,
      ),
      verificaTSKO: data.reduce(
        (sum, item) => sum + (item.verificaTSKO || 0),
        0,
      ),
      attivazioneOK: data.reduce(
        (sum, item) => sum + (item.attivazioneOK || 0),
        0,
      ),
      consegnate: data.reduce((sum, item) => sum + (item.consegnate || 0), 0),
      inVerificaSmartfiber: data.reduce(
        (sum, item) => sum + (item.inVerificaSmartfiber || 0),
        0,
      ),
      inReworkAzienda: data.reduce(
        (sum, item) => sum + (item.inReworkAzienda || 0),
        0,
      ),
      inCaricoPresidio: data.reduce(
        (sum, item) => sum + (item.inCaricoPresidio || 0),
        0,
      ),
      pubblicate: data.reduce((sum, item) => sum + (item.pubblicate || 0), 0),
      approvate: data.reduce((sum, item) => sum + (item.approvate || 0), 0),
      respinte: data.reduce((sum, item) => sum + (item.respinte || 0), 0),
      totale: data.reduce((sum, item) => sum + (item.totale || 0), 0),
    };

    const customData = data.map((item) => ({
      IMPRESA: item.impresa,
      "01. F2 da assegnare (no ODA)": item.inAttesaODA,
      "02. F2 da Accettare con ODA": item.daAssegnare,
      "03. F2 in carico con ODA": item.assegnate,
      "04. Appuntamneto pianificato": item.inCaricoImpresa,
      "05. Appuntamneto scaduto": item.appuntamentoScaduto,
      "06. Installazione OK": item.installazioneOK,
      "07. Attesa TIMSUPPORT": item.attesaTS,
      "08. Attivazione KO CPE": item.attivazioneKO_CPE,
      "09. Attivazione KO FO": item.attivazioneKO_FO,
      "10. Verifica TIMSUPPORT KO": item.verificaTSKO,
      "11. Attivazione OK": item.attivazioneOK,
      "12. Consegnate": item.consegnate,
      "13. In Verifica Smartfiber": item.inVerificaSmartfiber,
      "14. In Carico Presidio": item.inCaricoPresidio,
      "15. Pubblicate": item.pubblicate,
      "16. Respinte": item.respinte,
      "17. In Rework Azienda": item.inReworkAzienda,
      "18. Approvate": item.approvate,
      TOTALE: item.totale,
    }));

    // Aggiungo la riga dei totali
    customData.push({
      IMPRESA: "TOTALI",
      "01. F2 da assegnare (no ODA)": totali.inAttesaODA,
      "02. F2 da Accettare con ODA": totali.daAssegnare,
      "03. F2 in carico con ODA": totali.assegnate,
      "04. Appuntamneto pianificato": totali.inCaricoImpresa,
      "05. Appuntamneto scaduto": totali.appuntamentoScaduto,
      "06. Installazione OK": totali.installazioneOK,
      "07. Attesa TIMSUPPORT": totali.attesaTS,
      "08. Attivazione KO CPE": totali.attivazioneKO_CPE,
      "09. Attivazione KO FO": totali.attivazioneKO_FO,
      "10. Verifica TIMSUPPORT KO": totali.verificaTSKO,
      "11. Attivazione OK": totali.attivazioneOK,
      "12. Consegnate": totali.consegnate,
      "13. In Verifica Smartfiber": totali.inVerificaSmartfiber,
      "14. In Carico Presidio": totali.inCaricoPresidio,
      "15. Pubblicate": totali.pubblicate,
      "16. Respinte": totali.respinte,
      "17. In Rework Azienda": totali.inReworkAzienda,
      "18. Approvate": totali.approvate,
      TOTALE: totali.totale,
    });

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(customData, {
      header: [],
    });

    // Imposto gli header
    customHeaders.forEach((header, index) => {
      const cellRef = XLSX.utils.encode_cell({ r: 0, c: index });
      worksheet[cellRef] = { v: header };
    });

    // Formattazione della riga dei totali
    const lastRow = customData.length;
    const totaliRow = lastRow;
    customHeaders.forEach((_, index) => {
      const cellRef = XLSX.utils.encode_cell({ r: totaliRow, c: index });
      if (index === 0) {
        worksheet[cellRef].s = { font: { bold: true } };
      } else {
        worksheet[cellRef].s = { font: { bold: true }, numFmt: "#,##0" };
      }
    });

    const workbook: XLSX.WorkBook = {
      Sheets: { data: worksheet },
      SheetNames: ["data"],
    };

    const excelBuffer: any = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Salva il file Excel
    saveAs(blob, filename);
  }

  exportDocFase3ToExcel(
    data: DatiDocFase3PerImpresa[],
    filename: string,
  ): void {
    const customHeaders = [
      "IMPRESA",
      "01. F3 In attesa ODA",
      "02. F3 Da Accettare",
      "03. F3 Presa in carico",
      "04. F3 In lav. Impresa",
      "05. F3 Consegnata a SF",
      "06. F3 In carico SF",
      "07. F3 Presa in carico TIM",
      "08. F3 In firma TIM",
      "09. F3 Pacchetto Firmato",
      "10. F3 PEC a Infratel",
      "11. F3 Rework Impresa",
      "12. F3 Respinta",
      "13. F3 Approvata",
      "TOTALE",
    ];

    // Calcolo dei totali per colonna
    const totali = {
      inAttesaODA: data.reduce((sum, item) => sum + (item.inAttesaODA || 0), 0),
      daAssegnare: data.reduce((sum, item) => sum + (item.daAssegnare || 0), 0),
      assegnate: data.reduce(
        (sum, item) => sum + (item.assegnate || 0 + item.inCaricoImpresa || 0),
        0,
      ),
      inProgettazione: data.reduce(
        (sum, item) => sum + (item.inProgettazione || 0),
        0,
      ),
      consegnataASF: data.reduce(
        (sum, item) => sum + (item.consegnate || 0),
        0,
      ),
      inCaricoSF: data.reduce(
        (sum, item) => sum + (item.inVerificaSmartfiber || 0),
        0,
      ),
      presaInCaricoTIM: data.reduce(
        (sum, item) => sum + (item.inCaricoPresidio || 0),
        0,
      ),
      inFirmaTIM: data.reduce((sum, item) => sum + (item.inFirma || 0), 0),
      pacchettoFirmato: data.reduce(
        (sum, item) => sum + (item.firmate || 0),
        0,
      ),
      pecInfratel: data.reduce((sum, item) => sum + (item.pubblicate || 0), 0),
      reworkImpresa: data.reduce(
        (sum, item) => sum + (item.inReworkAzienda || 0),
        0,
      ),
      respinta: data.reduce((sum, item) => sum + (item.respinte || 0), 0),
      approvata: data.reduce((sum, item) => sum + (item.approvate || 0), 0),
      totale: data.reduce((sum, item) => sum + (item.totale || 0), 0),
    };

    const customData = data.map((item) => ({
      IMPRESA: item.impresa,
      "01. F3 In attesa ODA": item.inAttesaODA,
      "02. F3 Da Accettare": item.daAssegnare,
      "03. F3 Presa in carico": item.assegnate + item.inCaricoImpresa,
      "04. F3 In lav. Impresa": item.inProgettazione,
      "05. F3 Consegnata a SF": item.consegnate,
      "06. F3 In carico SF": item.inVerificaSmartfiber,
      "07. F3 Presa in carico TIM": item.inCaricoPresidio,
      "08. F3 In firma TIM": item.inFirma,
      "09. F3 Pacchetto Firmato": item.firmate,
      "10. F3 PEC a Infratel": item.pubblicate,
      "11. F3 Rework Impresa": item.inReworkAzienda,
      "12. F3 Respinta": item.respinte,
      "13. F3 Approvata": item.approvate,
      TOTALE: item.totale,
    }));

    // Aggiungo la riga dei totali
    customData.push({
      IMPRESA: "TOTALI",
      "01. F3 In attesa ODA": totali.inAttesaODA,
      "02. F3 Da Accettare": totali.daAssegnare,
      "03. F3 Presa in carico": totali.assegnate,
      "04. F3 In lav. Impresa": totali.inProgettazione,
      "05. F3 Consegnata a SF": totali.consegnataASF,
      "06. F3 In carico SF": totali.inCaricoSF,
      "07. F3 Presa in carico TIM": totali.presaInCaricoTIM,
      "08. F3 In firma TIM": totali.inFirmaTIM,
      "09. F3 Pacchetto Firmato": totali.pacchettoFirmato,
      "10. F3 PEC a Infratel": totali.pecInfratel,
      "11. F3 Rework Impresa": totali.reworkImpresa,
      "12. F3 Respinta": totali.respinta,
      "13. F3 Approvata": totali.approvata,
      TOTALE: totali.totale,
    });

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(customData, {
      header: [],
    });

    // Imposto gli header
    customHeaders.forEach((header, index) => {
      const cellRef = XLSX.utils.encode_cell({ r: 0, c: index });
      worksheet[cellRef] = { v: header };
    });

    // Formattazione della riga dei totali
    const lastRow = customData.length;
    const totaliRow = lastRow;
    customHeaders.forEach((_, index) => {
      const cellRef = XLSX.utils.encode_cell({ r: totaliRow, c: index });
      if (index === 0) {
        worksheet[cellRef].s = { font: { bold: true } };
      } else {
        worksheet[cellRef].s = { font: { bold: true }, numFmt: "#,##0" };
      }
    });

    const workbook: XLSX.WorkBook = {
      Sheets: { data: worksheet },
      SheetNames: ["data"],
    };

    const excelBuffer: any = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Salva il file Excel
    saveAs(blob, filename);
  }

  exportBando1OverallToExcel(datiBando1: any, filename: string): void {
    try {
      const bando1Headers = ["", "LOTTO 6", "LOTTO 7", "TOTALE"];

      const complessivoData = [
        {
          "": "ATTIVATE",
          "LOTTO 6": datiBando1.complessivoBando1AttivateLotto6,
          "LOTTO 7": datiBando1.complessivoBando1AttivateLotto7,
          TOTALE: datiBando1.complessivoBando1Attivate,
        },
        {
          "": "DA ATTIVARE",
          "LOTTO 6": datiBando1.complessivoBando1DaAttivareLotto6,
          "LOTTO 7": datiBando1.complessivoBando1DaAttivareLotto7,
          TOTALE: datiBando1.complessivoBando1DaAttivare,
        },
        {
          "": "FUORI PERIMETRO",
          "LOTTO 6": datiBando1.complessivoBando1FuoriPerimetroLotto6,
          "LOTTO 7": datiBando1.complessivoBando1FuoriPerimetroLotto7,
          TOTALE: datiBando1.complessivoBando1FuoriPerimetro,
        },
        {
          "": "TOTALI",
          "LOTTO 6":
            (datiBando1.complessivoBando1AttivateLotto6 || 0) +
            (datiBando1.complessivoBando1DaAttivareLotto6 || 0) +
            (datiBando1.complessivoBando1FuoriPerimetroLotto6 || 0),
          "LOTTO 7":
            (datiBando1.complessivoBando1AttivateLotto7 || 0) +
            (datiBando1.complessivoBando1DaAttivareLotto7 || 0) +
            (datiBando1.complessivoBando1FuoriPerimetroLotto7 || 0),
          TOTALE:
            (datiBando1.complessivoBando1Attivate || 0) +
            (datiBando1.complessivoBando1DaAttivare || 0) +
            (datiBando1.complessivoBando1FuoriPerimetro || 0),
        },
      ];

      const daAttivareData = [
        {
          "": "PRONTOFIBRA",
          "LOTTO 6": datiBando1.daAttivareBando1PFLotto6,
          "LOTTO 7": datiBando1.daAttivareBando1PFLotto7,
          TOTALE: datiBando1.daAttivareBando1PF,
        },
        {
          "": "LAVORABILE",
          "LOTTO 6": datiBando1.daAttivareBando1LavorabileLotto6,
          "LOTTO 7": datiBando1.daAttivareBando1LavorabileLotto7,
          TOTALE: datiBando1.daAttivareBando1Lavorabile,
        },
        {
          "": "VINCOLO INFRATEL",
          "LOTTO 6": datiBando1.daAttivareBando1VincoloInfratelLotto6,
          "LOTTO 7": datiBando1.daAttivareBando1VincoloInfratelLotto7,
          TOTALE: datiBando1.daAttivareBando1VincoloInfratel,
        },
        {
          "": "VINCOLO OF",
          "LOTTO 6": datiBando1.daAttivareBando1VincoloOFLotto6,
          "LOTTO 7": datiBando1.daAttivareBando1VincoloOFLotto7,
          TOTALE: datiBando1.daAttivareBando1VincoloOF,
        },
        {
          "": "VINCOLO FIBERCOP",
          "LOTTO 6": datiBando1.daAttivareBando1VincoloFibercopLotto6,
          "LOTTO 7": datiBando1.daAttivareBando1VincoloFibercopLotto7,
          TOTALE: datiBando1.daAttivareBando1VincoloFibercop,
        },
        {
          "": "VINCOLO TIM",
          "LOTTO 6": datiBando1.daAttivareBando1VincoloTimLotto6,
          "LOTTO 7": datiBando1.daAttivareBando1VincoloTimLotto7,
          TOTALE: datiBando1.daAttivareBando1VincoloTim,
        },
        {
          "": "TOTALI",
          "LOTTO 6":
            (datiBando1.daAttivareBando1PFLotto6 || 0) +
            (datiBando1.daAttivareBando1LavorabileLotto6 || 0) +
            (datiBando1.daAttivareBando1VincoloInfratelLotto6 || 0) +
            (datiBando1.daAttivareBando1VincoloOFLotto6 || 0) +
            (datiBando1.daAttivareBando1VincoloFibercopLotto6 || 0) +
            (datiBando1.daAttivareBando1VincoloTimLotto6 || 0),
          "LOTTO 7":
            (datiBando1.daAttivareBando1PFLotto7 || 0) +
            (datiBando1.daAttivareBando1LavorabileLotto7 || 0) +
            (datiBando1.daAttivareBando1VincoloInfratelLotto7 || 0) +
            (datiBando1.daAttivareBando1VincoloOFLotto7 || 0) +
            (datiBando1.daAttivareBando1VincoloFibercopLotto7 || 0) +
            (datiBando1.daAttivareBando1VincoloTimLotto7 || 0),
          TOTALE:
            (datiBando1.daAttivareBando1PF || 0) +
            (datiBando1.daAttivareBando1Lavorabile || 0) +
            (datiBando1.daAttivareBando1VincoloInfratel || 0) +
            (datiBando1.daAttivareBando1VincoloOF || 0) +
            (datiBando1.daAttivareBando1VincoloFibercop || 0) +
            (datiBando1.daAttivareBando1VincoloTim || 0),
        },
      ];

      const fuoriPerimetroData = [
        {
          "": "4.1 DISMESSA",
          "LOTTO 6": datiBando1.fuoriPerimetroBando1_4_1_Lotto6,
          "LOTTO 7": datiBando1.fuoriPerimetroBando1_4_1_Lotto7,
          TOTALE: datiBando1.fuoriPerimetroBando1_4_1,
        },
        {
          "": "4.2 MANCA ADESIONE",
          "LOTTO 6": datiBando1.fuoriPerimetroBando1_4_2_Lotto6,
          "LOTTO 7": datiBando1.fuoriPerimetroBando1_4_2_Lotto7,
          TOTALE: datiBando1.fuoriPerimetroBando1_4_2,
        },
        {
          "": "4.3 NON FATTIBILE",
          "LOTTO 6": datiBando1.fuoriPerimetroBando1_4_3_Lotto6,
          "LOTTO 7": datiBando1.fuoriPerimetroBando1_4_3_Lotto7,
          TOTALE: datiBando1.fuoriPerimetroBando1_4_3,
        },
        {
          "": "4.4 ANNULLATA	",
          "LOTTO 6": datiBando1.fuoriPerimetroBando1_4_4_Lotto6,
          "LOTTO 7": datiBando1.fuoriPerimetroBando1_4_4_Lotto7,
          TOTALE: datiBando1.fuoriPerimetroBando1_4_4,
        },

        {
          "": "TOTALI",
          "LOTTO 6":
            (datiBando1.fuoriPerimetroBando1_4_1_Lotto6 || 0) +
            (datiBando1.fuoriPerimetroBando1_4_2_Lotto6 || 0) +
            (datiBando1.fuoriPerimetroBando1_4_3_Lotto6 || 0) +
            (datiBando1.fuoriPerimetroBando1_4_4_Lotto6 || 0),
          "LOTTO 7":
            (datiBando1.fuoriPerimetroBando1_4_1_Lotto7 || 0) +
            (datiBando1.fuoriPerimetroBando1_4_2_Lotto7 || 0) +
            (datiBando1.fuoriPerimetroBando1_4_3_Lotto7 || 0) +
            (datiBando1.fuoriPerimetroBando1_4_4_Lotto7 || 0),
          TOTALE:
            (datiBando1.fuoriPerimetroBando1_4_1 || 0) +
            (datiBando1.fuoriPerimetroBando1_4_2 || 0) +
            (datiBando1.fuoriPerimetroBando1_4_3 || 0) +
            (datiBando1.fuoriPerimetroBando1_4_4 || 0),
        },
      ];

      const lavorabiliData = [
        {
          "": "TIM",
          "LOTTO 6": datiBando1.lavorabiliBando1TimLotto6,
          "LOTTO 7": datiBando1.lavorabiliBando1TimLotto7,
          TOTALE: datiBando1.lavorabiliBando1Tim,
        },

        {
          "": "FIBERCOP",
          "LOTTO 6": datiBando1.lavorabiliBando1FibercopLotto6,
          "LOTTO 7": datiBando1.lavorabiliBando1FibercopLotto7,
          TOTALE: datiBando1.lavorabiliBando1Fibercop,
        },
        {
          "": "OPENFIBER",
          "LOTTO 6": datiBando1.lavorabiliBando1OFLotto6,
          "LOTTO 7": datiBando1.lavorabiliBando1OFLotto7,
          TOTALE: datiBando1.lavorabiliBando1OF,
        },
        {
          "": "INFRATEL",
          "LOTTO 6": datiBando1.lavorabiliBando1InfratelLotto6,
          "LOTTO 7": datiBando1.lavorabiliBando1InfratelLotto7,
          TOTALE: datiBando1.lavorabiliBando1Infratel,
        },
        {
          "": "TOTALI",
          "LOTTO 6":
            (datiBando1.lavorabiliBando1TimLotto6 || 0) +
            (datiBando1.lavorabiliBando1FibercopLotto6 || 0) +
            (datiBando1.lavorabiliBando1OFLotto6 || 0) +
            (datiBando1.lavorabiliBando1InfratelLotto6 || 0),
          "LOTTO 7":
            (datiBando1.lavorabiliBando1TimLotto7 || 0) +
            (datiBando1.lavorabiliBando1FibercopLotto7 || 0) +
            (datiBando1.lavorabiliBando1OFLotto7 || 0) +
            (datiBando1.lavorabiliBando1InfratelLotto7 || 0),
          TOTALE:
            (datiBando1.lavorabiliBando1Tim || 0) +
            (datiBando1.lavorabiliBando1Fibercop || 0) +
            (datiBando1.lavorabiliBando1OF || 0) +
            (datiBando1.lavorabiliBando1Infratel || 0),
        },
      ];

      const vincoloInfratelData = [
        {
          "": "3.1 RISTRUTTURAZIONE",
          "LOTTO 6": datiBando1.vincoloInfratelBando1_3_1_Lotto6,
          "LOTTO 7": datiBando1.vincoloInfratelBando1_3_1_Lotto7,
          TOTALE: datiBando1.vincoloInfratelBando1_3_1,
        },
        {
          "": "3.2 CODICE MCN",
          "LOTTO 6": datiBando1.vincoloInfratelBando1_3_2_Lotto6,
          "LOTTO 7": datiBando1.vincoloInfratelBando1_3_2_Lotto7,
          TOTALE: datiBando1.vincoloInfratelBando1_3_2,
        },
        {
          "": "3.3 INDIRIZZO",
          "LOTTO 6": datiBando1.vincoloInfratelBando1_3_3_Lotto6,
          "LOTTO 7": datiBando1.vincoloInfratelBando1_3_3_Lotto7,
          TOTALE: datiBando1.vincoloInfratelBando1_3_3,
        },
        {
          "": "3.4 DISMISSIONE",
          "LOTTO 6": datiBando1.vincoloInfratelBando1_3_4_Lotto6,
          "LOTTO 7": datiBando1.vincoloInfratelBando1_3_4_Lotto7,
          TOTALE: datiBando1.vincoloInfratelBando1_3_4,
        },
        {
          "": "3.5 MANCATA ADESIONE",
          "LOTTO 6": datiBando1.vincoloInfratelBando1_3_5_Lotto6,
          "LOTTO 7": datiBando1.vincoloInfratelBando1_3_5_Lotto7,
          TOTALE: datiBando1.vincoloInfratelBando1_3_5,
        },
        {
          "": "3.6 SEDE A",
          "LOTTO 6": datiBando1.vincoloInfratelBando1_3_6_Lotto6,
          "LOTTO 7": datiBando1.vincoloInfratelBando1_3_6_Lotto7,
          TOTALE: datiBando1.vincoloInfratelBando1_3_6,
        },
        {
          "": "3.7 ATTESA CONFERMA DISMISSIONE",
          "LOTTO 6": datiBando1.vincoloInfratelBando1_3_7_Lotto6,
          "LOTTO 7": datiBando1.vincoloInfratelBando1_3_7_Lotto7,
          TOTALE: datiBando1.vincoloInfratelBando1_3_7,
        },
        {
          "": "3.8 ATTESA CONFERMA MANCATA ADESIONE",
          "LOTTO 6": datiBando1.vincoloInfratelBando1_3_8_Lotto6,
          "LOTTO 7": datiBando1.vincoloInfratelBando1_3_8_Lotto7,
          TOTALE: datiBando1.vincoloInfratelBando1_3_8,
        },
        {
          "": "3.9 IRU INFRATEL",
          "LOTTO 6": datiBando1.vincoloInfratelBando1_3_9_Lotto6,
          "LOTTO 7": datiBando1.vincoloInfratelBando1_3_9_Lotto7,
          TOTALE: datiBando1.vincoloInfratelBando1_3_9,
        },
        {
          "": "3.10 MANCANZA ALUNNI",
          "LOTTO 6": datiBando1.vincoloInfratelBando1_3_10_Lotto6,
          "LOTTO 7": datiBando1.vincoloInfratelBando1_3_10_Lotto7,
          TOTALE: datiBando1.vincoloInfratelBando1_3_10,
        },
        {
          "": "3.11 ALTRO (F1)",
          "LOTTO 6": datiBando1.vincoloInfratelBando1_3_11_Lotto6,
          "LOTTO 7": datiBando1.vincoloInfratelBando1_3_11_Lotto7,
          TOTALE: datiBando1.vincoloInfratelBando1_3_11,
        },
        {
          "": "3.12 ALTRO (F2)",
          "LOTTO 6": datiBando1.vincoloInfratelBando1_3_12_Lotto6,
          "LOTTO 7": datiBando1.vincoloInfratelBando1_3_12_Lotto7,
          TOTALE: datiBando1.vincoloInfratelBando1_3_12,
        },
        {
          "": "TOTALI",
          "LOTTO 6":
            (datiBando1.vincoloInfratelBando1_3_1_Lotto6 || 0) +
            (datiBando1.vincoloInfratelBando1_3_2_Lotto6 || 0) +
            (datiBando1.vincoloInfratelBando1_3_3_Lotto6 || 0) +
            (datiBando1.vincoloInfratelBando1_3_4_Lotto6 || 0) +
            (datiBando1.vincoloInfratelBando1_3_5_Lotto6 || 0) +
            (datiBando1.vincoloInfratelBando1_3_6_Lotto6 || 0) +
            (datiBando1.vincoloInfratelBando1_3_7_Lotto6 || 0) +
            (datiBando1.vincoloInfratelBando1_3_8_Lotto6 || 0) +
            (datiBando1.vincoloInfratelBando1_3_9_Lotto6 || 0) +
            (datiBando1.vincoloInfratelBando1_3_10_Lotto6 || 0) +
            (datiBando1.vincoloInfratelBando1_3_11_Lotto6 || 0) +
            (datiBando1.vincoloInfratelBando1_3_12_Lotto6 || 0),
          "LOTTO 7":
            (datiBando1.vincoloInfratelBando1_3_1_Lotto7 || 0) +
            (datiBando1.vincoloInfratelBando1_3_2_Lotto7 || 0) +
            (datiBando1.vincoloInfratelBando1_3_3_Lotto7 || 0) +
            (datiBando1.vincoloInfratelBando1_3_4_Lotto7 || 0) +
            (datiBando1.vincoloInfratelBando1_3_5_Lotto7 || 0) +
            (datiBando1.vincoloInfratelBando1_3_6_Lotto7 || 0) +
            (datiBando1.vincoloInfratelBando1_3_7_Lotto7 || 0) +
            (datiBando1.vincoloInfratelBando1_3_8_Lotto7 || 0) +
            (datiBando1.vincoloInfratelBando1_3_9_Lotto7 || 0) +
            (datiBando1.vincoloInfratelBando1_3_10_Lotto7 || 0) +
            (datiBando1.vincoloInfratelBando1_3_11_Lotto7 || 0) +
            (datiBando1.vincoloInfratelBando1_3_12_Lotto7 || 0),
          TOTALE:
            (datiBando1.vincoloInfratelBando1_3_1 || 0) +
            (datiBando1.vincoloInfratelBando1_3_2 || 0) +
            (datiBando1.vincoloInfratelBando1_3_3 || 0) +
            (datiBando1.vincoloInfratelBando1_3_4 || 0) +
            (datiBando1.vincoloInfratelBando1_3_5 || 0) +
            (datiBando1.vincoloInfratelBando1_3_6 || 0) +
            (datiBando1.vincoloInfratelBando1_3_7 || 0) +
            (datiBando1.vincoloInfratelBando1_3_8 || 0) +
            (datiBando1.vincoloInfratelBando1_3_9 || 0) +
            (datiBando1.vincoloInfratelBando1_3_10 || 0) +
            (datiBando1.vincoloInfratelBando1_3_11 || 0) +
            (datiBando1.vincoloInfratelBando1_3_12 || 0),
        },
      ];

      const vincoloOFData = [
        {
          "": "2.1 TRIPLETTA NON COMPLETA",
          "LOTTO 6": datiBando1.vincoloOFBando1_2_1_Lotto6
            ? datiBando1.vincoloOFBando1_2_1_Lotto6
            : 0,
          "LOTTO 7": datiBando1.vincoloOFBando1_2_1_Lotto7
            ? datiBando1.vincoloOFBando1_2_1_Lotto7
            : 0,
          TOTALE: datiBando1.vincoloOFBando1_2_1
            ? datiBando1.vincoloOFBando1_2_1
            : 0,
        },
        {
          "": "2.2 OF NON VENDIBILE",
          "LOTTO 6": datiBando1.vincoloOFBando1_2_2_Lotto6
            ? datiBando1.vincoloOFBando1_2_2_Lotto6
            : 0,
          "LOTTO 7": datiBando1.vincoloOFBando1_2_2_Lotto7
            ? datiBando1.vincoloOFBando1_2_2_Lotto7
            : 0,
          TOTALE: datiBando1.vincoloOFBando1_2_2
            ? datiBando1.vincoloOFBando1_2_2
            : 0,
        },
        {
          "": "2.3 MANCA MOC OF",
          "LOTTO 6": datiBando1.vincoloOFBando1_2_3_Lotto6
            ? datiBando1.vincoloOFBando1_2_3_Lotto6
            : 0,
          "LOTTO 7": datiBando1.vincoloOFBando1_2_3_Lotto7
            ? datiBando1.vincoloOFBando1_2_3_Lotto7
            : 0,
          TOTALE: datiBando1.vincoloOFBando1_2_3
            ? datiBando1.vincoloOFBando1_2_3
            : 0,
        },
        {
          "": "2.4 ASSENZA SEGNALE OF",
          "LOTTO 6": datiBando1.vincoloOFBando1_2_4_Lotto6
            ? datiBando1.vincoloOFBando1_2_4_Lotto6
            : 0,
          "LOTTO 7": datiBando1.vincoloOFBando1_2_4_Lotto7
            ? datiBando1.vincoloOFBando1_2_4_Lotto7
            : 0,
          TOTALE: datiBando1.vincoloOFBando1_2_4
            ? datiBando1.vincoloOFBando1_2_4
            : 0,
        },
        {
          "": "2.5 PERMUTA PCN",
          "LOTTO 6": datiBando1.vincoloOFBando1_2_5_Lotto6
            ? datiBando1.vincoloOFBando1_2_5_Lotto6
            : 0,
          "LOTTO 7": datiBando1.vincoloOFBando1_2_5_Lotto7
            ? datiBando1.vincoloOFBando1_2_5_Lotto7
            : 0,
          TOTALE: datiBando1.vincoloOFBando1_2_5
            ? datiBando1.vincoloOFBando1_2_5
            : 0,
        },
        {
          "": "2.6 ALTRO (F1)",
          "LOTTO 6": datiBando1.vincoloOFBando1_2_6_Lotto6
            ? datiBando1.vincoloOFBando1_2_6_Lotto6
            : 0,
          "LOTTO 7": datiBando1.vincoloOFBando1_2_6_Lotto7
            ? datiBando1.vincoloOFBando1_2_6_Lotto7
            : 0,
          TOTALE: datiBando1.vincoloOFBando1_2_6
            ? datiBando1.vincoloOFBando1_2_6
            : 0,
        },
        {
          "": "2.7 OF NON ORDINATA",
          "LOTTO 6": datiBando1.vincoloOFBando1_2_7_Lotto6
            ? datiBando1.vincoloOFBando1_2_7_Lotto6
            : 0,
          "LOTTO 7": datiBando1.vincoloOFBando1_2_7_Lotto7
            ? datiBando1.vincoloOFBando1_2_7_Lotto7
            : 0,
          TOTALE: datiBando1.vincoloOFBando1_2_7
            ? datiBando1.vincoloOFBando1_2_7
            : 0,
        },
        {
          "": "2.8 OF INDIRIZZO KO",
          "LOTTO 6": datiBando1.vincoloOFBando1_2_8_Lotto6
            ? datiBando1.vincoloOFBando1_2_8_Lotto6
            : 0,
          "LOTTO 7": datiBando1.vincoloOFBando1_2_8_Lotto7
            ? datiBando1.vincoloOFBando1_2_8_Lotto7
            : 0,
          TOTALE: datiBando1.vincoloOFBando1_2_8
            ? datiBando1.vincoloOFBando1_2_8
            : 0,
        },
        {
          "": "2.9 ALTRO (F2)	",
          "LOTTO 6": datiBando1.vincoloOFBando1_2_9_Lotto6
            ? datiBando1.vincoloOFBando1_2_9_Lotto6
            : 0,
          "LOTTO 7": datiBando1.vincoloOFBando1_2_9_Lotto7
            ? datiBando1.vincoloOFBando1_2_9_Lotto7
            : 0,
          TOTALE: datiBando1.vincoloOFBando1_2_9
            ? datiBando1.vincoloOFBando1_2_9
            : 0,
        },

        {
          "": "TOTALI",
          "LOTTO 6":
            (datiBando1.vincoloOFBando1_2_1_Lotto6 || 0) +
            (datiBando1.vincoloOFBando1_2_2_Lotto6 || 0) +
            (datiBando1.vincoloOFBando1_2_3_Lotto6 || 0) +
            (datiBando1.vincoloOFBando1_2_4_Lotto6 || 0) +
            (datiBando1.vincoloOFBando1_2_5_Lotto6 || 0) +
            (datiBando1.vincoloOFBando1_2_6_Lotto6 || 0) +
            (datiBando1.vincoloOFBando1_2_7_Lotto6 || 0) +
            (datiBando1.vincoloOFBando1_2_8_Lotto6 || 0) +
            (datiBando1.vincoloOFBando1_2_9_Lotto6 || 0),
          "LOTTO 7":
            (datiBando1.vincoloOFBando1_2_1_Lotto7 || 0) +
            (datiBando1.vincoloOFBando1_2_2_Lotto7 || 0) +
            (datiBando1.vincoloOFBando1_2_3_Lotto7 || 0) +
            (datiBando1.vincoloOFBando1_2_4_Lotto7 || 0) +
            (datiBando1.vincoloOFBando1_2_5_Lotto7 || 0) +
            (datiBando1.vincoloOFBando1_2_6_Lotto7 || 0) +
            (datiBando1.vincoloOFBando1_2_7_Lotto7 || 0) +
            (datiBando1.vincoloOFBando1_2_8_Lotto7 || 0) +
            (datiBando1.vincoloOFBando1_2_9_Lotto7 || 0),
          TOTALE:
            (datiBando1.vincoloOFBando1_2_1 || 0) +
            (datiBando1.vincoloOFBando1_2_2 || 0) +
            (datiBando1.vincoloOFBando1_2_3 || 0) +
            (datiBando1.vincoloOFBando1_2_4 || 0) +
            (datiBando1.vincoloOFBando1_2_5 || 0) +
            (datiBando1.vincoloOFBando1_2_6 || 0) +
            (datiBando1.vincoloOFBando1_2_7 || 0) +
            (datiBando1.vincoloOFBando1_2_8 || 0) +
            (datiBando1.vincoloOFBando1_2_9 || 0),
        },
      ];

      const vincoloFibercopData = [
        {
          "": "1.1 MSAN",
          "LOTTO 6": datiBando1.vincoloFibercopBando1_1_1_Lotto6
            ? datiBando1.vincoloFibercopBando1_1_1_Lotto6
            : 0,
          "LOTTO 7": datiBando1.vincoloFibercopBando1_1_1_Lotto7
            ? datiBando1.vincoloFibercopBando1_1_1_Lotto7
            : 0,
          TOTALE: datiBando1.vincoloFibercopBando1_1_1
            ? datiBando1.vincoloFibercopBando1_1_1
            : 0,
        },
        {
          "": "1.2 OLT",
          "LOTTO 6": datiBando1.vincoloFibercopBando1_1_2_Lotto6
            ? datiBando1.vincoloFibercopBando1_1_2_Lotto6
            : 0,
          "LOTTO 7": datiBando1.vincoloFibercopBando1_1_2_Lotto7
            ? datiBando1.vincoloFibercopBando1_1_2_Lotto7
            : 0,
          TOTALE: datiBando1.vincoloFibercopBando1_1_2
            ? datiBando1.vincoloFibercopBando1_1_2
            : 0,
        },
        {
          "": "1.4 PERMESSO",
          "LOTTO 6": datiBando1.vincoloFibercopBando1_1_3_Lotto6
            ? datiBando1.vincoloFibercopBando1_1_3_Lotto6
            : 0,
          "LOTTO 7": datiBando1.vincoloFibercopBando1_1_3_Lotto7
            ? datiBando1.vincoloFibercopBando1_1_3_Lotto7
            : 0,
          TOTALE: datiBando1.vincoloFibercopBando1_1_3
            ? datiBando1.vincoloFibercopBando1_1_3
            : 0,
        },
        {
          "": "1.6 ASSENZA SEGNALE FC",
          "LOTTO 6": datiBando1.vincoloFibercopBando1_1_4_Lotto6
            ? datiBando1.vincoloFibercopBando1_1_4_Lotto6
            : 0,
          "LOTTO 7": datiBando1.vincoloFibercopBando1_1_4_Lotto7
            ? datiBando1.vincoloFibercopBando1_1_4_Lotto7
            : 0,
          TOTALE: datiBando1.vincoloFibercopBando1_1_4
            ? datiBando1.vincoloFibercopBando1_1_4
            : 0,
        },
        {
          "": "1.7 MANCA MOC FC",
          "LOTTO 6": datiBando1.vincoloFibercopBando1_1_5_Lotto6
            ? datiBando1.vincoloFibercopBando1_1_5_Lotto6
            : 0,
          "LOTTO 7": datiBando1.vincoloFibercopBando1_1_5_Lotto7
            ? datiBando1.vincoloFibercopBando1_1_5_Lotto7
            : 0,
          TOTALE: datiBando1.vincoloFibercopBando1_1_5
            ? datiBando1.vincoloFibercopBando1_1_5
            : 0,
        },

        {
          "": "TOTALI",
          "LOTTO 6":
            (datiBando1.vincoloFibercopBando1_1_1_Lotto6 || 0) +
            (datiBando1.vincoloFibercopBando1_1_2_Lotto6 || 0) +
            (datiBando1.vincoloFibercopBando1_1_3_Lotto6 || 0) +
            (datiBando1.vincoloFibercopBando1_1_4_Lotto6 || 0) +
            (datiBando1.vincoloFibercopBando1_1_5_Lotto6 || 0),
          "LOTTO 7":
            (datiBando1.vincoloFibercopBando1_1_1_Lotto7 || 0) +
            (datiBando1.vincoloFibercopBando1_1_2_Lotto7 || 0) +
            (datiBando1.vincoloFibercopBando1_1_3_Lotto7 || 0) +
            (datiBando1.vincoloFibercopBando1_1_4_Lotto7 || 0) +
            (datiBando1.vincoloFibercopBando1_1_5_Lotto7 || 0),
          TOTALE:
            (datiBando1.vincoloFibercopBando1_1_1 || 0) +
            (datiBando1.vincoloFibercopBando1_1_2 || 0) +
            (datiBando1.vincoloFibercopBando1_1_3 || 0) +
            (datiBando1.vincoloFibercopBando1_1_4 || 0) +
            (datiBando1.vincoloFibercopBando1_1_5 || 0),
        },
      ];

      const vincoloTimData = [
        {
          "": "1.3 ONEROSA",
          "LOTTO 6": datiBando1.vincoloTimBando1_1_3_Lotto6
            ? datiBando1.vincoloTimBando1_1_3_Lotto6
            : 0,
          "LOTTO 7": datiBando1.vincoloTimBando1_1_3_Lotto7
            ? datiBando1.vincoloTimBando1_1_3_Lotto7
            : 0,
          TOTALE: datiBando1.vincoloTimBando1_1_3
            ? datiBando1.vincoloTimBando1_1_3
            : 0,
        },
        {
          "": "1.5 MANCA MOC TIM",
          "LOTTO 6": datiBando1.vincoloTimBando1_1_5_Lotto6
            ? datiBando1.vincoloTimBando1_1_5_Lotto6
            : 0,
          "LOTTO 7": datiBando1.vincoloTimBando1_1_5_Lotto7
            ? datiBando1.vincoloTimBando1_1_5_Lotto7
            : 0,
          TOTALE: datiBando1.vincoloTimBando1_1_5
            ? datiBando1.vincoloTimBando1_1_5
            : 0,
        },
        {
          "": "1.8 ALTRO (F1)",
          "LOTTO 6": datiBando1.vincoloTimBando1_1_8_Lotto6
            ? datiBando1.vincoloTimBando1_1_8_Lotto6
            : 0,
          "LOTTO 7": datiBando1.vincoloTimBando1_1_8_Lotto7
            ? datiBando1.vincoloTimBando1_1_8_Lotto7
            : 0,
          TOTALE: datiBando1.vincoloTimBando1_1_8
            ? datiBando1.vincoloTimBando1_1_8
            : 0,
        },
        {
          "": "1.9 ALTRO (F2)",
          "LOTTO 6": datiBando1.vincoloTimBando1_1_9_Lotto6
            ? datiBando1.vincoloTimBando1_1_9_Lotto6
            : 0,
          "LOTTO 7": datiBando1.vincoloTimBando1_1_9_Lotto7
            ? datiBando1.vincoloTimBando1_1_9_Lotto7
            : 0,
          TOTALE: datiBando1.vincoloTimBando1_1_9
            ? datiBando1.vincoloTimBando1_1_9
            : 0,
        },
        {
          "": "1.10 VERIFICA OL TIM",
          "LOTTO 6": datiBando1.vincoloTimBando1_1_10_Lotto6
            ? datiBando1.vincoloTimBando1_1_10_Lotto6
            : 0,
          "LOTTO 7": datiBando1.vincoloTimBando1_1_10_Lotto7
            ? datiBando1.vincoloTimBando1_1_10_Lotto7
            : 0,
          TOTALE: datiBando1.vincoloTimBando1_1_10
            ? datiBando1.vincoloTimBando1_1_10
            : 0,
        },
        {
          "": "1.11 INFRASTRUTTURA CLIENTE ONEROSA",
          "LOTTO 6": datiBando1.vincoloTimBando1_1_11_Lotto6
            ? datiBando1.vincoloTimBando1_1_11_Lotto6
            : 0,
          "LOTTO 7": datiBando1.vincoloTimBando1_1_11_Lotto7
            ? datiBando1.vincoloTimBando1_1_11_Lotto7
            : 0,
          TOTALE: datiBando1.vincoloTimBando1_1_11
            ? datiBando1.vincoloTimBando1_1_11
            : 0,
        },

        {
          "": "TOTALI",
          "LOTTO 6":
            (datiBando1.vincoloTimBando1_1_3_Lotto6 || 0) +
            (datiBando1.vincoloTimBando1_1_5_Lotto6 || 0) +
            (datiBando1.vincoloTimBando1_1_8_Lotto6 || 0) +
            (datiBando1.vincoloTimBando1_1_9_Lotto6 || 0) +
            (datiBando1.vincoloTimBando1_1_10_Lotto6 || 0) +
            (datiBando1.vincoloTimBando1_1_11_Lotto6 || 0),
          "LOTTO 7":
            (datiBando1.vincoloTimBando1_1_3_Lotto7 || 0) +
            (datiBando1.vincoloTimBando1_1_5_Lotto7 || 0) +
            (datiBando1.vincoloTimBando1_1_8_Lotto7 || 0) +
            (datiBando1.vincoloTimBando1_1_9_Lotto7 || 0) +
            (datiBando1.vincoloTimBando1_1_10_Lotto7 || 0) +
            (datiBando1.vincoloTimBando1_1_11_Lotto7 || 0),
          TOTALE:
            (datiBando1.vincoloTimBando1_1_3 || 0) +
            (datiBando1.vincoloTimBando1_1_5 || 0) +
            (datiBando1.vincoloTimBando1_1_8 || 0) +
            (datiBando1.vincoloTimBando1_1_9 || 0) +
            (datiBando1.vincoloTimBando1_1_10 || 0) +
            (datiBando1.vincoloTimBando1_1_11 || 0),
        },
      ];

      const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(
        complessivoData,
        {
          header: [],
        },
      );

      // Imposto gli header
      bando1Headers.forEach((header, index) => {
        const cellRef = XLSX.utils.encode_cell({ r: 0, c: index });
        worksheet[cellRef] = { v: header };
      });

      const worksheet2: XLSX.WorkSheet = XLSX.utils.json_to_sheet(
        daAttivareData,
        {
          header: [],
        },
      );
      const worksheet3: XLSX.WorkSheet = XLSX.utils.json_to_sheet(
        fuoriPerimetroData,
        {
          header: [],
        },
      );
      const worksheet4: XLSX.WorkSheet = XLSX.utils.json_to_sheet(
        lavorabiliData,
        {
          header: [],
        },
      );
      const worksheet5: XLSX.WorkSheet = XLSX.utils.json_to_sheet(
        vincoloInfratelData,
        {
          header: [],
        },
      );
      const worksheet6: XLSX.WorkSheet = XLSX.utils.json_to_sheet(
        vincoloOFData,
        {
          header: [],
        },
      );
      const worksheet7: XLSX.WorkSheet = XLSX.utils.json_to_sheet(
        vincoloFibercopData,
        {
          header: [],
        },
      );
      const worksheet8: XLSX.WorkSheet = XLSX.utils.json_to_sheet(
        vincoloTimData,
        {
          header: [],
        },
      );
      // Imposto gli header per il secondo foglio
      bando1Headers.forEach((header, index) => {
        const cellRef = XLSX.utils.encode_cell({ r: 0, c: index });
        worksheet2[cellRef] = { v: header };
      });

      const workbook: XLSX.WorkBook = {
        Sheets: {
          COMPLESSIVO: worksheet,
          "DA ATTIVARE": worksheet2,
          "FUORI PERIMETRO": worksheet3,
          LAVORABILI: worksheet4,
          "VINCOLO INFRATEL": worksheet5,
          "VINCOLO OPENFIBER": worksheet6,
          "VINCOLO FIBERCOP": worksheet7,
          "VINCOLO TIM": worksheet8,
        },
        SheetNames: [
          "COMPLESSIVO",
          "DA ATTIVARE",
          "FUORI PERIMETRO",
          "LAVORABILE + PRONTO FIBRA",
          "VINCOLO INFRATEL",
          "VINCOLO OPENFIBER",
          "VINCOLO FIBERCOP",
          "VINCOLO TIM",
        ],
      };

      const excelBuffer: any = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      const blob = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      // Salva il file Excel
      saveAs(blob, filename);

      // Bando 1 - Dati da Attivare
      /*  
           const workbook: XLSX.WorkBook = XLSX.utils.book_new();
const wsBando1DaAttivare = XLSX.utils.json_to_sheet([{
        'Dati da Attivare Bando 1': '',
        'Totale': datiBando1.daAttivareBando1,
        'PF': datiBando1.daAttivareBando1PF,
        'PF Lotto 6': datiBando1.daAttivareBando1PFLotto6,
        'PF Lotto 7': datiBando1.daAttivareBando1PFLotto7,
        'Lavorabili': datiBando1.daAttivareBando1Lavorabile,
        'Lavorabili Lotto 6': datiBando1.daAttivareBando1LavorabileLotto6,
        'Lavorabili Lotto 7': datiBando1.daAttivareBando1LavorabileLotto7,
        'Vincolo Infratel': datiBando1.daAttivareBando1VincoloInfratel,
        'Vincolo Infratel Lotto 6': datiBando1.daAttivareBando1VincoloInfratelLotto6,
        'Vincolo Infratel Lotto 7': datiBando1.daAttivareBando1VincoloInfratelLotto7,
        'Vincolo OF': datiBando1.daAttivareBando1VincoloOF,
        'Vincolo OF Lotto 6': datiBando1.daAttivareBando1VincoloOFLotto6,
        'Vincolo OF Lotto 7': datiBando1.daAttivareBando1VincoloOFLotto7,
        'Vincolo Fibercop': datiBando1.daAttivareBando1VincoloFibercop,
        'Vincolo Fibercop Lotto 6': datiBando1.daAttivareBando1VincoloFibercopLotto6,
        'Vincolo Fibercop Lotto 7': datiBando1.daAttivareBando1VincoloFibercopLotto7,
        'Vincolo TIM': datiBando1.daAttivareBando1VincoloTim,
        'Vincolo TIM Lotto 6': datiBando1.daAttivareBando1VincoloTimLotto6,
        'Vincolo TIM Lotto 7': datiBando1.daAttivareBando1VincoloTimLotto7
      }]);
      XLSX.utils.book_append_sheet(workbook, wsBando1DaAttivare, 'Bando1_DaAttivare');

      // Bando 1 - Dati Lavorabili
      const wsBando1Lavorabili = XLSX.utils.json_to_sheet([{
        'Dati Lavorabili Bando 1': '',
        'Totale': datiBando1.lavorabiliBando1,
        'Lotto 6': datiBando1.lavorabiliBando1Lotto6,
        'Lotto 7': datiBando1.lavorabiliBando1Lotto7,
        'TIM': datiBando1.lavorabiliBando1Tim,
        'TIM Lotto 6': datiBando1.lavorabiliBando1TimLotto6,
        'TIM Lotto 7': datiBando1.lavorabiliBando1TimLotto7,
        'Fibercop': datiBando1.lavorabiliBando1Fibercop,
        'Fibercop Lotto 6': datiBando1.lavorabiliBando1FibercopLotto6,
        'Fibercop Lotto 7': datiBando1.lavorabiliBando1FibercopLotto7,
        'OF': datiBando1.lavorabiliBando1OF,
        'OF Lotto 6': datiBando1.lavorabiliBando1OFLotto6,
        'OF Lotto 7': datiBando1.lavorabiliBando1OFLotto7,
        'Infratel': datiBando1.lavorabiliBando1Infratel,
        'Infratel Lotto 6': datiBando1.lavorabiliBando1InfratelLotto6,
        'Infratel Lotto 7': datiBando1.lavorabiliBando1InfratelLotto7
      }]);
      XLSX.utils.book_append_sheet(workbook, wsBando1Lavorabili, 'Bando1_Lavorabili');

      // Bando 2 - Dati Complessivi
      const wsBando2Complessivi = XLSX.utils.json_to_sheet([{
        'Dati Complessivi Bando 2': '',
        'Totale': datiBando2.complessivoBando2,
        'Attivate': datiBando2.complessivoBando2Attivate,
        'Attivate Lotto 1': datiBando2.complessivoBando2AttivateLotto1,
        'Attivate Lotto 5': datiBando2.complessivoBando2AttivateLotto5,
        'Attivate Lotto 7': datiBando2.complessivoBando2AttivateLotto7,
        'Attivate Lotto 8': datiBando2.complessivoBando2AttivateLotto8,
        'Da Attivare': datiBando2.complessivoBando2DaAttivare,
        'Da Attivare Lotto 1': datiBando2.complessivoBando2DaAttivareLotto1,
        'Da Attivare Lotto 5': datiBando2.complessivoBando2DaAttivareLotto5,
        'Da Attivare Lotto 7': datiBando2.complessivoBando2DaAttivareLotto7,
        'Da Attivare Lotto 8': datiBando2.complessivoBando2DaAttivareLotto8,
        'Fuori Perimetro': datiBando2.complessivoBando2FuoriPerimetro,
        'Fuori Perimetro Lotto 1': datiBando2.complessivoBando2FuoriPerimetroLotto1,
        'Fuori Perimetro Lotto 5': datiBando2.complessivoBando2FuoriPerimetroLotto5,
        'Fuori Perimetro Lotto 7': datiBando2.complessivoBando2FuoriPerimetroLotto7,
        'Fuori Perimetro Lotto 8': datiBando2.complessivoBando2FuoriPerimetroLotto8
      }]);
      XLSX.utils.book_append_sheet(workbook, wsBando2Complessivi, 'Bando2_Complessivi');

      // Bando 2 - Dati da Attivare
      const wsBando2DaAttivare = XLSX.utils.json_to_sheet([{
        'Dati da Attivare Bando 2': '',
        'Totale': datiBando2.daAttivareBando2,
        'PF': datiBando2.daAttivareBando2PF,
        'PF Lotto 1': datiBando2.daAttivareBando2PFLotto1,
        'PF Lotto 5': datiBando2.daAttivareBando2PFLotto5,
        'PF Lotto 7': datiBando2.daAttivareBando2PFLotto7,
        'PF Lotto 8': datiBando2.daAttivareBando2PFLotto8,
        'Lavorabili': datiBando2.daAttivareBando2Lavorabile,
        'Lavorabili Lotto 1': datiBando2.daAttivareBando2LavorabileLotto1,
        'Lavorabili Lotto 5': datiBando2.daAttivareBando2LavorabileLotto5,
        'Lavorabili Lotto 7': datiBando2.daAttivareBando2LavorabileLotto7,
        'Lavorabili Lotto 8': datiBando2.daAttivareBando2LavorabileLotto8,
        'Vincolo Infratel': datiBando2.daAttivareBando2VincoloInfratel,
        'Vincolo Infratel Lotto 1': datiBando2.daAttivareBando2VincoloInfratelLotto1,
        'Vincolo Infratel Lotto 5': datiBando2.daAttivareBando2VincoloInfratelLotto5,
        'Vincolo Infratel Lotto 7': datiBando2.daAttivareBando2VincoloInfratelLotto7,
        'Vincolo Infratel Lotto 8': datiBando2.daAttivareBando2VincoloInfratelLotto8,
        'Vincolo OF': datiBando2.daAttivareBando2VincoloOF,
        'Vincolo OF Lotto 1': datiBando2.daAttivareBando2VincoloOFLotto1,
        'Vincolo OF Lotto 5': datiBando2.daAttivareBando2VincoloOFLotto5,
        'Vincolo OF Lotto 7': datiBando2.daAttivareBando2VincoloOFLotto7,
        'Vincolo OF Lotto 8': datiBando2.daAttivareBando2VincoloOFLotto8,
        'Vincolo Fibercop': datiBando2.daAttivareBando2VincoloFibercop,
        'Vincolo Fibercop Lotto 1': datiBando2.daAttivareBando2VincoloFibercopLotto1,
        'Vincolo Fibercop Lotto 5': datiBando2.daAttivareBando2VincoloFibercopLotto5,
        'Vincolo Fibercop Lotto 7': datiBando2.daAttivareBando2VincoloFibercopLotto7,
        'Vincolo Fibercop Lotto 8': datiBando2.daAttivareBando2VincoloFibercopLotto8,
        'Vincolo TIM': datiBando2.daAttivareBando2VincoloTim,
        'Vincolo TIM Lotto 1': datiBando2.daAttivareBando2VincoloTimLotto1,
        'Vincolo TIM Lotto 5': datiBando2.daAttivareBando2VincoloTimLotto5,
        'Vincolo TIM Lotto 7': datiBando2.daAttivareBando2VincoloTimLotto7,
        'Vincolo TIM Lotto 8': datiBando2.daAttivareBando2VincoloTimLotto8
      }]);
      XLSX.utils.book_append_sheet(workbook, wsBando2DaAttivare, 'Bando2_DaAttivare');

      // Bando 2 - Dati Lavorabili
      const wsBando2Lavorabili = XLSX.utils.json_to_sheet([{
        'Dati Lavorabili Bando 2': '',
        'Totale': datiBando2.lavorabiliBando2,
        'Lotto 1': datiBando2.lavorabiliBando2Lotto1,
        'Lotto 5': datiBando2.lavorabiliBando2Lotto5,
        'Lotto 7': datiBando2.lavorabiliBando2Lotto7,
        'Lotto 8': datiBando2.lavorabiliBando2Lotto8,
        'TIM': datiBando2.lavorabiliBando2Tim,
        'TIM Lotto 1': datiBando2.lavorabiliBando2TimLotto1,
        'TIM Lotto 5': datiBando2.lavorabiliBando2TimLotto5,
        'TIM Lotto 7': datiBando2.lavorabiliBando2TimLotto7,
        'TIM Lotto 8': datiBando2.lavorabiliBando2TimLotto8,
        'Fibercop': datiBando2.lavorabiliBando2Fibercop,
        'Fibercop Lotto 1': datiBando2.lavorabiliBando2FibercopLotto1,
        'Fibercop Lotto 5': datiBando2.lavorabiliBando2FibercopLotto5,
        'Fibercop Lotto 7': datiBando2.lavorabiliBando2FibercopLotto7,
        'Fibercop Lotto 8': datiBando2.lavorabiliBando2FibercopLotto8,
        'OF': datiBando2.lavorabiliBando2OF,
        'OF Lotto 1': datiBando2.lavorabiliBando2OFLotto1,
        'OF Lotto 5': datiBando2.lavorabiliBando2OFLotto5,
        'OF Lotto 7': datiBando2.lavorabiliBando2OFLotto7,
        'OF Lotto 8': datiBando2.lavorabiliBando2OFLotto8,
        'Infratel': datiBando2.lavorabiliBando2Infratel,
        'Infratel Lotto 1': datiBando2.lavorabiliBando2InfratelLotto1,
        'Infratel Lotto 5': datiBando2.lavorabiliBando2InfratelLotto5,
        'Infratel Lotto 7': datiBando2.lavorabiliBando2InfratelLotto7,
        'Infratel Lotto 8': datiBando2.lavorabiliBando2InfratelLotto8
      }]);
      XLSX.utils.book_append_sheet(workbook, wsBando2Lavorabili, 'Bando2_Lavorabili'); 

      // Imposta le larghezze delle colonne per tutti i fogli
      const sheets = [complessivoData];
      
      sheets.forEach(sheet => {
        const wscols = [];
        for (let i = 0; i < Object.keys(sheet).length; i++) {
          wscols.push({ wch: 20 }); // Imposta una larghezza fissa per tutte le colonne
        }
        sheet['!cols'] = wscols;
      });

      // Salva il file
      XLSX.writeFile(workbook, filename);
      */
    } catch (error) {
      this.logger.error("Errore durante la generazione del file Excel:", error);
      throw error;
    }
  }
  exportBando2OverallToExcel(datiBando2: any, filename: string): void {
    try {
      const bando2Headers = [
        "",
        "LOTTO 1",
        "LOTTO 5",
        "LOTTO 7",
        "LOTTO 8",
        "TOTALE",
      ];

      const complessivoData = [
        {
          "": "ATTIVATE",
          "LOTTO 1": datiBando2.complessivoBando2AttivateLotto1,
          "LOTTO 5": datiBando2.complessivoBando2AttivateLotto5,
          "LOTTO 7": datiBando2.complessivoBando2AttivateLotto7,
          "LOTTO 8": datiBando2.complessivoBando2AttivateLotto8,
          TOTALE: datiBando2.complessivoBando2Attivate,
        },
        {
          "": "DA ATTIVARE",
          "LOTTO 1": datiBando2.complessivoBando2DaAttivareLotto1,
          "LOTTO 5": datiBando2.complessivoBando2DaAttivareLotto5,
          "LOTTO 7": datiBando2.complessivoBando2DaAttivareLotto7,
          "LOTTO 8": datiBando2.complessivoBando2DaAttivareLotto8,
          TOTALE: datiBando2.complessivoBando2DaAttivare,
        },
        {
          "": "FUORI PERIMETRO",
          "LOTTO 1": datiBando2.complessivoBando2FuoriPerimetroLotto1,
          "LOTTO 5": datiBando2.complessivoBando2FuoriPerimetroLotto5,
          "LOTTO 7": datiBando2.complessivoBando2FuoriPerimetroLotto7,
          "LOTTO 8": datiBando2.complessivoBando2FuoriPerimetroLotto8,
          TOTALE: datiBando2.complessivoBando2FuoriPerimetro,
        },
        {
          "": "TOTALI",
          "LOTTO 1":
            (datiBando2.complessivoBando2AttivateLotto1 || 0) +
            (datiBando2.complessivoBando2DaAttivareLotto1 || 0) +
            (datiBando2.complessivoBando2FuoriPerimetroLotto1 || 0),
          "LOTTO 5":
            (datiBando2.complessivoBando2AttivateLotto5 || 0) +
            (datiBando2.complessivoBando2DaAttivareLotto5 || 0) +
            (datiBando2.complessivoBando2FuoriPerimetroLotto5 || 0),
          "LOTTO 7":
            (datiBando2.complessivoBando2AttivateLotto7 || 0) +
            (datiBando2.complessivoBando2DaAttivareLotto7 || 0) +
            (datiBando2.complessivoBando2FuoriPerimetroLotto7 || 0),
          "LOTTO 8":
            (datiBando2.complessivoBando2AttivateLotto8 || 0) +
            (datiBando2.complessivoBando2DaAttivareLotto8 || 0) +
            (datiBando2.complessivoBando2FuoriPerimetroLotto8 || 0),
          TOTALE:
            (datiBando2.complessivoBando2Attivate || 0) +
            (datiBando2.complessivoBando2DaAttivare || 0) +
            (datiBando2.complessivoBando2FuoriPerimetro || 0),
        },
      ];

      const daAttivareData = [
        {
          "": "PRONTOFIBRA",
          "LOTTO 1": datiBando2.daAttivareBando2PFLotto1,
          "LOTTO 5": datiBando2.daAttivareBando2PFLotto5,
          "LOTTO 7": datiBando2.daAttivareBando2PFLotto7,
          "LOTTO 8": datiBando2.daAttivareBando2PFLotto8,
          TOTALE: datiBando2.daAttivareBando2PF,
        },
        {
          "": "LAVORABILE",
          "LOTTO 1": datiBando2.daAttivareBando2LavorabileLotto1,
          "LOTTO 5": datiBando2.daAttivareBando2LavorabileLotto5,
          "LOTTO 7": datiBando2.daAttivareBando2LavorabileLotto7,
          "LOTTO 8": datiBando2.daAttivareBando2LavorabileLotto8,
          TOTALE: datiBando2.daAttivareBando2Lavorabile,
        },
        {
          "": "VINCOLO INFRATEL",
          "LOTTO 1": datiBando2.daAttivareBando2VincoloInfratelLotto1,
          "LOTTO 5": datiBando2.daAttivareBando2VincoloInfratelLotto5,
          "LOTTO 7": datiBando2.daAttivareBando2VincoloInfratelLotto7,
          "LOTTO 8": datiBando2.daAttivareBando2VincoloInfratelLotto8,
          TOTALE: datiBando2.daAttivareBando2VincoloInfratel,
        },
        {
          "": "VINCOLO OF",
          "LOTTO 1": datiBando2.daAttivareBando2VincoloOFLotto1,
          "LOTTO 5": datiBando2.daAttivareBando2VincoloOFLotto5,
          "LOTTO 7": datiBando2.daAttivareBando2VincoloOFLotto7,
          "LOTTO 8": datiBando2.daAttivareBando2VincoloOFLotto8,
          TOTALE: datiBando2.daAttivareBando2VincoloOF,
        },
        {
          "": "VINCOLO FIBERCOP",
          "LOTTO 1": datiBando2.daAttivareBando2VincoloFibercopLotto1,
          "LOTTO 5": datiBando2.daAttivareBando2VincoloFibercopLotto5,
          "LOTTO 7": datiBando2.daAttivareBando2VincoloFibercopLotto7,
          "LOTTO 8": datiBando2.daAttivareBando2VincoloFibercopLotto8,
          TOTALE: datiBando2.daAttivareBando2VincoloFibercop,
        },
        {
          "": "VINCOLO TIM",
          "LOTTO 1": datiBando2.daAttivareBando2VincoloTimLotto1,
          "LOTTO 5": datiBando2.daAttivareBando2VincoloTimLotto5,
          "LOTTO 7": datiBando2.daAttivareBando2VincoloTimLotto7,
          "LOTTO 8": datiBando2.daAttivareBando2VincoloTimLotto8,
          TOTALE: datiBando2.daAttivareBando2VincoloTim,
        },
        {
          "": "TOTALI",
          "LOTTO 1":
            (datiBando2.daAttivareBando2PFLotto1 || 0) +
            (datiBando2.daAttivareBando2LavorabileLotto1 || 0) +
            (datiBando2.daAttivareBando2VincoloInfratelLotto1 || 0) +
            (datiBando2.daAttivareBando2VincoloOFLotto1 || 0) +
            (datiBando2.daAttivareBando2VincoloFibercopLotto1 || 0) +
            (datiBando2.daAttivareBando2VincoloTimLotto1 || 0),
          "LOTTO 5":
            (datiBando2.daAttivareBando2PFLotto5 || 0) +
            (datiBando2.daAttivareBando2LavorabileLotto5 || 0) +
            (datiBando2.daAttivareBando2VincoloInfratelLotto5 || 0) +
            (datiBando2.daAttivareBando2VincoloOFLotto5 || 0) +
            (datiBando2.daAttivareBando2VincoloFibercopLotto1 || 0) +
            (datiBando2.daAttivareBando2VincoloTimLotto5 || 0),
          "LOTTO 7":
            (datiBando2.daAttivareBando2PFLotto7 || 0) +
            (datiBando2.daAttivareBando2LavorabileLotto7 || 0) +
            (datiBando2.daAttivareBando2VincoloInfratelLotto7 || 0) +
            (datiBando2.daAttivareBando2VincoloOFLotto7 || 0) +
            (datiBando2.daAttivareBando2VincoloFibercopLotto7 || 0) +
            (datiBando2.daAttivareBando2VincoloTimLotto7 || 0),
          "LOTTO 8":
            (datiBando2.daAttivareBando2PFLotto8 || 0) +
            (datiBando2.daAttivareBando2LavorabileLotto8 || 0) +
            (datiBando2.daAttivareBando2VincoloInfratelLotto8 || 0) +
            (datiBando2.daAttivareBando2VincoloOFLotto8 || 0) +
            (datiBando2.daAttivareBando2VincoloFibercopLotto8 || 0) +
            (datiBando2.daAttivareBando2VincoloTimLotto8 || 0),
          TOTALE:
            (datiBando2.daAttivareBando2PF || 0) +
            (datiBando2.daAttivareBando2Lavorabile || 0) +
            (datiBando2.daAttivareBando2VincoloInfratel || 0) +
            (datiBando2.daAttivareBando2VincoloOF || 0) +
            (datiBando2.daAttivareBando2VincoloFibercop || 0) +
            (datiBando2.daAttivareBando2VincoloTim || 0),
        },
      ];

      const fuoriPerimetroData = [
        {
          "": "4.1 DISMESSA",
          "LOTTO 1": datiBando2.fuoriPerimetroBando2_4_1_Lotto1,
          "LOTTO 5": datiBando2.fuoriPerimetroBando2_4_1_Lotto5,
          "LOTTO 7": datiBando2.fuoriPerimetroBando2_4_1_Lotto7,
          "LOTTO 8": datiBando2.fuoriPerimetroBando2_4_1_Lotto8,
          TOTALE: datiBando2.fuoriPerimetroBando2_4_1,
        },
        {
          "": "4.2 MANCA ADESIONE",
          "LOTTO 1": datiBando2.fuoriPerimetroBando2_4_2_Lotto1,
          "LOTTO 5": datiBando2.fuoriPerimetroBando2_4_2_Lotto5,
          "LOTTO 7": datiBando2.fuoriPerimetroBando2_4_2_Lotto7,
          "LOTTO 8": datiBando2.fuoriPerimetroBando2_4_2_Lotto8,
          TOTALE: datiBando2.fuoriPerimetroBando2_4_2,
        },
        {
          "": "4.3 NON FATTIBILE",
          "LOTTO 1": datiBando2.fuoriPerimetroBando2_4_3_Lotto1,
          "LOTTO 5": datiBando2.fuoriPerimetroBando2_4_3_Lotto5,
          "LOTTO 7": datiBando2.fuoriPerimetroBando2_4_3_Lotto7,
          "LOTTO 8": datiBando2.fuoriPerimetroBando2_4_3_Lotto8,
          TOTALE: datiBando2.fuoriPerimetroBando2_4_3,
        },
        {
          "": "4.4 ANNULLATA	",
          "LOTTO 1": datiBando2.fuoriPerimetroBando2_4_4_Lotto1,
          "LOTTO 5": datiBando2.fuoriPerimetroBando2_4_4_Lotto5,
          "LOTTO 7": datiBando2.fuoriPerimetroBando2_4_4_Lotto7,
          "LOTTO 8": datiBando2.fuoriPerimetroBando2_4_4_Lotto8,
          TOTALE: datiBando2.fuoriPerimetroBando2_4_4,
        },

        {
          "": "TOTALI",
          "LOTTO 1":
            (datiBando2.fuoriPerimetroBando2_4_1_Lotto1 || 0) +
            (datiBando2.fuoriPerimetroBando2_4_2_Lotto1 || 0) +
            (datiBando2.fuoriPerimetroBando2_4_3_Lotto1 || 0) +
            (datiBando2.fuoriPerimetroBando2_4_4_Lotto1 || 0),
          "LOTTO 5":
            (datiBando2.fuoriPerimetroBando2_4_1_Lotto5 || 0) +
            (datiBando2.fuoriPerimetroBando2_4_2_Lotto5 || 0) +
            (datiBando2.fuoriPerimetroBando2_4_3_Lotto5 || 0) +
            (datiBando2.fuoriPerimetroBando2_4_4_Lotto5 || 0),
          "LOTTO 7":
            (datiBando2.fuoriPerimetroBando2_4_1_Lotto7 || 0) +
            (datiBando2.fuoriPerimetroBando2_4_2_Lotto7 || 0) +
            (datiBando2.fuoriPerimetroBando2_4_3_Lotto7 || 0) +
            (datiBando2.fuoriPerimetroBando2_4_4_Lotto7 || 0),
          "LOTTO 8":
            (datiBando2.fuoriPerimetroBando2_4_1_Lotto8 || 0) +
            (datiBando2.fuoriPerimetroBando2_4_2_Lotto8 || 0) +
            (datiBando2.fuoriPerimetroBando2_4_3_Lotto8 || 0) +
            (datiBando2.fuoriPerimetroBando2_4_4_Lotto8 || 0),
          TOTALE:
            (datiBando2.fuoriPerimetroBando2_4_1 || 0) +
            (datiBando2.fuoriPerimetroBando2_4_2 || 0) +
            (datiBando2.fuoriPerimetroBando2_4_3 || 0) +
            (datiBando2.fuoriPerimetroBando2_4_4 || 0),
        },
      ];

      const lavorabiliData = [
        {
          "": "TIM",
          "LOTTO 1": datiBando2.lavorabiliBando2TimLotto1,
          "LOTTO 5": datiBando2.lavorabiliBando2TimLotto5,
          "LOTTO 7": datiBando2.lavorabiliBando2TimLotto7,
          "LOTTO 8": datiBando2.lavorabiliBando2TimLotto8,
          TOTALE: datiBando2.lavorabiliBando2Tim,
        },

        {
          "": "FIBERCOP",
          "LOTTO 1": datiBando2.lavorabiliBando2FibercopLotto1,
          "LOTTO 5": datiBando2.lavorabiliBando2FibercopLotto5,
          "LOTTO 7": datiBando2.lavorabiliBando2FibercopLotto7,
          "LOTTO 8": datiBando2.lavorabiliBando2FibercopLotto8,
          TOTALE: datiBando2.lavorabiliBando2Fibercop,
        },
        {
          "": "OPENFIBER",
          "LOTTO 1": datiBando2.lavorabiliBando2OFLotto1,
          "LOTTO 5": datiBando2.lavorabiliBando2OFLotto5,
          "LOTTO 7": datiBando2.lavorabiliBando2OFLotto7,
          "LOTTO 8": datiBando2.lavorabiliBando2OFLotto8,
          TOTALE: datiBando2.lavorabiliBando2OF,
        },
        {
          "": "INFRATEL",
          "LOTTO 1": datiBando2.lavorabiliBando2InfratelLotto1,
          "LOTTO 5": datiBando2.lavorabiliBando2InfratelLotto5,
          "LOTTO 7": datiBando2.lavorabiliBando2InfratelLotto7,
          "LOTTO 8": datiBando2.lavorabiliBando2InfratelLotto8,
          TOTALE: datiBando2.lavorabiliBando2Infratel,
        },
        {
          "": "TOTALI",
          "LOTTO 1":
            (datiBando2.lavorabiliBando2TimLotto1 || 0) +
            (datiBando2.lavorabiliBando2FibercopLotto1 || 0) +
            (datiBando2.lavorabiliBando2OFLotto1 || 0) +
            (datiBando2.lavorabiliBando2InfratelLotto1 || 0),
          "LOTTO 5":
            (datiBando2.lavorabiliBando2TimLotto5 || 0) +
            (datiBando2.lavorabiliBando2FibercopLotto5 || 0) +
            (datiBando2.lavorabiliBando2OFLotto5 || 0) +
            (datiBando2.lavorabiliBando2InfratelLotto5 || 0),
          "LOTTO 7":
            (datiBando2.lavorabiliBando2TimLotto7 || 0) +
            (datiBando2.lavorabiliBando2FibercopLotto7 || 0) +
            (datiBando2.lavorabiliBando2OFLotto7 || 0) +
            (datiBando2.lavorabiliBando2InfratelLotto7 || 0),
          "LOTTO 8":
            (datiBando2.lavorabiliBando2TimLotto8 || 0) +
            (datiBando2.lavorabiliBando2FibercopLotto8 || 0) +
            (datiBando2.lavorabiliBando2OFLotto8 || 0) +
            (datiBando2.lavorabiliBando2InfratelLotto8 || 0),
          TOTALE:
            (datiBando2.lavorabiliBando2Tim || 0) +
            (datiBando2.lavorabiliBando2Fibercop || 0) +
            (datiBando2.lavorabiliBando2OF || 0) +
            (datiBando2.lavorabiliBando2Infratel || 0),
        },
      ];

      const vincoloInfratelData = [
        {
          "": "3.1 RISTRUTTURAZIONE",
          "LOTTO 1": datiBando2.vincoloInfratelBando2_3_1_Lotto1,
          "LOTTO 5": datiBando2.vincoloInfratelBando2_3_1_Lotto5,
          "LOTTO 7": datiBando2.vincoloInfratelBando2_3_1_Lotto7,
          "LOTTO 8": datiBando2.vincoloInfratelBando2_3_1_Lotto8,
          TOTALE: datiBando2.vincoloInfratelBando2_3_1,
        },
        {
          "": "3.2 CODICE MCN",
          "LOTTO 1": datiBando2.vincoloInfratelBando2_3_2_Lotto1,
          "LOTTO 5": datiBando2.vincoloInfratelBando2_3_2_Lotto5,
          "LOTTO 7": datiBando2.vincoloInfratelBando2_3_2_Lotto7,
          "LOTTO 8": datiBando2.vincoloInfratelBando2_3_2_Lotto8,
          TOTALE: datiBando2.vincoloInfratelBando2_3_2,
        },
        {
          "": "3.3 INDIRIZZO",
          "LOTTO 1": datiBando2.vincoloInfratelBando2_3_3_Lotto1,
          "LOTTO 5": datiBando2.vincoloInfratelBando2_3_3_Lotto5,
          "LOTTO 7": datiBando2.vincoloInfratelBando2_3_3_Lotto7,
          "LOTTO 8": datiBando2.vincoloInfratelBando2_3_3_Lotto8,
          TOTALE: datiBando2.vincoloInfratelBando2_3_3,
        },
        {
          "": "3.4 DISMISSIONE",
          "LOTTO 1": datiBando2.vincoloInfratelBando2_3_4_Lotto1,
          "LOTTO 5": datiBando2.vincoloInfratelBando2_3_4_Lotto5,
          "LOTTO 7": datiBando2.vincoloInfratelBando2_3_4_Lotto7,
          "LOTTO 8": datiBando2.vincoloInfratelBando2_3_4_Lotto8,
          TOTALE: datiBando2.vincoloInfratelBando2_3_4,
        },
        {
          "": "3.5 MANCATA ADESIONE",
          "LOTTO 1": datiBando2.vincoloInfratelBando2_3_5_Lotto1,
          "LOTTO 5": datiBando2.vincoloInfratelBando2_3_5_Lotto5,
          "LOTTO 7": datiBando2.vincoloInfratelBando2_3_5_Lotto7,
          "LOTTO 8": datiBando2.vincoloInfratelBando2_3_5_Lotto8,
          TOTALE: datiBando2.vincoloInfratelBando2_3_5,
        },
        {
          "": "3.6 SEDE A",
          "LOTTO 1": datiBando2.vincoloInfratelBando2_3_6_Lotto1,
          "LOTTO 5": datiBando2.vincoloInfratelBando2_3_6_Lotto5,
          "LOTTO 7": datiBando2.vincoloInfratelBando2_3_6_Lotto7,
          "LOTTO 8": datiBando2.vincoloInfratelBando2_3_6_Lotto8,
          TOTALE: datiBando2.vincoloInfratelBando2_3_6,
        },
        {
          "": "3.7 ATTESA CONFERMA DISMISSIONE",
          "LOTTO 1": datiBando2.vincoloInfratelBando2_3_7_Lotto1,
          "LOTTO 5": datiBando2.vincoloInfratelBando2_3_7_Lotto5,
          "LOTTO 7": datiBando2.vincoloInfratelBando2_3_7_Lotto7,
          "LOTTO 8": datiBando2.vincoloInfratelBando2_3_7_Lotto8,
          TOTALE: datiBando2.vincoloInfratelBando2_3_7,
        },
        {
          "": "3.8 ATTESA CONFERMA MANCATA ADESIONE",
          "LOTTO 1": datiBando2.vincoloInfratelBando2_3_8_Lotto1,
          "LOTTO 5": datiBando2.vincoloInfratelBando2_3_8_Lotto5,
          "LOTTO 7": datiBando2.vincoloInfratelBando2_3_8_Lotto7,
          "LOTTO 8": datiBando2.vincoloInfratelBando2_3_8_Lotto8,
          TOTALE: datiBando2.vincoloInfratelBando2_3_8,
        },
        {
          "": "3.9 IRU INFRATEL",
          "LOTTO 1": datiBando2.vincoloInfratelBando2_3_9_Lotto1,
          "LOTTO 5": datiBando2.vincoloInfratelBando2_3_9_Lotto5,
          "LOTTO 7": datiBando2.vincoloInfratelBando2_3_9_Lotto7,
          "LOTTO 8": datiBando2.vincoloInfratelBando2_3_9_Lotto8,
          TOTALE: datiBando2.vincoloInfratelBando2_3_9,
        },
        {
          "": "3.10 MANCANZA ALUNNI",
          "LOTTO 1": datiBando2.vincoloInfratelBando2_3_10_Lotto1,
          "LOTTO 5": datiBando2.vincoloInfratelBando2_3_10_Lotto5,
          "LOTTO 7": datiBando2.vincoloInfratelBando2_3_10_Lotto7,
          "LOTTO 8": datiBando2.vincoloInfratelBando2_3_10_Lotto8,
          TOTALE: datiBando2.vincoloInfratelBando2_3_10,
        },
        {
          "": "3.11 ALTRO (F1)",
          "LOTTO 1": datiBando2.vincoloInfratelBando2_3_11_Lotto1,
          "LOTTO 5": datiBando2.vincoloInfratelBando2_3_11_Lotto5,
          "LOTTO 7": datiBando2.vincoloInfratelBando2_3_11_Lotto7,
          "LOTTO 8": datiBando2.vincoloInfratelBando2_3_11_Lotto8,
          TOTALE: datiBando2.vincoloInfratelBando2_3_11,
        },
        {
          "": "3.12 ALTRO (F2)",
          "LOTTO 1": datiBando2.vincoloInfratelBando2_3_12_Lotto1,
          "LOTTO 5": datiBando2.vincoloInfratelBando2_3_12_Lotto5,
          "LOTTO 7": datiBando2.vincoloInfratelBando2_3_12_Lotto7,
          "LOTTO 8": datiBando2.vincoloInfratelBando2_3_12_Lotto8,
          TOTALE: datiBando2.vincoloInfratelBando2_3_12,
        },
        {
          "": "TOTALI",
          "LOTTO 1":
            (datiBando2.vincoloInfratelBando2_3_1_Lotto1 || 0) +
            (datiBando2.vincoloInfratelBando2_3_2_Lotto1 || 0) +
            (datiBando2.vincoloInfratelBando2_3_3_Lotto1 || 0) +
            (datiBando2.vincoloInfratelBando2_3_4_Lotto1 || 0) +
            (datiBando2.vincoloInfratelBando2_3_5_Lotto1 || 0) +
            (datiBando2.vincoloInfratelBando2_3_6_Lotto1 || 0) +
            (datiBando2.vincoloInfratelBando2_3_7_Lotto1 || 0) +
            (datiBando2.vincoloInfratelBando2_3_8_Lotto1 || 0) +
            (datiBando2.vincoloInfratelBando2_3_9_Lotto1 || 0) +
            (datiBando2.vincoloInfratelBando2_3_10_Lotto1 || 0) +
            (datiBando2.vincoloInfratelBando2_3_11_Lotto1 || 0) +
            (datiBando2.vincoloInfratelBando2_3_12_Lotto1 || 0),
          "LOTTO 5":
            (datiBando2.vincoloInfratelBando2_3_1_Lotto5 || 0) +
            (datiBando2.vincoloInfratelBando2_3_2_Lotto5 || 0) +
            (datiBando2.vincoloInfratelBando2_3_3_Lotto5 || 0) +
            (datiBando2.vincoloInfratelBando2_3_4_Lotto5 || 0) +
            (datiBando2.vincoloInfratelBando2_3_5_Lotto5 || 0) +
            (datiBando2.vincoloInfratelBando2_3_6_Lotto5 || 0) +
            (datiBando2.vincoloInfratelBando2_3_7_Lotto5 || 0) +
            (datiBando2.vincoloInfratelBando2_3_8_Lotto5 || 0) +
            (datiBando2.vincoloInfratelBando2_3_9_Lotto5 || 0) +
            (datiBando2.vincoloInfratelBando2_3_10_Lotto5 || 0) +
            (datiBando2.vincoloInfratelBando2_3_11_Lotto5 || 0) +
            (datiBando2.vincoloInfratelBando2_3_12_Lotto5 || 0),
          "LOTTO 7":
            (datiBando2.vincoloInfratelBando2_3_1_Lotto7 || 0) +
            (datiBando2.vincoloInfratelBando2_3_2_Lotto7 || 0) +
            (datiBando2.vincoloInfratelBando2_3_3_Lotto7 || 0) +
            (datiBando2.vincoloInfratelBando2_3_4_Lotto7 || 0) +
            (datiBando2.vincoloInfratelBando2_3_5_Lotto7 || 0) +
            (datiBando2.vincoloInfratelBando2_3_6_Lotto7 || 0) +
            (datiBando2.vincoloInfratelBando2_3_7_Lotto7 || 0) +
            (datiBando2.vincoloInfratelBando2_3_8_Lotto7 || 0) +
            (datiBando2.vincoloInfratelBando2_3_9_Lotto7 || 0) +
            (datiBando2.vincoloInfratelBando2_3_10_Lotto7 || 0) +
            (datiBando2.vincoloInfratelBando2_3_11_Lotto7 || 0) +
            (datiBando2.vincoloInfratelBando2_3_12_Lotto7 || 0),
          "LOTTO 8":
            (datiBando2.vincoloInfratelBando2_3_1_Lotto8 || 0) +
            (datiBando2.vincoloInfratelBando2_3_2_Lotto8 || 0) +
            (datiBando2.vincoloInfratelBando2_3_3_Lotto8 || 0) +
            (datiBando2.vincoloInfratelBando2_3_4_Lotto8 || 0) +
            (datiBando2.vincoloInfratelBando2_3_5_Lotto8 || 0) +
            (datiBando2.vincoloInfratelBando2_3_6_Lotto8 || 0) +
            (datiBando2.vincoloInfratelBando2_3_7_Lotto8 || 0) +
            (datiBando2.vincoloInfratelBando2_3_8_Lotto8 || 0) +
            (datiBando2.vincoloInfratelBando2_3_9_Lotto8 || 0) +
            (datiBando2.vincoloInfratelBando2_3_10_Lotto8 || 0) +
            (datiBando2.vincoloInfratelBando2_3_11_Lotto8 || 0) +
            (datiBando2.vincoloInfratelBando2_3_12_Lotto8 || 0),
          TOTALE:
            (datiBando2.vincoloInfratelBando2_3_1 || 0) +
            (datiBando2.vincoloInfratelBando2_3_2 || 0) +
            (datiBando2.vincoloInfratelBando2_3_3 || 0) +
            (datiBando2.vincoloInfratelBando2_3_4 || 0) +
            (datiBando2.vincoloInfratelBando2_3_5 || 0) +
            (datiBando2.vincoloInfratelBando2_3_6 || 0) +
            (datiBando2.vincoloInfratelBando2_3_7 || 0) +
            (datiBando2.vincoloInfratelBando2_3_8 || 0) +
            (datiBando2.vincoloInfratelBando2_3_9 || 0) +
            (datiBando2.vincoloInfratelBando2_3_10 || 0) +
            (datiBando2.vincoloInfratelBando2_3_11 || 0) +
            (datiBando2.vincoloInfratelBando2_3_12 || 0),
        },
      ];

      const vincoloOFData = [
        {
          "": "2.1 TRIPLETTA NON COMPLETA",
          "LOTTO 1": datiBando2.vincoloOFBando2_2_1_Lotto1,
          "LOTTO 5": datiBando2.vincoloOFBando2_2_1_Lotto5,
          "LOTTO 7": datiBando2.vincoloOFBando2_2_1_Lotto7,
          "LOTTO 8": datiBando2.vincoloOFBando2_2_1_Lotto8,
          TOTALE: datiBando2.vincoloOFBando2_2_1,
        },
        {
          "": "2.2 OF NON VENDIBILE",
          "LOTTO 1": datiBando2.vincoloOFBando2_2_2_Lotto1,
          "LOTTO 5": datiBando2.vincoloOFBando2_2_2_Lotto5,
          "LOTTO 7": datiBando2.vincoloOFBando2_2_2_Lotto7,
          "LOTTO 8": datiBando2.vincoloOFBando2_2_2_Lotto8,
          TOTALE: datiBando2.vincoloOFBando2_2_2,
        },
        {
          "": "2.3 MANCA MOC OF",
          "LOTTO 1": datiBando2.vincoloOFBando2_2_3_Lotto1,
          "LOTTO 5": datiBando2.vincoloOFBando2_2_3_Lotto5,
          "LOTTO 7": datiBando2.vincoloOFBando2_2_3_Lotto7,
          "LOTTO 8": datiBando2.vincoloOFBando2_2_3_Lotto8,
          TOTALE: datiBando2.vincoloOFBando1_2_3
            ? datiBando2.vincoloOFBando1_2_3
            : 0,
        },
        {
          "": "2.4 ASSENZA SEGNALE OF",
          "LOTTO 1": datiBando2.vincoloOFBando2_2_4_Lotto1,
          "LOTTO 5": datiBando2.vincoloOFBando2_2_4_Lotto5,
          "LOTTO 7": datiBando2.vincoloOFBando2_2_4_Lotto7,
          "LOTTO 8": datiBando2.vincoloOFBando2_2_4_Lotto8,
          TOTALE: datiBando2.vincoloOFBando1_2_4
            ? datiBando2.vincoloOFBando1_2_4
            : 0,
        },
        {
          "": "2.5 PERMUTA PCN",
          "LOTTO 1": datiBando2.vincoloOFBando2_2_5_Lotto1,
          "LOTTO 5": datiBando2.vincoloOFBando2_2_5_Lotto5,
          "LOTTO 7": datiBando2.vincoloOFBando2_2_5_Lotto7,
          "LOTTO 8": datiBando2.vincoloOFBando2_2_5_Lotto8,
          TOTALE: datiBando2.vincoloOFBando1_2_5
            ? datiBando2.vincoloOFBando1_2_5
            : 0,
        },
        {
          "": "2.6 ALTRO (F1)",
          "LOTTO 1": datiBando2.vincoloOFBando2_2_6_Lotto1,
          "LOTTO 5": datiBando2.vincoloOFBando2_2_6_Lotto5,
          "LOTTO 7": datiBando2.vincoloOFBando2_2_6_Lotto7,
          "LOTTO 8": datiBando2.vincoloOFBando2_2_6_Lotto8,
          TOTALE: datiBando2.vincoloOFBando1_2_6
            ? datiBando2.vincoloOFBando1_2_6
            : 0,
        },
        {
          "": "2.7 OF NON ORDINATA",
          "LOTTO 1": datiBando2.vincoloOFBando2_2_7_Lotto1,
          "LOTTO 5": datiBando2.vincoloOFBando2_2_7_Lotto5,
          "LOTTO 7": datiBando2.vincoloOFBando2_2_7_Lotto7,
          "LOTTO 8": datiBando2.vincoloOFBando2_2_7_Lotto8,
          TOTALE: datiBando2.vincoloOFBando1_2_7
            ? datiBando2.vincoloOFBando1_2_7
            : 0,
        },
        {
          "": "2.8 OF INDIRIZZO KO",
          "LOTTO 1": datiBando2.vincoloOFBando2_2_8_Lotto1,
          "LOTTO 5": datiBando2.vincoloOFBando2_2_8_Lotto5,
          "LOTTO 7": datiBando2.vincoloOFBando2_2_8_Lotto7,
          "LOTTO 8": datiBando2.vincoloOFBando2_2_8_Lotto8,
          TOTALE: datiBando2.vincoloOFBando1_2_8
            ? datiBando2.vincoloOFBando1_2_8
            : 0,
        },
        {
          "": "2.9 ALTRO (F2)	",
          "LOTTO 1": datiBando2.vincoloOFBando2_2_9_Lotto1,
          "LOTTO 5": datiBando2.vincoloOFBando2_2_9_Lotto5,
          "LOTTO 7": datiBando2.vincoloOFBando2_2_9_Lotto7,
          "LOTTO 8": datiBando2.vincoloOFBando2_2_9_Lotto8,
          TOTALE: datiBando2.vincoloOFBando1_2_9
            ? datiBando2.vincoloOFBando1_2_9
            : 0,
        },

        {
          "": "TOTALI",
          "LOTTO 1":
            (datiBando2.vincoloOFBando2_2_1_Lotto1 || 0) +
            (datiBando2.vincoloOFBando2_2_2_Lotto1 || 0) +
            (datiBando2.vincoloOFBando2_2_3_Lotto1 || 0) +
            (datiBando2.vincoloOFBando2_2_4_Lotto1 || 0) +
            (datiBando2.vincoloOFBando2_2_5_Lotto1 || 0) +
            (datiBando2.vincoloOFBando2_2_6_Lotto1 || 0) +
            (datiBando2.vincoloOFBando2_2_7_Lotto1 || 0) +
            (datiBando2.vincoloOFBando2_2_8_Lotto1 || 0) +
            (datiBando2.vincoloOFBando2_2_9_Lotto1 || 0),
          "LOTTO 5":
            (datiBando2.vincoloOFBando2_2_1_Lotto5 || 0) +
            (datiBando2.vincoloOFBando2_2_2_Lotto5 || 0) +
            (datiBando2.vincoloOFBando2_2_3_Lotto5 || 0) +
            (datiBando2.vincoloOFBando2_2_4_Lotto5 || 0) +
            (datiBando2.vincoloOFBando2_2_5_Lotto5 || 0) +
            (datiBando2.vincoloOFBando2_2_6_Lotto5 || 0) +
            (datiBando2.vincoloOFBando2_2_7_Lotto5 || 0) +
            (datiBando2.vincoloOFBando2_2_8_Lotto5 || 0) +
            (datiBando2.vincoloOFBando2_2_9_Lotto5 || 0),
          "LOTTO 7":
            (datiBando2.vincoloOFBando2_2_1_Lotto7 || 0) +
            (datiBando2.vincoloOFBando2_2_2_Lotto7 || 0) +
            (datiBando2.vincoloOFBando2_2_3_Lotto7 || 0) +
            (datiBando2.vincoloOFBando2_2_4_Lotto7 || 0) +
            (datiBando2.vincoloOFBando2_2_5_Lotto7 || 0) +
            (datiBando2.vincoloOFBando2_2_6_Lotto7 || 0) +
            (datiBando2.vincoloOFBando2_2_7_Lotto7 || 0) +
            (datiBando2.vincoloOFBando2_2_8_Lotto7 || 0) +
            (datiBando2.vincoloOFBando2_2_9_Lotto7 || 0),
          "LOTTO 8":
            (datiBando2.vincoloOFBando2_2_1_Lotto8 || 0) +
            (datiBando2.vincoloOFBando2_2_2_Lotto8 || 0) +
            (datiBando2.vincoloOFBando2_2_3_Lotto8 || 0) +
            (datiBando2.vincoloOFBando2_2_4_Lotto8 || 0) +
            (datiBando2.vincoloOFBando2_2_5_Lotto8 || 0) +
            (datiBando2.vincoloOFBando2_2_6_Lotto8 || 0) +
            (datiBando2.vincoloOFBando2_2_7_Lotto8 || 0) +
            (datiBando2.vincoloOFBando2_2_8_Lotto8 || 0) +
            (datiBando2.vincoloOFBando2_2_9_Lotto8 || 0),
          TOTALE:
            (datiBando2.vincoloOFBando2_2_1 || 0) +
            (datiBando2.vincoloOFBando2_2_2 || 0) +
            (datiBando2.vincoloOFBando2_2_3 || 0) +
            (datiBando2.vincoloOFBando2_2_4 || 0) +
            (datiBando2.vincoloOFBando2_2_5 || 0) +
            (datiBando2.vincoloOFBando2_2_6 || 0) +
            (datiBando2.vincoloOFBando2_2_7 || 0) +
            (datiBando2.vincoloOFBando2_2_8 || 0) +
            (datiBando2.vincoloOFBando2_2_9 || 0),
        },
      ];

      const vincoloFibercopData = [
        {
          "": "1.1 MSAN",
          "LOTTO 1": datiBando2.vincoloFibercopBando2_1_1_Lotto1
            ? datiBando2.vincoloFibercopBando2_1_1_Lotto1
            : 0,
          "LOTTO 5": datiBando2.vincoloFibercopBando2_1_1_Lotto5
            ? datiBando2.vincoloFibercopBando2_1_1_Lotto5
            : 0,
          "LOTTO 7": datiBando2.vincoloFibercopBando2_1_1_Lotto7
            ? datiBando2.vincoloFibercopBando2_1_1_Lotto7
            : 0,
          "LOTTO 8": datiBando2.vincoloFibercopBando2_1_1_Lotto8
            ? datiBando2.vincoloFibercopBando2_1_1_Lotto8
            : 0,
          TOTALE: datiBando2.vincoloFibercopBando2_1_1
            ? datiBando2.vincoloFibercopBando2_1_1
            : 0,
        },
        {
          "": "1.2 OLT",
          "LOTTO 1": datiBando2.vincoloFibercopBando2_1_2_Lotto1
            ? datiBando2.vincoloFibercopBando2_1_2_Lotto1
            : 0,
          "LOTTO 5": datiBando2.vincoloFibercopBando2_1_2_Lotto5
            ? datiBando2.vincoloFibercopBando2_1_2_Lotto5
            : 0,
          "LOTTO 7": datiBando2.vincoloFibercopBando2_1_2_Lotto7
            ? datiBando2.vincoloFibercopBando2_1_2_Lotto7
            : 0,
          "LOTTO 8": datiBando2.vincoloFibercopBando2_1_2_Lotto8
            ? datiBando2.vincoloFibercopBando2_1_2_Lotto8
            : 0,
          TOTALE: datiBando2.vincoloFibercopBando2_1_2
            ? datiBando2.vincoloFibercopBando2_1_2
            : 0,
        },
        {
          "": "1.4 PERMESSO",
          "LOTTO 1": datiBando2.vincoloFibercopBando2_1_4_Lotto1
            ? datiBando2.vincoloFibercopBando2_1_4_Lotto1
            : 0,
          "LOTTO 5": datiBando2.vincoloFibercopBando2_1_4_Lotto5
            ? datiBando2.vincoloFibercopBando2_1_4_Lotto5
            : 0,
          "LOTTO 7": datiBando2.vincoloFibercopBando2_1_4_Lotto7
            ? datiBando2.vincoloFibercopBando2_1_4_Lotto7
            : 0,
          "LOTTO 8": datiBando2.vincoloFibercopBando2_1_4_Lotto8
            ? datiBando2.vincoloFibercopBando2_1_4_Lotto8
            : 0,
          TOTALE: datiBando2.vincoloFibercopBando2_1_4
            ? datiBando2.vincoloFibercopBando2_1_4
            : 0,
        },
        {
          "": "1.6 ASSENZA SEGNALE FC",
          "LOTTO 1": datiBando2.vincoloFibercopBando2_1_6_Lotto1
            ? datiBando2.vincoloFibercopBando2_1_6_Lotto1
            : 0,
          "LOTTO 5": datiBando2.vincoloFibercopBando2_1_6_Lotto5
            ? datiBando2.vincoloFibercopBando2_1_6_Lotto5
            : 0,
          "LOTTO 7": datiBando2.vincoloFibercopBando2_1_6_Lotto7
            ? datiBando2.vincoloFibercopBando2_1_6_Lotto7
            : 0,
          "LOTTO 8": datiBando2.vincoloFibercopBando2_1_6_Lotto8
            ? datiBando2.vincoloFibercopBando2_1_6_Lotto8
            : 0,
          TOTALE: datiBando2.vincoloFibercopBando2_1_6
            ? datiBando2.vincoloFibercopBando2_1_6
            : 0,
        },
        {
          "": "1.7 MANCA MOC FC",
          "LOTTO 1": datiBando2.vincoloFibercopBando2_1_7_Lotto1
            ? datiBando2.vincoloFibercopBando2_1_7_Lotto1
            : 0,
          "LOTTO 5": datiBando2.vincoloFibercopBando2_1_7_Lotto5
            ? datiBando2.vincoloFibercopBando2_1_7_Lotto5
            : 0,
          "LOTTO 7": datiBando2.vincoloFibercopBando2_1_7_Lotto7
            ? datiBando2.vincoloFibercopBando2_1_7_Lotto7
            : 0,
          "LOTTO 8": datiBando2.vincoloFibercopBando2_1_7_Lotto8
            ? datiBando2.vincoloFibercopBando2_1_7_Lotto8
            : 0,
          TOTALE: datiBando2.vincoloFibercopBando2_1_7
            ? datiBando2.vincoloFibercopBando2_1_7
            : 0,
        },

        {
          "": "TOTALI",
          "LOTTO 1":
            (datiBando2.vincoloFibercopBando2_1_1_Lotto1 || 0) +
            (datiBando2.vincoloFibercopBando2_1_2_Lotto1 || 0) +
            (datiBando2.vincoloFibercopBando2_1_4_Lotto1 || 0) +
            (datiBando2.vincoloFibercopBando2_1_6_Lotto1 || 0) +
            (datiBando2.vincoloFibercopBando2_1_7_Lotto1 || 0),
          "LOTTO 5":
            (datiBando2.vincoloFibercopBando2_1_1_Lotto5 || 0) +
            (datiBando2.vincoloFibercopBando2_1_2_Lotto5 || 0) +
            (datiBando2.vincoloFibercopBando2_1_4_Lotto5 || 0) +
            (datiBando2.vincoloFibercopBando2_1_6_Lotto5 || 0) +
            (datiBando2.vincoloFibercopBando2_1_7_Lotto5 || 0),
          "LOTTO 7":
            (datiBando2.vincoloFibercopBando2_1_1_Lotto7 || 0) +
            (datiBando2.vincoloFibercopBando2_1_2_Lotto7 || 0) +
            (datiBando2.vincoloFibercopBando2_1_4_Lotto7 || 0) +
            (datiBando2.vincoloFibercopBando2_1_6_Lotto7 || 0) +
            (datiBando2.vincoloFibercopBando2_1_7_Lotto7 || 0),
          "LOTTO 8":
            (datiBando2.vincoloFibercopBando2_1_1_Lotto8 || 0) +
            (datiBando2.vincoloFibercopBando2_1_2_Lotto8 || 0) +
            (datiBando2.vincoloFibercopBando2_1_4_Lotto8 || 0) +
            (datiBando2.vincoloFibercopBando2_1_6_Lotto8 || 0) +
            (datiBando2.vincoloFibercopBando2_1_7_Lotto8 || 0),
          TOTALE:
            (datiBando2.vincoloFibercopBando2_1_1 || 0) +
            (datiBando2.vincoloFibercopBando2_1_2 || 0) +
            (datiBando2.vincoloFibercopBando2_1_4 || 0) +
            (datiBando2.vincoloFibercopBando2_1_6 || 0) +
            (datiBando2.vincoloFibercopBando2_1_7 || 0),
        },
      ];

      const vincoloTimData = [
        {
          "": "1.3 ONEROSA",
          "LOTTO 1": datiBando2.vincoloTimBando2_1_3_Lotto1
            ? datiBando2.vincoloTimBando2_1_3_Lotto1
            : 0,
          "LOTTO 5": datiBando2.vincoloTimBando2_1_3_Lotto5
            ? datiBando2.vincoloTimBando2_1_3_Lotto5
            : 0,
          "LOTTO 7": datiBando2.vincoloTimBando2_1_3_Lotto7
            ? datiBando2.vincoloTimBando2_1_3_Lotto7
            : 0,
          "LOTTO 8": datiBando2.vincoloTimBando2_1_3_Lotto8
            ? datiBando2.vincoloTimBando2_1_3_Lotto8
            : 0,
          TOTALE: datiBando2.vincoloTimBando2_1_3
            ? datiBando2.vincoloTimBando2_1_3
            : 0,
        },
        {
          "": "1.5 MANCA MOC TIM",
          "LOTTO 1": datiBando2.vincoloTimBando2_1_5_Lotto1
            ? datiBando2.vincoloTimBando2_1_5_Lotto1
            : 0,
          "LOTTO 5": datiBando2.vincoloTimBando2_1_5_Lotto5
            ? datiBando2.vincoloTimBando2_1_5_Lotto5
            : 0,
          "LOTTO 7": datiBando2.vincoloTimBando2_1_5_Lotto7
            ? datiBando2.vincoloTimBando2_1_5_Lotto7
            : 0,
          "LOTTO 8": datiBando2.vincoloTimBando2_1_5_Lotto8
            ? datiBando2.vincoloTimBando2_1_5_Lotto8
            : 0,
          TOTALE: datiBando2.vincoloTimBando2_1_5
            ? datiBando2.vincoloTimBando2_1_5
            : 0,
        },
        {
          "": "1.8 ALTRO (F1)",
          "LOTTO 1": datiBando2.vincoloTimBando2_1_8_Lotto1
            ? datiBando2.vincoloTimBando2_1_8_Lotto1
            : 0,
          "LOTTO 5": datiBando2.vincoloTimBando2_1_8_Lotto5
            ? datiBando2.vincoloTimBando2_1_8_Lotto5
            : 0,
          "LOTTO 7": datiBando2.vincoloTimBando2_1_8_Lotto7
            ? datiBando2.vincoloTimBando2_1_8_Lotto7
            : 0,
          "LOTTO 8": datiBando2.vincoloTimBando2_1_8_Lotto8
            ? datiBando2.vincoloTimBando2_1_8_Lotto8
            : 0,
          TOTALE: datiBando2.vincoloTimBando2_1_8
            ? datiBando2.vincoloTimBando2_1_8
            : 0,
        },
        {
          "": "1.9 ALTRO (F2)",
          "LOTTO 1": datiBando2.vincoloTimBando2_1_9_Lotto1
            ? datiBando2.vincoloTimBando2_1_9_Lotto1
            : 0,
          "LOTTO 5": datiBando2.vincoloTimBando2_1_9_Lotto5
            ? datiBando2.vincoloTimBando2_1_9_Lotto5
            : 0,
          "LOTTO 7": datiBando2.vincoloTimBando2_1_9_Lotto7
            ? datiBando2.vincoloTimBando2_1_9_Lotto7
            : 0,
          "LOTTO 8": datiBando2.vincoloTimBando2_1_9_Lotto8
            ? datiBando2.vincoloTimBando2_1_9_Lotto8
            : 0,
          TOTALE: datiBando2.vincoloTimBando2_1_9
            ? datiBando2.vincoloTimBando2_1_9
            : 0,
        },
        {
          "": "1.10 VERIFICA OL TIM",
          "LOTTO 1": datiBando2.vincoloTimBando2_1_10_Lotto1
            ? datiBando2.vincoloTimBando2_1_10_Lotto1
            : 0,
          "LOTTO 5": datiBando2.vincoloTimBando2_1_10_Lotto5
            ? datiBando2.vincoloTimBando2_1_10_Lotto5
            : 0,
          "LOTTO 7": datiBando2.vincoloTimBando2_1_10_Lotto7
            ? datiBando2.vincoloTimBando2_1_10_Lotto7
            : 0,
          "LOTTO 8": datiBando2.vincoloTimBando2_1_10_Lotto8
            ? datiBando2.vincoloTimBando2_1_10_Lotto8
            : 0,
          TOTALE: datiBando2.vincoloTimBando2_1_10
            ? datiBando2.vincoloTimBando2_1_10
            : 0,
        },
        {
          "": "1.11 INFRASTRUTTURA CLIENTE ONEROSA",
          "LOTTO 1": datiBando2.vincoloTimBando2_1_11_Lotto1
            ? datiBando2.vincoloTimBando2_1_11_Lotto1
            : 0,
          "LOTTO 5": datiBando2.vincoloTimBando2_1_11_Lotto5
            ? datiBando2.vincoloTimBando2_1_11_Lotto5
            : 0,
          "LOTTO 7": datiBando2.vincoloTimBando2_1_11_Lotto7
            ? datiBando2.vincoloTimBando2_1_11_Lotto7
            : 0,
          "LOTTO 8": datiBando2.vincoloTimBando2_1_11_Lotto8
            ? datiBando2.vincoloTimBando2_1_11_Lotto8
            : 0,
          TOTALE: datiBando2.vincoloTimBando2_1_11
            ? datiBando2.vincoloTimBando2_1_11
            : 0,
        },

        {
          "": "TOTALI",
          "LOTTO 1":
            (datiBando2.vincoloTimBando2_1_3_Lotto1 || 0) +
            (datiBando2.vincoloTimBando2_1_5_Lotto1 || 0) +
            (datiBando2.vincoloTimBando2_1_8_Lotto1 || 0) +
            (datiBando2.vincoloTimBando2_1_9_Lotto1 || 0) +
            (datiBando2.vincoloTimBando2_1_10_Lotto1 || 0) +
            (datiBando2.vincoloTimBando2_1_11_Lotto1 || 0),
          "LOTTO 5":
            (datiBando2.vincoloTimBando2_1_3_Lotto5 || 0) +
            (datiBando2.vincoloTimBando2_1_5_Lotto5 || 0) +
            (datiBando2.vincoloTimBando2_1_8_Lotto5 || 0) +
            (datiBando2.vincoloTimBando2_1_9_Lotto5 || 0) +
            (datiBando2.vincoloTimBando2_1_10_Lotto5 || 0) +
            (datiBando2.vincoloTimBando2_1_11_Lotto5 || 0),
          "LOTTO 7":
            (datiBando2.vincoloTimBando2_1_3_Lotto7 || 0) +
            (datiBando2.vincoloTimBando2_1_5_Lotto7 || 0) +
            (datiBando2.vincoloTimBando2_1_8_Lotto7 || 0) +
            (datiBando2.vincoloTimBando2_1_9_Lotto7 || 0) +
            (datiBando2.vincoloTimBando2_1_10_Lotto7 || 0) +
            (datiBando2.vincoloTimBando2_1_11_Lotto7 || 0),
          "LOTTO 8":
            (datiBando2.vincoloTimBando2_1_3_Lotto8 || 0) +
            (datiBando2.vincoloTimBando2_1_5_Lotto8 || 0) +
            (datiBando2.vincoloTimBando2_1_8_Lotto8 || 0) +
            (datiBando2.vincoloTimBando2_1_9_Lotto8 || 0) +
            (datiBando2.vincoloTimBando2_1_10_Lotto8 || 0) +
            (datiBando2.vincoloTimBando2_1_11_Lotto8 || 0),
          TOTALE:
            (datiBando2.vincoloTimBando2_1_3 || 0) +
            (datiBando2.vincoloTimBando2_1_5 || 0) +
            (datiBando2.vincoloTimBando2_1_8 || 0) +
            (datiBando2.vincoloTimBando2_1_9 || 0) +
            (datiBando2.vincoloTimBando2_1_10 || 0) +
            (datiBando2.vincoloTimBando2_1_11 || 0),
        },
      ];

      const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(
        complessivoData,
        {
          header: [],
        },
      );

      // Imposto gli header
      bando2Headers.forEach((header, index) => {
        const cellRef = XLSX.utils.encode_cell({ r: 0, c: index });
        worksheet[cellRef] = { v: header };
      });

      const worksheet2: XLSX.WorkSheet = XLSX.utils.json_to_sheet(
        daAttivareData,
        {
          header: [],
        },
      );
      const worksheet3: XLSX.WorkSheet = XLSX.utils.json_to_sheet(
        fuoriPerimetroData,
        {
          header: [],
        },
      );
      const worksheet4: XLSX.WorkSheet = XLSX.utils.json_to_sheet(
        lavorabiliData,
        {
          header: [],
        },
      );
      const worksheet5: XLSX.WorkSheet = XLSX.utils.json_to_sheet(
        vincoloInfratelData,
        {
          header: [],
        },
      );
      const worksheet6: XLSX.WorkSheet = XLSX.utils.json_to_sheet(
        vincoloOFData,
        {
          header: [],
        },
      );
      const worksheet7: XLSX.WorkSheet = XLSX.utils.json_to_sheet(
        vincoloFibercopData,
        {
          header: [],
        },
      );
      const worksheet8: XLSX.WorkSheet = XLSX.utils.json_to_sheet(
        vincoloTimData,
        {
          header: [],
        },
      );
      // Imposto gli header per il secondo foglio
      bando2Headers.forEach((header, index) => {
        const cellRef = XLSX.utils.encode_cell({ r: 0, c: index });
        worksheet2[cellRef] = { v: header };
      });

      const workbook: XLSX.WorkBook = {
        Sheets: {
          COMPLESSIVO: worksheet,
          "DA ATTIVARE": worksheet2,
          "FUORI PERIMETRO": worksheet3,
          LAVORABILI: worksheet4,
          "VINCOLO INFRATEL": worksheet5,
          "VINCOLO OPENFIBER": worksheet6,
          "VINCOLO FIBERCOP": worksheet7,
          "VINCOLO TIM": worksheet8,
        },
        SheetNames: [
          "COMPLESSIVO",
          "DA ATTIVARE",
          "FUORI PERIMETRO",
          "LAVORABILE + PRONTO FIBRA",
          "VINCOLO INFRATEL",
          "VINCOLO OPENFIBER",
          "VINCOLO FIBERCOP",
          "VINCOLO TIM",
        ],
      };

      const excelBuffer: any = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      const blob = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      // Salva il file Excel
      saveAs(blob, filename);
    } catch (error) {
      this.logger.error("Errore durante la generazione del file Excel:", error);
      throw error;
    }
  }

  exportBando1OverallDaAttivareToExcel(
    datiBando1: any,
    pratiche: PraticaFlowdy2_Firestore[],
    filename: string,
  ): void {
    this.logger.info(
      "[EXCEL SERVICE] Export Bando 1 Overall DA ATTIVARE To Excel -  Pratiche: " +
        pratiche.length,
    );
    try {
      const riepilogoHeaders = ["", "LOTTO 6", "LOTTO 7", "TOTALE"];
      const dettaglioHeaders = [
        "CODICE INFRATEL",
        "STATO COMPLESSIVO",
        "DETTAGLIO DA ATTIVARE",
        "DETTAGLIO LAVORABILE + PRONTO FIBRA",
        "IMPRESA",
        "LOTTO",
        "REGIONE",
        "PROVINCIA",
        "COMUNE",
        "CODICE MIUR",
        "DENOMINAZIONE",
        "INDIRIZZO EFFETTIVO",
        "TIPO SEDE",
        "TIPO SEDE EFFETTIVA",
        "STATO PRONTOFIBRA",
        "DATA ATTIVAZIONE",
        "SDF PRINCIPALE",
        "SDF BK",
        "TGU FTTO PRINCIPALE",
        "TGU GIGA PRINCIPALE",
        "TGU FTTO BK",
        "TGU GIGA BK",
      ];

      const daAttivareData = [
        {
          "": "PRONTOFIBRA",
          "LOTTO 6": datiBando1.daAttivareBando1PFLotto6,
          "LOTTO 7": datiBando1.daAttivareBando1PFLotto7,
          TOTALE: datiBando1.daAttivareBando1PF,
        },
        {
          "": "LAVORABILE",
          "LOTTO 6": datiBando1.daAttivareBando1LavorabileLotto6,
          "LOTTO 7": datiBando1.daAttivareBando1LavorabileLotto7,
          TOTALE: datiBando1.daAttivareBando1Lavorabile,
        },
        {
          "": "VINCOLO INFRATEL",
          "LOTTO 6": datiBando1.daAttivareBando1VincoloInfratelLotto6,
          "LOTTO 7": datiBando1.daAttivareBando1VincoloInfratelLotto7,
          TOTALE: datiBando1.daAttivareBando1VincoloInfratel,
        },
        {
          "": "VINCOLO OF",
          "LOTTO 6": datiBando1.daAttivareBando1VincoloOFLotto6,
          "LOTTO 7": datiBando1.daAttivareBando1VincoloOFLotto7,
          TOTALE: datiBando1.daAttivareBando1VincoloOF,
        },
        {
          "": "VINCOLO FIBERCOP",
          "LOTTO 6": datiBando1.daAttivareBando1VincoloFibercopLotto6,
          "LOTTO 7": datiBando1.daAttivareBando1VincoloFibercopLotto7,
          TOTALE: datiBando1.daAttivareBando1VincoloFibercop,
        },
        {
          "": "VINCOLO TIM",
          "LOTTO 6": datiBando1.daAttivareBando1VincoloTimLotto6,
          "LOTTO 7": datiBando1.daAttivareBando1VincoloTimLotto7,
          TOTALE: datiBando1.daAttivareBando1VincoloTim,
        },
        {
          "": "TOTALI",
          "LOTTO 6":
            (datiBando1.daAttivareBando1PFLotto6 || 0) +
            (datiBando1.daAttivareBando1LavorabileLotto6 || 0) +
            (datiBando1.daAttivareBando1VincoloInfratelLotto6 || 0) +
            (datiBando1.daAttivareBando1VincoloOFLotto6 || 0) +
            (datiBando1.daAttivareBando1VincoloFibercopLotto6 || 0) +
            (datiBando1.daAttivareBando1VincoloTimLotto6 || 0),
          "LOTTO 7":
            (datiBando1.daAttivareBando1PFLotto7 || 0) +
            (datiBando1.daAttivareBando1LavorabileLotto7 || 0) +
            (datiBando1.daAttivareBando1VincoloInfratelLotto7 || 0) +
            (datiBando1.daAttivareBando1VincoloOFLotto7 || 0) +
            (datiBando1.daAttivareBando1VincoloFibercopLotto7 || 0) +
            (datiBando1.daAttivareBando1VincoloTimLotto7 || 0),
          TOTALE:
            (datiBando1.daAttivareBando1PF || 0) +
            (datiBando1.daAttivareBando1Lavorabile || 0) +
            (datiBando1.daAttivareBando1VincoloInfratel || 0) +
            (datiBando1.daAttivareBando1VincoloOF || 0) +
            (datiBando1.daAttivareBando1VincoloFibercop || 0) +
            (datiBando1.daAttivareBando1VincoloTim || 0),
        },
      ];

      const praticheFiltrate = this.filtraDaAttivarePratica(pratiche);

      const dettaglioData = praticheFiltrate.map((pratica) => ({
        "CODICE INFRATEL": pratica.cui,
        "STATO COMPLESSIVO": this.getStatoComplessivoPratica(pratica),
        "DETTAGLIO DA ATTIVARE": this.getStatoDaAttivarePratica(pratica),
        "DETTAGLIO LAVORABILE + PRONTO FIBRA":
          this.getStatoLavorabilePratica(pratica),
        IMPRESA: pratica.azienda,
        LOTTO: pratica.lotto,
        REGIONE: pratica.regione,
        PROVINCIA: pratica.provincia,
        COMUNE: pratica.comune,
        "CODICE MIUR": pratica.codiceMiur,
        DENOMINAZIONE: pratica.denominazione,
        "INDIRIZZO EFFETTIVO": pratica.indirizzo,
        "TIPO SEDE": pratica.tipoSede,
        "TIPO SEDE EFFETTIVA": pratica.tipoSedeEffettiva
          ? pratica.tipoSedeEffettiva
          : "",
        "STATO PRONTOFIBRA": pratica.statoPF,
        "SDF PRINCIPALE": pratica.sdfPrincipale,
        "DATA ATTIVAZIONE": pratica.dataConfermaTS
          ? this.utilService.formattaDataDaTimestampFirestore(
              pratica.dataConfermaTS,
            )
          : "",
        "SDF BK": pratica.sdfBackup,
        "TGU FTTO PRINCIPALE": pratica.tguFttoPrincipale,
        "TGU GIGA PRINCIPALE": pratica.tguGigaPrincipale,
        "TGU FTTO BK": pratica.tguFttoBackup,
        "TGU GIGA BK": pratica.tguGigaBackup,
      }));

      const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(
        daAttivareData,
        {
          header: [],
        },
      );

      // Imposto gli header
      riepilogoHeaders.forEach((header, index) => {
        const cellRef = XLSX.utils.encode_cell({ r: 0, c: index });
        worksheet[cellRef] = { v: header };
      });

      const worksheet2: XLSX.WorkSheet = XLSX.utils.json_to_sheet(
        dettaglioData,
        {
          header: [],
        },
      );

      // Imposto gli header per il secondo foglio
      dettaglioHeaders.forEach((header, index) => {
        const cellRef = XLSX.utils.encode_cell({ r: 0, c: index });
        worksheet2[cellRef] = { v: header };
      });

      const workbook: XLSX.WorkBook = {
        Sheets: {
          RIEPILOGO: worksheet,
          DETTAGLIO: worksheet2,
        },
        SheetNames: ["RIEPILOGO", "DETTAGLIO"],
      };

      const excelBuffer: any = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      const blob = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      // Salva il file Excel
      saveAs(blob, filename);
    } catch (error) {
      this.logger.error("Errore durante la generazione del file Excel:", error);
      throw error;
    }
  }

  exportBando1OverallComplessivoToExcel(
    datiBando1: any,
    pratiche: PraticaFlowdy2_Firestore[],
    filename: string,
  ): void {
    this.logger.info(
      "[EXCEL SERVICE] Export Bando 1 Overall COMPLESSIVO To Excel -  Pratiche: " +
        pratiche.length,
    );
    try {
      const riepilogoHeaders = ["", "LOTTO 6", "LOTTO 7", "TOTALE"];

      const dettaglioHeaders = [
        "CODICE INFRATEL",
        "STATO COMPLESSIVO",
        "IMPRESA",
        "LOTTO",
        "REGIONE",
        "PROVINCIA",
        "COMUNE",
        "CODICE MIUR",
        "DENOMINAZIONE",
        "INDIRIZZO EFFETTIVO",
        "TIPO SEDE",
        "TIPO SEDE EFFETTIVA",
        "STATO PRONTOFIBRA",
        "DATA ATTIVAZIONE",
        "SDF PRINCIPALE",
        "SDF BK",
        "TGU FTTO PRINCIPALE",
        "TGU GIGA PRINCIPALE",
        "TGU FTTO BK",
        "TGU GIGA BK",
      ];

      const complessivoData = [
        {
          "": "ATTIVATE",
          "LOTTO 6": datiBando1.complessivoBando1AttivateLotto6,
          "LOTTO 7": datiBando1.complessivoBando1AttivateLotto7,
          TOTALE: datiBando1.complessivoBando1Attivate,
        },
        {
          "": "DA ATTIVARE",
          "LOTTO 6": datiBando1.complessivoBando1DaAttivareLotto6,
          "LOTTO 7": datiBando1.complessivoBando1DaAttivareLotto7,
          TOTALE: datiBando1.complessivoBando1DaAttivare,
        },
        {
          "": "FUORI PERIMETRO",
          "LOTTO 6": datiBando1.complessivoBando1FuoriPerimetroLotto6,
          "LOTTO 7": datiBando1.complessivoBando1FuoriPerimetroLotto7,
          TOTALE: datiBando1.complessivoBando1FuoriPerimetro,
        },
        {
          "": "TOTALI",
          "LOTTO 6":
            (datiBando1.complessivoBando1AttivateLotto6 || 0) +
            (datiBando1.complessivoBando1DaAttivareLotto6 || 0) +
            (datiBando1.complessivoBando1FuoriPerimetroLotto6 || 0),
          "LOTTO 7":
            (datiBando1.complessivoBando1AttivateLotto7 || 0) +
            (datiBando1.complessivoBando1DaAttivareLotto7 || 0) +
            (datiBando1.complessivoBando1FuoriPerimetroLotto7 || 0),
          TOTALE:
            (datiBando1.complessivoBando1Attivate || 0) +
            (datiBando1.complessivoBando1DaAttivare || 0) +
            (datiBando1.complessivoBando1FuoriPerimetro || 0),
        },
      ];

      const dettaglioData = pratiche.map((pratica) => ({
        "CODICE INFRATEL": pratica.cui,
        "STATO COMPLESSIVO": this.getStatoComplessivoPratica(pratica),
        IMPRESA: pratica.azienda,
        LOTTO: pratica.lotto,
        REGIONE: pratica.regione,
        PROVINCIA: pratica.provincia,
        COMUNE: pratica.comune,
        "CODICE MIUR": pratica.codiceMiur,
        DENOMINAZIONE: pratica.denominazione,
        "INDIRIZZO EFFETTIVO": pratica.indirizzo,
        "TIPO SEDE": pratica.tipoSede,
        "TIPO SEDE EFFETTIVA": pratica.tipoSedeEffettiva
          ? pratica.tipoSedeEffettiva
          : "",
        "STATO PRONTOFIBRA": pratica.statoPF,
        "SDF PRINCIPALE": pratica.sdfPrincipale,
        "DATA ATTIVAZIONE": pratica.dataConfermaTS
          ? this.utilService.formattaDataDaTimestampFirestore(
              pratica.dataConfermaTS,
            )
          : "",
        "SDF BK": pratica.sdfBackup,
        "TGU FTTO PRINCIPALE": pratica.tguFttoPrincipale,
        "TGU GIGA PRINCIPALE": pratica.tguGigaPrincipale,
        "TGU FTTO BK": pratica.tguFttoBackup,
        "TGU GIGA BK": pratica.tguGigaBackup,
      }));

      const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(
        complessivoData,
        {
          header: [],
        },
      );

      // Imposto gli header
      riepilogoHeaders.forEach((header, index) => {
        const cellRef = XLSX.utils.encode_cell({ r: 0, c: index });
        worksheet[cellRef] = { v: header };
      });

      const worksheet2: XLSX.WorkSheet = XLSX.utils.json_to_sheet(
        dettaglioData,
        {
          header: [],
        },
      );

      // Imposto gli header per il secondo foglio
      dettaglioHeaders.forEach((header, index) => {
        const cellRef = XLSX.utils.encode_cell({ r: 0, c: index });
        worksheet2[cellRef] = { v: header };
      });

      const workbook: XLSX.WorkBook = {
        Sheets: {
          RIEPILOGO: worksheet,
          DETTAGLIO: worksheet2,
        },
        SheetNames: ["RIEPILOGO", "DETTAGLIO"],
      };

      const excelBuffer: any = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      const blob = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      // Salva il file Excel
      saveAs(blob, filename);
    } catch (error) {
      this.logger.error("Errore durante la generazione del file Excel:", error);
      throw error;
    }
  }

  exportBando2OverallComplessivoToExcel(
    datiBando2: any,
    pratiche: PraticaFlowdy2_Firestore[],
    filename: string,
  ): void {
    this.logger.info(
      "[EXCEL SERVICE] Export Bando 2 Overall COMPLESSIVO To Excel -  Pratiche: " +
        pratiche.length,
    );
    try {
      const bando2Headers = [
        "",
        "LOTTO 1",
        "LOTTO 5",
        "LOTTO 7",
        "LOTTO 8",
        "TOTALE",
      ];

      const dettaglioHeaders = [
        "CODICE INFRATEL",
        "STATO COMPLESSIVO",
        "IMPRESA",
        "LOTTO",
        "REGIONE",
        "PROVINCIA",
        "COMUNE",
        "CODICE MIUR",
        "DENOMINAZIONE",
        "INDIRIZZO EFFETTIVO",
        "TIPO SEDE",
        "TIPO SEDE EFFETTIVA",
        "STATO PRONTOFIBRA",
        "DATA ATTIVAZIONE",
        "SDF PRINCIPALE",
        "SDF BK",
        "TGU FTTO PRINCIPALE",
        "TGU GIGA PRINCIPALE",
        "TGU FTTO BK",
        "TGU GIGA BK",
      ];

      const complessivoData = [
        {
          "": "ATTIVATE",
          "LOTTO 1": datiBando2.complessivoBando2AttivateLotto1,
          "LOTTO 5": datiBando2.complessivoBando2AttivateLotto5,
          "LOTTO 7": datiBando2.complessivoBando2AttivateLotto7,
          "LOTTO 8": datiBando2.complessivoBando2AttivateLotto8,
          TOTALE: datiBando2.complessivoBando2Attivate,
        },
        {
          "": "DA ATTIVARE",
          "LOTTO 1": datiBando2.complessivoBando2DaAttivareLotto1,
          "LOTTO 5": datiBando2.complessivoBando2DaAttivareLotto5,
          "LOTTO 7": datiBando2.complessivoBando2DaAttivareLotto7,
          "LOTTO 8": datiBando2.complessivoBando2DaAttivareLotto8,
          TOTALE: datiBando2.complessivoBando2DaAttivare,
        },
        {
          "": "FUORI PERIMETRO",
          "LOTTO 1": datiBando2.complessivoBando2FuoriPerimetroLotto1,
          "LOTTO 5": datiBando2.complessivoBando2FuoriPerimetroLotto5,
          "LOTTO 7": datiBando2.complessivoBando2FuoriPerimetroLotto7,
          "LOTTO 8": datiBando2.complessivoBando2FuoriPerimetroLotto8,
          TOTALE: datiBando2.complessivoBando2FuoriPerimetro,
        },
        {
          "": "TOTALI",
          "LOTTO 1":
            (datiBando2.complessivoBando2AttivateLotto1 || 0) +
            (datiBando2.complessivoBando2DaAttivareLotto1 || 0) +
            (datiBando2.complessivoBando2FuoriPerimetroLotto1 || 0),
          "LOTTO 5":
            (datiBando2.complessivoBando2AttivateLotto5 || 0) +
            (datiBando2.complessivoBando2DaAttivareLotto5 || 0) +
            (datiBando2.complessivoBando2FuoriPerimetroLotto5 || 0),
          "LOTTO 7":
            (datiBando2.complessivoBando2AttivateLotto7 || 0) +
            (datiBando2.complessivoBando2DaAttivareLotto7 || 0) +
            (datiBando2.complessivoBando2FuoriPerimetroLotto7 || 0),
          "LOTTO 8":
            (datiBando2.complessivoBando2AttivateLotto8 || 0) +
            (datiBando2.complessivoBando2DaAttivareLotto8 || 0) +
            (datiBando2.complessivoBando2FuoriPerimetroLotto8 || 0),
          TOTALE:
            (datiBando2.complessivoBando2Attivate || 0) +
            (datiBando2.complessivoBando2DaAttivare || 0) +
            (datiBando2.complessivoBando2FuoriPerimetro || 0),
        },
      ];

      const dettaglioData = pratiche.map((pratica) => ({
        "CODICE INFRATEL": pratica.cui,
        "STATO COMPLESSIVO": this.getStatoComplessivoPratica(pratica),
        IMPRESA: pratica.azienda,
        LOTTO: pratica.lotto,
        REGIONE: pratica.regione,
        PROVINCIA: pratica.provincia,
        COMUNE: pratica.comune,
        "CODICE MIUR": pratica.codiceMiur,
        DENOMINAZIONE: pratica.denominazione,
        "INDIRIZZO EFFETTIVO": pratica.indirizzo,
        "TIPO SEDE": pratica.tipoSede,
        "TIPO SEDE EFFETTIVA": pratica.tipoSedeEffettiva
          ? pratica.tipoSedeEffettiva
          : "",
        "STATO PRONTOFIBRA": pratica.statoPF,
        "SDF PRINCIPALE": pratica.sdfPrincipale,
        "DATA ATTIVAZIONE": pratica.dataConfermaTS
          ? this.utilService.formattaDataDaTimestampFirestore(
              pratica.dataConfermaTS,
            )
          : "",
        "SDF BK": pratica.sdfBackup,
        "TGU FTTO PRINCIPALE": pratica.tguFttoPrincipale,
        "TGU GIGA PRINCIPALE": pratica.tguGigaPrincipale,
        "TGU FTTO BK": pratica.tguFttoBackup,
        "TGU GIGA BK": pratica.tguGigaBackup,
      }));

      const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(
        complessivoData,
        {
          header: [],
        },
      );

      // Imposto gli header
      bando2Headers.forEach((header, index) => {
        const cellRef = XLSX.utils.encode_cell({ r: 0, c: index });
        worksheet[cellRef] = { v: header };
      });

      const worksheet2: XLSX.WorkSheet = XLSX.utils.json_to_sheet(
        dettaglioData,
        {
          header: [],
        },
      );

      // Imposto gli header per il secondo foglio
      dettaglioHeaders.forEach((header, index) => {
        const cellRef = XLSX.utils.encode_cell({ r: 0, c: index });
        worksheet2[cellRef] = { v: header };
      });

      const workbook: XLSX.WorkBook = {
        Sheets: {
          RIEPILOGO: worksheet,
          DETTAGLIO: worksheet2,
        },
        SheetNames: ["RIEPILOGO", "DETTAGLIO"],
      };

      const excelBuffer: any = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      const blob = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      // Salva il file Excel
      saveAs(blob, filename);
    } catch (error) {
      this.logger.error("Errore durante la generazione del file Excel:", error);
      throw error;
    }
  }

  exportBando2OverallDaAttivareToExcel(
    datiBando2: any,
    pratiche: PraticaFlowdy2_Firestore[],
    filename: string,
  ): void {
    this.logger.info(
      "[EXCEL SERVICE] Export Bando 2 Overall DA ATTIVARE To Excel -  Pratiche: " +
        pratiche.length,
    );
    try {
      const bando2Headers = [
        "",
        "LOTTO 1",
        "LOTTO 5",
        "LOTTO 7",
        "LOTTO 8",
        "TOTALE",
      ];

      const dettaglioHeaders = [
        "CODICE INFRATEL",
        "STATO COMPLESSIVO",
        "DETTAGLIO DA ATTIVARE",
        "DETTAGLIO LAVORABILE + PRONTO FIBRA",
        "IMPRESA",
        "LOTTO",
        "REGIONE",
        "PROVINCIA",
        "COMUNE",
        "CODICE MIUR",
        "DENOMINAZIONE",
        "INDIRIZZO EFFETTIVO",
        "TIPO SEDE",
        "TIPO SEDE EFFETTIVA",
        "STATO PRONTOFIBRA",
        "DATA ATTIVAZIONE",
        "SDF PRINCIPALE",
        "SDF BK",
        "TGU FTTO PRINCIPALE",
        "TGU GIGA PRINCIPALE",
        "TGU FTTO BK",
        "TGU GIGA BK",
      ];

      const daAttivareData = [
        {
          "": "PRONTOFIBRA",
          "LOTTO 1": datiBando2.daAttivareBando2PFLotto1,
          "LOTTO 5": datiBando2.daAttivareBando2PFLotto5,
          "LOTTO 7": datiBando2.daAttivareBando2PFLotto7,
          "LOTTO 8": datiBando2.daAttivareBando2PFLotto8,
          TOTALE: datiBando2.daAttivareBando2PF,
        },
        {
          "": "LAVORABILE",
          "LOTTO 1": datiBando2.daAttivareBando2LavorabileLotto1,
          "LOTTO 5": datiBando2.daAttivareBando2LavorabileLotto5,
          "LOTTO 7": datiBando2.daAttivareBando2LavorabileLotto7,
          "LOTTO 8": datiBando2.daAttivareBando2LavorabileLotto8,
          TOTALE: datiBando2.daAttivareBando2Lavorabile,
        },
        {
          "": "VINCOLO INFRATEL",
          "LOTTO 1": datiBando2.daAttivareBando2VincoloInfratelLotto1,
          "LOTTO 5": datiBando2.daAttivareBando2VincoloInfratelLotto5,
          "LOTTO 7": datiBando2.daAttivareBando2VincoloInfratelLotto7,
          "LOTTO 8": datiBando2.daAttivareBando2VincoloInfratelLotto8,
          TOTALE: datiBando2.daAttivareBando2VincoloInfratel,
        },
        {
          "": "VINCOLO OF",
          "LOTTO 1": datiBando2.daAttivareBando2VincoloOFLotto1,
          "LOTTO 5": datiBando2.daAttivareBando2VincoloOFLotto5,
          "LOTTO 7": datiBando2.daAttivareBando2VincoloOFLotto7,
          "LOTTO 8": datiBando2.daAttivareBando2VincoloOFLotto8,
          TOTALE: datiBando2.daAttivareBando2VincoloOF,
        },
        {
          "": "VINCOLO FIBERCOP",
          "LOTTO 1": datiBando2.daAttivareBando2VincoloFibercopLotto1,
          "LOTTO 5": datiBando2.daAttivareBando2VincoloFibercopLotto5,
          "LOTTO 7": datiBando2.daAttivareBando2VincoloFibercopLotto7,
          "LOTTO 8": datiBando2.daAttivareBando2VincoloFibercopLotto8,
          TOTALE: datiBando2.daAttivareBando2VincoloFibercop,
        },
        {
          "": "VINCOLO TIM",
          "LOTTO 1": datiBando2.daAttivareBando2VincoloTimLotto1,
          "LOTTO 5": datiBando2.daAttivareBando2VincoloTimLotto5,
          "LOTTO 7": datiBando2.daAttivareBando2VincoloTimLotto7,
          "LOTTO 8": datiBando2.daAttivareBando2VincoloTimLotto8,
          TOTALE: datiBando2.daAttivareBando2VincoloTim,
        },
        {
          "": "TOTALI",
          "LOTTO 1":
            (datiBando2.daAttivareBando2PFLotto1 || 0) +
            (datiBando2.daAttivareBando2LavorabileLotto1 || 0) +
            (datiBando2.daAttivareBando2VincoloInfratelLotto1 || 0) +
            (datiBando2.daAttivareBando2VincoloOFLotto1 || 0) +
            (datiBando2.daAttivareBando2VincoloFibercopLotto1 || 0) +
            (datiBando2.daAttivareBando2VincoloTimLotto1 || 0),
          "LOTTO 5":
            (datiBando2.daAttivareBando2PFLotto5 || 0) +
            (datiBando2.daAttivareBando2LavorabileLotto5 || 0) +
            (datiBando2.daAttivareBando2VincoloInfratelLotto5 || 0) +
            (datiBando2.daAttivareBando2VincoloOFLotto5 || 0) +
            (datiBando2.daAttivareBando2VincoloFibercopLotto1 || 0) +
            (datiBando2.daAttivareBando2VincoloTimLotto5 || 0),
          "LOTTO 7":
            (datiBando2.daAttivareBando2PFLotto7 || 0) +
            (datiBando2.daAttivareBando2LavorabileLotto7 || 0) +
            (datiBando2.daAttivareBando2VincoloInfratelLotto7 || 0) +
            (datiBando2.daAttivareBando2VincoloOFLotto7 || 0) +
            (datiBando2.daAttivareBando2VincoloFibercopLotto7 || 0) +
            (datiBando2.daAttivareBando2VincoloTimLotto7 || 0),
          "LOTTO 8":
            (datiBando2.daAttivareBando2PFLotto8 || 0) +
            (datiBando2.daAttivareBando2LavorabileLotto8 || 0) +
            (datiBando2.daAttivareBando2VincoloInfratelLotto8 || 0) +
            (datiBando2.daAttivareBando2VincoloOFLotto8 || 0) +
            (datiBando2.daAttivareBando2VincoloFibercopLotto8 || 0) +
            (datiBando2.daAttivareBando2VincoloTimLotto8 || 0),
          TOTALE:
            (datiBando2.daAttivareBando2PF || 0) +
            (datiBando2.daAttivareBando2Lavorabile || 0) +
            (datiBando2.daAttivareBando2VincoloInfratel || 0) +
            (datiBando2.daAttivareBando2VincoloOF || 0) +
            (datiBando2.daAttivareBando2VincoloFibercop || 0) +
            (datiBando2.daAttivareBando2VincoloTim || 0),
        },
      ];

      const praticheFiltrate = this.filtraDaAttivarePratica(pratiche);

      const dettaglioData = praticheFiltrate.map((pratica) => ({
        "CODICE INFRATEL": pratica.cui,
        "STATO COMPLESSIVO": this.getStatoComplessivoPratica(pratica),
        "DETTAGLIO DA ATTIVARE": this.getStatoDaAttivarePratica(pratica),
        "DETTAGLIO LAVORABILE + PRONTO FIBRA":
          this.getStatoLavorabilePratica(pratica),
        IMPRESA: pratica.azienda,
        LOTTO: pratica.lotto,
        REGIONE: pratica.regione,
        PROVINCIA: pratica.provincia,
        COMUNE: pratica.comune,
        "CODICE MIUR": pratica.codiceMiur,
        DENOMINAZIONE: pratica.denominazione,
        "INDIRIZZO EFFETTIVO": pratica.indirizzo,
        "TIPO SEDE": pratica.tipoSede,
        "TIPO SEDE EFFETTIVA": pratica.tipoSedeEffettiva
          ? pratica.tipoSedeEffettiva
          : "",
        "STATO PRONTOFIBRA": pratica.statoPF,
        "SDF PRINCIPALE": pratica.sdfPrincipale,
        "DATA ATTIVAZIONE": pratica.dataConfermaTS
          ? this.utilService.formattaDataDaTimestampFirestore(
              pratica.dataConfermaTS,
            )
          : "",
        "SDF BK": pratica.sdfBackup,
        "TGU FTTO PRINCIPALE": pratica.tguFttoPrincipale,
        "TGU GIGA PRINCIPALE": pratica.tguGigaPrincipale,
        "TGU FTTO BK": pratica.tguFttoBackup,
        "TGU GIGA BK": pratica.tguGigaBackup,
      }));

      const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(
        daAttivareData,
        {
          header: [],
        },
      );

      // Imposto gli header
      bando2Headers.forEach((header, index) => {
        const cellRef = XLSX.utils.encode_cell({ r: 0, c: index });
        worksheet[cellRef] = { v: header };
      });

      const worksheet2: XLSX.WorkSheet = XLSX.utils.json_to_sheet(
        dettaglioData,
        {
          header: [],
        },
      );

      // Imposto gli header per il secondo foglio
      dettaglioHeaders.forEach((header, index) => {
        const cellRef = XLSX.utils.encode_cell({ r: 0, c: index });
        worksheet2[cellRef] = { v: header };
      });

      const workbook: XLSX.WorkBook = {
        Sheets: {
          RIEPILOGO: worksheet,
          DETTAGLIO: worksheet2,
        },
        SheetNames: ["RIEPILOGO", "DETTAGLIO"],
      };

      const excelBuffer: any = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      const blob = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      // Salva il file Excel
      saveAs(blob, filename);
    } catch (error) {
      this.logger.error("Errore durante la generazione del file Excel:", error);
      throw error;
    }
  }

  getStatoComplessivoPratica(pratica: PraticaFlowdy2_Firestore): string {
    if (pratica.statoPF && pratica.statoPF.length > 0) {
      if (
        pratica.statoPF == "SEDE ATTIVATA" ||
        pratica.statoPF == "ROUTER INSTALLATO"
      ) {
        return "ATTIVATA";
      } else if (pratica.statoPF == "KO" && pratica.vincoloTipologiaID == 4) {
        return "FUORI PERIMETRO";
      } else {
        if (pratica.statoPF == "IN ATTESA" && pratica.vincoloTipologiaID == 4) {
          return "FUORI PERIMETRO";
        } else {
          return "DA ATTIVARE";
        }
      }
    } else {
      if (pratica.vincoloTipologiaID == 4) {
        return "FUORI PERIMETRO";
      } else {
        return "DA ATTIVARE";
      }
    }
  }

  filtraDaAttivarePratica(
    pratiche: PraticaFlowdy2_Firestore[],
  ): PraticaFlowdy2_Firestore[] {
    const praticheFiltrate = pratiche.filter((pratica) => {
      if (pratica.statoPF && pratica.statoPF == "PRONTO") {
        return true;
      } else if (pratica.statoPF == "IN ATTESA" || !pratica.statoPF) {
        if (!pratica.vincoloTipologiaID) {
          return true;
        } else {
          if (pratica.vincoloTipologiaID == 3) {
            return true;
          } else if (pratica.vincoloTipologiaID == 2) {
            return true;
          } else if (pratica.vincoloTipologiaID == 1) {
            if (
              pratica.vincoloCategoriaCodice == "1.1" ||
              pratica.vincoloCategoriaCodice == "1.2" ||
              pratica.vincoloCategoriaCodice == "1.4" ||
              pratica.vincoloCategoriaCodice == "1.6" ||
              pratica.vincoloCategoriaCodice == "1.7"
            ) {
              return true;
            } else if (
              pratica.vincoloCategoriaCodice == "1.3" ||
              pratica.vincoloCategoriaCodice == "1.5" ||
              pratica.vincoloCategoriaCodice == "1.8" ||
              pratica.vincoloCategoriaCodice == "1.9" ||
              pratica.vincoloCategoriaCodice == "1.10" ||
              pratica.vincoloCategoriaCodice == "1.11"
            ) {
              return true;
            }
          }
        }
      } else if (pratica.statoPF && pratica.statoPF == "KO") {
        if (pratica.vincoloTipologiaID == 3) {
          return true;
        } else if (pratica.vincoloTipologiaID == 2) {
          return true;
        } else if (pratica.vincoloTipologiaID == 1) {
          if (
            pratica.vincoloCategoriaCodice == "1.1" ||
            pratica.vincoloCategoriaCodice == "1.2" ||
            pratica.vincoloCategoriaCodice == "1.4" ||
            pratica.vincoloCategoriaCodice == "1.6" ||
            pratica.vincoloCategoriaCodice == "1.7"
          ) {
            return true;
          } else if (
            pratica.vincoloCategoriaCodice == "1.3" ||
            pratica.vincoloCategoriaCodice == "1.5" ||
            pratica.vincoloCategoriaCodice == "1.8" ||
            pratica.vincoloCategoriaCodice == "1.9" ||
            pratica.vincoloCategoriaCodice == "1.10" ||
            pratica.vincoloCategoriaCodice == "1.11"
          ) {
            return true;
          }
        }
      }

      return false;
    });
    return praticheFiltrate;
  }

  getStatoDaAttivarePratica(pratica: PraticaFlowdy2_Firestore): string {
    if (pratica.bando === "BANDO 1") {
      if (pratica.statoPF && pratica.statoPF == "PRONTO") {
        return "PRONTO FIBRA";
      } else if (
        !pratica.vincoloTipologiaID &&
        (pratica.statoPF == "IN ATTESA" || !pratica.statoPF)
      ) {
        return "LAVORABILE";
      } else if (pratica.statoPF && pratica.statoPF == "KO") {
        if (pratica.vincoloTipologiaID == 3) {
          return "VINCOLO INFRATEL";
        } else if (pratica.vincoloTipologiaID == 2) {
          return "VINCOLO OF";
        } else if (pratica.vincoloTipologiaID == 1) {
          if (
            pratica.vincoloCategoriaCodice == "1.1" ||
            pratica.vincoloCategoriaCodice == "1.2" ||
            pratica.vincoloCategoriaCodice == "1.4" ||
            pratica.vincoloCategoriaCodice == "1.6" ||
            pratica.vincoloCategoriaCodice == "1.7"
          ) {
            return "VINCOLO FIBERCOP";
          } else if (
            pratica.vincoloCategoriaCodice == "1.3" ||
            pratica.vincoloCategoriaCodice == "1.5" ||
            pratica.vincoloCategoriaCodice == "1.8" ||
            pratica.vincoloCategoriaCodice == "1.9" ||
            pratica.vincoloCategoriaCodice == "1.10" ||
            pratica.vincoloCategoriaCodice == "1.11"
          ) {
            return "VINCOLO TIM";
          }
        }
      }
    } else if (pratica.bando === "BANDO 2") {
      if (pratica.statoPF && pratica.statoPF == "PRONTO") {
        return "PRONTO FIBRA";
      } else if (pratica.statoPF == "IN ATTESA" || !pratica.statoPF) {
        if (!pratica.vincoloTipologiaID) {
          return "LAVORABILE";
        } else {
          if (pratica.vincoloTipologiaID == 3) {
            return "VINCOLO INFRATEL";
          } else if (pratica.vincoloTipologiaID == 2) {
            return "VINCOLO OF";
          } else if (pratica.vincoloTipologiaID == 1) {
            if (
              pratica.vincoloCategoriaCodice == "1.1" ||
              pratica.vincoloCategoriaCodice == "1.2" ||
              pratica.vincoloCategoriaCodice == "1.4" ||
              pratica.vincoloCategoriaCodice == "1.6" ||
              pratica.vincoloCategoriaCodice == "1.7"
            ) {
              return "VINCOLO FIBERCOP";
            } else if (
              pratica.vincoloCategoriaCodice == "1.3" ||
              pratica.vincoloCategoriaCodice == "1.5" ||
              pratica.vincoloCategoriaCodice == "1.8" ||
              pratica.vincoloCategoriaCodice == "1.9" ||
              pratica.vincoloCategoriaCodice == "1.10" ||
              pratica.vincoloCategoriaCodice == "1.11"
            ) {
              return "VINCOLO TIM";
            }
          }
        }
      } else if (pratica.statoPF && pratica.statoPF == "KO") {
        if (pratica.vincoloTipologiaID == 3) {
          return "VINCOLO INFRATEL";
        } else if (pratica.vincoloTipologiaID == 2) {
          return "VINCOLO OF";
        } else if (pratica.vincoloTipologiaID == 1) {
          if (
            pratica.vincoloCategoriaCodice == "1.1" ||
            pratica.vincoloCategoriaCodice == "1.2" ||
            pratica.vincoloCategoriaCodice == "1.4" ||
            pratica.vincoloCategoriaCodice == "1.6" ||
            pratica.vincoloCategoriaCodice == "1.7"
          ) {
            return "VINCOLO FIBERCOP";
          } else if (
            pratica.vincoloCategoriaCodice == "1.3" ||
            pratica.vincoloCategoriaCodice == "1.5" ||
            pratica.vincoloCategoriaCodice == "1.8" ||
            pratica.vincoloCategoriaCodice == "1.9" ||
            pratica.vincoloCategoriaCodice == "1.10" ||
            pratica.vincoloCategoriaCodice == "1.11"
          ) {
            return "VINCOLO TIM";
          }
        }
      }
    }
    return "";
  }

  getStatoLavorabilePratica(pratica: PraticaFlowdy2_Firestore): string {
    if (pratica.bando === "BANDO 1") {
      if (pratica.statoPF && pratica.statoPF == "PRONTO") {
        return "TIM";
      } else if (
        (!pratica.statoPF || pratica.statoPF == "IN ATTESA") &&
        !pratica.vincoloTipologiaID
      ) {
        if (pratica.tipoSedeEffettiva == "Mandatoria A") {
          return "INFRATEL";
        } else if (
          pratica.tipoSedeEffettiva == "Mandatoria B" ||
          pratica.tipoSedeEffettiva == "Mandatoria D" ||
          pratica.tipoSedeEffettiva == "Aggiuntiva B" ||
          pratica.tipoSedeEffettiva == "Aggiuntiva D"
        ) {
          return "FIBERCOP";
        } else if (pratica.tipoSedeEffettiva == "Mandatoria C") {
          return "OF";
        }
      }
    } else if (pratica.bando === "BANDO 2") {
      if (pratica.statoPF && pratica.statoPF == "PRONTO") {
        return "TIM";
      } else if (
        (!pratica.statoPF || pratica.statoPF == "IN ATTESA") &&
        !pratica.vincoloTipologiaID
      ) {
        if (
          pratica.tipoSedeEffettiva == "B" ||
          pratica.tipoSedeEffettiva == "B*" ||
          pratica.tipoSedeEffettiva == "D"
        ) {
          return "FIBERCOP";
        } else if (pratica.tipoSedeEffettiva == "C") {
          return "OF";
        } else if (pratica.tipoSedeEffettiva == "A") {
          return "INFRATEL";
        }
      }
    }
    return "";
  }
}
